import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GoldSiverHeader from '../HomePage/GoldSiverHeader';
import { getProfile } from '../../store/auth';
import { getPokemons, adminGetAllPokemons, adminGivePokemon, adminGetAllUsers, adminGetUserPokemons, adminTakePokemon, adminEditUser, adminAddPokemonToDB, adminEditPokemonInDB, adminGetAllAttacks, adminUpdatePokemonAttacks, adminGetPokemonAttacks, adminSavePokemonAttack, adminGetPokemonEvolutions, adminSavePokemonEvolution } from '../../store/pokemon';
import { adminGetChatSettings, adminUpdateChatSettings } from '../../store/chatSettings';
import { adminGetPaypalSettings, adminUpdatePaypalSettings } from '../../store/paypalSettings';
import { adminGetMenuSettings, adminUpdateMenuSettings } from '../../store/menuSettings';
import { adminGetAdTags, updateAdTags } from '../../store/adTags';
import { adminGetBattleSettings, adminUpdateBattleSettings } from '../../store/battleSettings';
import { Container, Row, Col, Card, Alert, Form, Button, Table, Nav, Modal, Badge, Tabs, Tab } from 'react-bootstrap';
import { getImagePath } from '../../utils/imagePath';
import axios from '../../api/axios';
import { API_ENDPOINTS } from '../../api/endpoint';
import { toast } from 'react-toastify';

function Admin() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userData = useSelector(state => state.auth.user_data);
    const profile = useSelector(state => state.auth.profile);
    const profileLoading = useSelector(state => state.auth.profile_loading);
    const pokemons = useSelector(state => state.pokemon.pokemons) || [];
    const givePokemonLoading = useSelector(state => state.pokemon.admin_give_pokemon_loading);
    const adminUsers = useSelector(state => state.pokemon.admin_users) || [];
    const adminUsersLoading = useSelector(state => state.pokemon.admin_users_loading);
    const adminUserPokemons = useSelector(state => state.pokemon.admin_user_pokemons) || [];
    const adminUserPokemonsLoading = useSelector(state => state.pokemon.admin_user_pokemons_loading);
    
    // Also check localStorage for admin status
    const [localUserData, setLocalUserData] = React.useState(null);
    const [checkedAdmin, setCheckedAdmin] = React.useState(false);
    
    // Form state for giving Pokemon
    const [targetUsername, setTargetUsername] = useState('');
    const [selectedPokemonId, setSelectedPokemonId] = useState('');
    const [pokemonLevel, setPokemonLevel] = useState(5);
    const [addToTeam, setAddToTeam] = useState(false);
    
    // State for user management
    const [usersPage, setUsersPage] = useState(1);
    const [usersSearch, setUsersSearch] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [editingUser, setEditingUser] = useState(null);
    
    // State for Pokemon DB management
    const [editingPokemon, setEditingPokemon] = useState(null);
    const [newPokemonData, setNewPokemonData] = useState({
        naam: '',
        type1: '',
        type2: '',
        groei: '',
        attack_base: '',
        defence_base: '',
        speed_base: '',
        'spc.attack_base': '',
        'spc.defence_base': '',
        hp_base: '',
        aanval_1: '',
        aanval_2: '',
        aanval_3: '',
        aanval_4: '',
        ability: '',
        wereld: '',
        zeldzaamheid: ''
    });
    
    // Tab state for navigation
    const [activeTab, setActiveTab] = useState('dashboard');
    
    // State for Pokemon list/search
    const [pokemonSearch, setPokemonSearch] = useState('');
    const [pokemonPage, setPokemonPage] = useState(1);
    const pokemonsPerPage = 50;
    
    // State for chat settings
    const [chatDisplayMode, setChatDisplayMode] = useState('home_only');
    const chatSettings = useSelector(state => state.chatSettings.chatSettings);
    const chatSettingsLoading = useSelector(state => state.chatSettings.loading);
    
    // State for PayPal settings
    const [paypalEmail, setPaypalEmail] = useState('kfir@spo.co.il');
    const [paypalClientId, setPaypalClientId] = useState('');
    const [paypalClientSecret, setPaypalClientSecret] = useState('');
    const [paypalMode, setPaypalMode] = useState('sandbox');
    const [paypalCurrency, setPaypalCurrency] = useState('USD');
    const paypalSettings = useSelector(state => state.paypalSettings.paypalSettings);
    const paypalSettingsLoading = useSelector(state => state.paypalSettings.loading);
    
    // State for Menu Management
    const adminMenus = useSelector(state => state.menuSettings.adminMenus) || [];
    const adminMenusLoading = useSelector(state => state.menuSettings.adminMenusLoading);
    const adminMenusError = useSelector(state => state.menuSettings.adminMenusError);
    const menuUpdateLoading = useSelector(state => state.menuSettings.updateLoading);
    const [menuChanges, setMenuChanges] = useState({});
    const [newMenuItem, setNewMenuItem] = useState({ menu_key: '', menu_name: '', menu_route: '', menu_type: 'popup' });
    
    // State for Battle Settings
    const adminBattleSettings = useSelector(state => state.battleSettings.adminSettings) || {};
    const battleSettingsLoading = useSelector(state => state.battleSettings.adminLoading);
    const battleSettingsUpdateLoading = useSelector(state => state.battleSettings.updateLoading);
    const [showDefaultAttacks, setShowDefaultAttacks] = useState('0');
    const [defaultAttacksCount, setDefaultAttacksCount] = useState('4');
    
    // State for Ad Tags Management
    const adTags = useSelector(state => state.adTags.tags) || [];
    const adTagsLoading = useSelector(state => state.adTags.loading);
    const adTagsUpdateLoading = useSelector(state => state.adTags.updateLoading);
    const [newAdTag, setNewAdTag] = useState({ tag_name: '', tag_code: '', position: 'header_top', display_order: 0, is_active: 1 });
    const [battleTimerSeconds, setBattleTimerSeconds] = useState('180');
    const [healingTimeSeconds, setHealingTimeSeconds] = useState('180');
    const [enemyStrengthPercent, setEnemyStrengthPercent] = useState('100');
    const [playerStrengthPercent, setPlayerStrengthPercent] = useState('100');
    
    // State for PVP Management
    const [pvpSettings, setPvpSettings] = useState({});
    const [pvpSettingsLoading, setPvpSettingsLoading] = useState(false);
    const [pvpRewards, setPvpRewards] = useState([]);
    const [pvpRewardsLoading, setPvpRewardsLoading] = useState(false);
    const [pvpLeaderboard, setPvpLeaderboard] = useState([]);
    const [pvpAllStatistics, setPvpAllStatistics] = useState([]);
    const [pvpTotalSilverWon, setPvpTotalSilverWon] = useState(0);
    const [pvpLeaderboardLoading, setPvpLeaderboardLoading] = useState(false);
    const [pvpRewardDistribution, setPvpRewardDistribution] = useState({ total_reward: 1000, criteria: 'wins' });
    const [pvpDistributeLoading, setPvpDistributeLoading] = useState(false);
    
    // State for Database Tools
    const [initDbLoading, setInitDbLoading] = useState(false);
    const [resetGameLoading, setResetGameLoading] = useState(false);
    
    // State for Chat Management
    const [chatLogs, setChatLogs] = useState([]);
    const [chatLogsLoading, setChatLogsLoading] = useState(false);
    const [logsDaysBack, setLogsDaysBack] = useState(7);
    const [logsFilterUser, setLogsFilterUser] = useState('');
    const [chatReports, setChatReports] = useState([]);
    const [chatReportsLoading, setChatReportsLoading] = useState(false);
    const [mutedUsers, setMutedUsers] = useState([]);
    const [bannedUsers, setBannedUsers] = useState([]);
    const [usersWithWarnings, setUsersWithWarnings] = useState([]);
    const [chatRooms, setChatRooms] = useState([]);
    const [chatRoomsLoading, setChatRoomsLoading] = useState(false);
    const [showCreateRoomModal, setShowCreateRoomModal] = useState(false);
    const [newRoomName, setNewRoomName] = useState('');
    const [newRoomType, setNewRoomType] = useState('public');
    const [chatBroadcasts, setChatBroadcasts] = useState([]);
    const [broadcastsLoading, setBroadcastsLoading] = useState(false);
    
    // State for Pokemon Attacks Management
    const allAttacks = useSelector(state => state.pokemon.all_attacks) || [];
    const allAttacksLoading = useSelector(state => state.pokemon.all_attacks_loading);
    const updateAttacksLoading = useSelector(state => state.pokemon.update_attacks_loading);
    const pokemonAttacks = useSelector(state => state.pokemon.pokemon_attacks) || [];
    const pokemonAttacksLoading = useSelector(state => state.pokemon.pokemon_attacks_loading);
    const pokemonAttackTypes = useSelector(state => state.pokemon.pokemon_attack_types) || [];
    const saveAttackLoading = useSelector(state => state.pokemon.save_attack_loading);
    const [selectedPokemonForAttacks, setSelectedPokemonForAttacks] = useState(null);
    const [attacksModalOpen, setAttacksModalOpen] = useState(false);
    const [editedAttacks, setEditedAttacks] = useState({ 
        1: { attack_name: '', level_learned: 1, attack_type: '', attack_power: 0, attack_pp: 10, attack_accuracy: 100, attack_category: 'Physical' },
        2: { attack_name: '', level_learned: 1, attack_type: '', attack_power: 0, attack_pp: 10, attack_accuracy: 100, attack_category: 'Physical' },
        3: { attack_name: '', level_learned: 1, attack_type: '', attack_power: 0, attack_pp: 10, attack_accuracy: 100, attack_category: 'Physical' },
        4: { attack_name: '', level_learned: 1, attack_type: '', attack_power: 0, attack_pp: 10, attack_accuracy: 100, attack_category: 'Physical' }
    });
    const [attackSearch, setAttackSearch] = useState('');
    const [selectedAttackSlot, setSelectedAttackSlot] = useState(null); // Which attack button is being edited
    
    // State for Evolution Management
    const pokemonEvolutions = useSelector(state => state.pokemon.pokemon_evolutions) || [];
    const pokemonEvolutionsLoading = useSelector(state => state.pokemon.pokemon_evolutions_loading);
    const saveEvolutionLoading = useSelector(state => state.pokemon.save_evolution_loading);
    const [selectedPokemonForEvolutions, setSelectedPokemonForEvolutions] = useState(null);
    const [evolutionsModalOpen, setEvolutionsModalOpen] = useState(false);
    const [editingEvolution, setEditingEvolution] = useState(null);
    const [newEvolution, setNewEvolution] = useState({
        level: 16,
        nieuw_id: '',
        trade: 0,
        item: '',
        time: ''
    });
    const [evolutionPokemonSearch, setEvolutionPokemonSearch] = useState('');
    const [evolutionPokemonSearchResults, setEvolutionPokemonSearchResults] = useState([]);
    
    // State for Pokemon Import from PokemonDB.net
    const [importModalOpen, setImportModalOpen] = useState(false);
    const [importingPokemon, setImportingPokemon] = useState(null);
    const [importPreviewData, setImportPreviewData] = useState(null);
    const [importLoading, setImportLoading] = useState(false);
    const [importResults, setImportResults] = useState(null);
    
    // State for Maps Management
    const [maps, setMaps] = useState([]);
    const [mapsLoading, setMapsLoading] = useState(false);
    const [selectedMap, setSelectedMap] = useState(null);
    const [mapPoints, setMapPoints] = useState([]);
    const [mapPointsLoading, setMapPointsLoading] = useState(false);
    const [selectedPoint, setSelectedPoint] = useState(null);
    const [pointPokemon, setPointPokemon] = useState([]);
    const [pointPokemonLoading, setPointPokemonLoading] = useState(false);
    const [showMapModal, setShowMapModal] = useState(false);
    const [imageBrowserPath, setImageBrowserPath] = useState('');
    const [imageBrowserItems, setImageBrowserItems] = useState([]);
    const [imageBrowserLoading, setImageBrowserLoading] = useState(false);
    const [showPointModal, setShowPointModal] = useState(false);
    const [showPokemonModal, setShowPokemonModal] = useState(false);
    const [editingMap, setEditingMap] = useState(null);
    const [editingPoint, setEditingPoint] = useState(null);
    const [newMap, setNewMap] = useState({ name: '', image_path: '', city_id: null, city_name: '', order: 0, is_active: 1, required_level: 0 });
    const [newPoint, setNewPoint] = useState({ map_id: null, name: '', gebied: '', point_type: 'battle', target_url: '', x: 0, y: 0, width: 100, height: 100, tooltip: '', is_active: 1, required_level: 0, required_attacks: 0, next_point_id: null, trainer_id: null, silver_cost: null, trainer_image: null });
    const [newPokemonToPoint, setNewPokemonToPoint] = useState({ pokemon_wild_id: null, spawn_rate: 100, min_level: 1, max_level: 100 });
    const [editingPokemonId, setEditingPokemonId] = useState(null);
    const [allWildPokemon, setAllWildPokemon] = useState([]);
    const [wildPokemonLoading, setWildPokemonLoading] = useState(false);
    const [pokemonSearchInput, setPokemonSearchInput] = useState('');
    const [pokemonSearchResults, setPokemonSearchResults] = useState([]);
    const [showPokemonSearch, setShowPokemonSearch] = useState(false);
    const [bulkImportMode, setBulkImportMode] = useState(false);
    const [htmlImportMode, setHtmlImportMode] = useState(false);
    const [htmlInput, setHtmlInput] = useState('');
    const [bulkPokemonList, setBulkPokemonList] = useState([{ pokemon_wild_id: null, spawn_rate: 100, min_level: 1, max_level: 100, search: '' }]);
    const [csvFile, setCsvFile] = useState(null);
    const [activeSearchIndex, setActiveSearchIndex] = useState(null);
    const [uploadingImage, setUploadingImage] = useState(false);
    const [cities, setCities] = useState([]);
    const [citySearch, setCitySearch] = useState('');
    const [citySearchLoading, setCitySearchLoading] = useState(false);
    const [clickedMapPosition, setClickedMapPosition] = useState(null);
    const [mapContainerRef, setMapContainerRef] = useState(null);
    const [originalImageSize, setOriginalImageSize] = useState({ width: 0, height: 0 });
    const [mapImageSize, setMapImageSize] = useState({ width: 0, height: 0 });
    const [drawMode, setDrawMode] = useState(false);
    const [drawTool, setDrawTool] = useState('line'); // 'line', 'rectangle', 'grid'
    const [drawing, setDrawing] = useState(false);
    const [moveMode, setMoveMode] = useState(false); // Moving mode for dragging points
    const [draggingPoint, setDraggingPoint] = useState(null); // Currently dragging point
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 }); // Offset for dragging
    const [justFinishedDragging, setJustFinishedDragging] = useState(false); // Track if we just finished dragging to prevent onClick
    const [drawStart, setDrawStart] = useState(null);
    const [drawEnd, setDrawEnd] = useState(null);
    const [drawings, setDrawings] = useState([]);
    const [showGrid, setShowGrid] = useState(false);
    
    // State for Trainers Management
    const [trainers, setTrainers] = useState([]);
    const [trainersLoading, setTrainersLoading] = useState(false);
    const [selectedTrainer, setSelectedTrainer] = useState(null);
    const [showTrainerModal, setShowTrainerModal] = useState(false);
    const [editingTrainer, setEditingTrainer] = useState(null);
    const [newTrainer, setNewTrainer] = useState({
        trainer_name: '',
        trainer_image: '',
        silver_cost: 100,
        level_range_min: 1,
        level_range_max: 100,
        is_active: 1
    });
    const [trainerPokemon, setTrainerPokemon] = useState([]);
    const [trainerRewards, setTrainerRewards] = useState([]);
    const [showTrainerPokemonModal, setShowTrainerPokemonModal] = useState(false);
    const [showTrainerRewardModal, setShowTrainerRewardModal] = useState(false);
    const [newTrainerPokemon, setNewTrainerPokemon] = useState({
        wild_id: null,
        slot_position: 1,
        level_min: 5,
        level_max: 100
    });
    const [newTrainerReward, setNewTrainerReward] = useState({
        reward_type: 'item',
        reward_value: '',
        reward_quantity: 1,
        reward_name: '',
        chance_percentage: 2.0
    });
    const [gridSize, setGridSize] = useState(50); // pixels
    
    useEffect(() => {
        // Get userData from localStorage as well
        const storedUserData = localStorage.getItem('userData');
        if (storedUserData) {
            try {
                const parsed = JSON.parse(storedUserData);
                setLocalUserData(parsed);
                console.log('[ADMIN] Loaded from localStorage:', parsed);
            } catch (e) {
                console.error('Error parsing userData from localStorage:', e);
            }
        }
    }, []);
    
    // Handle resize to recalculate map image size
    useEffect(() => {
        if (!mapContainerRef || !originalImageSize.width || !originalImageSize.height) return;
        
        const handleResize = () => {
            if (mapContainerRef) {
                const containerRect = mapContainerRef.getBoundingClientRect();
                const containerAspect = containerRect.width / containerRect.height;
                const imageAspect = originalImageSize.width / originalImageSize.height;
                
                let displayedWidth, displayedHeight;
                if (imageAspect > containerAspect) {
                    displayedWidth = containerRect.width;
                    displayedHeight = containerRect.width / imageAspect;
                } else {
                    displayedHeight = containerRect.height;
                    displayedWidth = containerRect.height * imageAspect;
                }
                
                setMapImageSize({
                    width: displayedWidth,
                    height: displayedHeight
                });
            }
        };
        
        window.addEventListener('resize', handleResize);
        const timeoutId = setTimeout(handleResize, 100);
        
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(timeoutId);
        };
    }, [mapContainerRef, originalImageSize.width, originalImageSize.height, selectedMap?.id]);

    const [profileLoaded, setProfileLoaded] = useState(false);
    const [pokemonsLoaded, setPokemonsLoaded] = useState(false);
    
    // Check admin status from multiple sources
    const checkAdminStatus = () => {
        // Check userData from Redux first (updated by getProfile)
        if (userData && userData.admin !== undefined && userData.admin !== null) {
            const level = parseInt(userData.admin) || 0;
            if (level > 0) {
                console.log('[ADMIN] Found admin in userData:', level);
                return { isAdmin: true, level: level };
            }
        }
        // Check profile from Redux (backup)
        if (profile && profile.admin !== undefined && profile.admin !== null) {
            const level = parseInt(profile.admin) || 0;
            if (level > 0) {
                console.log('[ADMIN] Found admin in profile:', level);
                return { isAdmin: true, level: level };
            }
        }
        // Check localStorage (fallback)
        if (localUserData && localUserData.admin !== undefined && localUserData.admin !== null) {
            const level = parseInt(localUserData.admin) || 0;
            if (level > 0) {
                console.log('[ADMIN] Found admin in localStorage:', level);
                return { isAdmin: true, level: level };
            }
        }
        console.log('[ADMIN] No admin found - userData:', userData, 'profile:', profile, 'localUserData:', localUserData);
        return { isAdmin: false, level: 0 };
    };
    
    useEffect(() => {
        // Load profile if we have playerId - only once
        const playerId = userData?.playerId || localUserData?.playerId;
        if (playerId && !profileLoading && !profileLoaded) {
            console.log('[ADMIN] Loading profile for playerId:', playerId);
            dispatch(getProfile());
            setProfileLoaded(true);
        }
        
        // Load pokemons list - only once
        // For admin, use adminGetAllPokemons to get ALL pokemons (not filtered by wereld)
        if (!pokemonsLoaded && checkedAdmin) {
            const adminStatus = checkAdminStatus();
            if (adminStatus.isAdmin) {
                console.log('[ADMIN] Loading all pokemons (not filtered by wereld)');
                dispatch(adminGetAllPokemons());
            } else {
                dispatch(getPokemons());
            }
            setPokemonsLoaded(true);
        }
        
    }, [dispatch, userData, localUserData, profileLoading, profileLoaded, pokemonsLoaded, checkedAdmin]);

    const adminStatus = checkAdminStatus();
    const isAdmin = adminStatus.isAdmin;
    const adminLevel = adminStatus.level;
    
    // Load chat settings when opening chat settings tab
    useEffect(() => {
        if (activeTab === 'chat-settings' && isAdmin) {
            dispatch(adminGetChatSettings());
        }
    }, [dispatch, activeTab, isAdmin]);
    
    // Update local state when chat settings are loaded
    useEffect(() => {
        if (chatSettings && chatSettings.display_mode) {
            setChatDisplayMode(chatSettings.display_mode);
        }
    }, [chatSettings]);
    
    // Load menu settings when opening menu management tab
    useEffect(() => {
        if (activeTab === 'menu-management' && isAdmin) {
            dispatch(adminGetMenuSettings());
        }
    }, [dispatch, activeTab, isAdmin]);
    
    // Load battle settings when opening battle settings tab
    useEffect(() => {
        if (activeTab === 'battle-settings' && isAdmin) {
            dispatch(adminGetBattleSettings());
        }
        if (activeTab === 'pvp-management' && isAdmin) {
            loadPvpSettings();
            loadPvpRewards();
            loadPvpLeaderboard();
        }
        if (activeTab === 'ad-tags-management' && isAdmin) {
            dispatch(adminGetAdTags());
        }
    }, [dispatch, activeTab, isAdmin]);
    
    // Load maps when opening maps management tab
    useEffect(() => {
        if (activeTab === 'maps-management' && adminLevel >= 3) {
            loadMaps();
        }
        if (activeTab === 'trainers-management' && adminLevel >= 3) {
            loadTrainers();
        }
    }, [activeTab, adminLevel]);
    
    // Load map points when a map is selected
    useEffect(() => {
        if (selectedMap) {
            loadMapPoints(selectedMap.id);
        }
    }, [selectedMap]);
    
    // Load wild pokemon when Pokemon modal opens
    useEffect(() => {
        if ((showPokemonModal || showTrainerPokemonModal) && allWildPokemon.length === 0) {
            loadWildPokemon();
        }
    }, [showPokemonModal, showTrainerPokemonModal]);
    
    // Load point pokemon when a point is selected
    useEffect(() => {
        if (selectedPoint) {
            loadPointPokemon(selectedPoint.id);
        }
    }, [selectedPoint]);
    
    // Load trainers when point modal opens (for trainer selection)
    useEffect(() => {
        if (showPointModal && trainers.length === 0) {
            loadTrainers();
        }
    }, [showPointModal]);
    
    // Update local state when battle settings are loaded
    useEffect(() => {
        if (adminBattleSettings && Object.keys(adminBattleSettings).length > 0) {
            if (adminBattleSettings.show_default_attacks) {
                setShowDefaultAttacks(adminBattleSettings.show_default_attacks.value || '0');
            }
            if (adminBattleSettings.default_attacks_count) {
                setDefaultAttacksCount(adminBattleSettings.default_attacks_count.value || '4');
            }
            if (adminBattleSettings.battle_timer_seconds) {
                setBattleTimerSeconds(adminBattleSettings.battle_timer_seconds.value || '180');
            }
            if (adminBattleSettings.healing_time_seconds) {
                setHealingTimeSeconds(adminBattleSettings.healing_time_seconds.value || '180');
            }
            if (adminBattleSettings.enemy_strength_percent) {
                setEnemyStrengthPercent(adminBattleSettings.enemy_strength_percent.value || '100');
            }
            if (adminBattleSettings.player_strength_percent) {
                setPlayerStrengthPercent(adminBattleSettings.player_strength_percent.value || '100');
            }
        }
    }, [adminBattleSettings]);
    
    // Load attacks when opening attacks popup
    useEffect(() => {
        if (attacksModalOpen && allAttacks.length === 0) {
            dispatch(adminGetAllAttacks());
        }
    }, [dispatch, attacksModalOpen, allAttacks.length]);
    
    // Load Pokemon attacks when opening modal
    useEffect(() => {
        if (attacksModalOpen && selectedPokemonForAttacks) {
            dispatch(adminGetPokemonAttacks(selectedPokemonForAttacks.wild_id));
        }
    }, [dispatch, attacksModalOpen, selectedPokemonForAttacks]);
    
    // Load Pokemon evolutions when opening modal
    useEffect(() => {
        if (evolutionsModalOpen && selectedPokemonForEvolutions) {
            dispatch(adminGetPokemonEvolutions(selectedPokemonForEvolutions.wild_id));
        }
    }, [dispatch, evolutionsModalOpen, selectedPokemonForEvolutions]);
    
    // Handle opening attacks modal
    const handleOpenAttacksModal = (pokemon) => {
        setSelectedPokemonForAttacks(pokemon);
        setEditedAttacks({
            1: { attack_name: pokemon.aanval_1 || '', level_learned: 1, attack_type: pokemon.type1 || '', attack_power: 40, attack_pp: 35, attack_accuracy: 100, attack_category: 'Physical' },
            2: { attack_name: pokemon.aanval_2 || '', level_learned: 1, attack_type: pokemon.type1 || '', attack_power: 40, attack_pp: 35, attack_accuracy: 100, attack_category: 'Physical' },
            3: { attack_name: pokemon.aanval_3 || '', level_learned: 1, attack_type: pokemon.type1 || '', attack_power: 50, attack_pp: 25, attack_accuracy: 100, attack_category: 'Physical' },
            4: { attack_name: pokemon.aanval_4 || '', level_learned: 1, attack_type: pokemon.type1 || '', attack_power: 60, attack_pp: 20, attack_accuracy: 100, attack_category: 'Special' }
        });
        setSelectedAttackSlot(null);
        setAttacksModalOpen(true);
    };
    
    // Handle closing attacks modal
    const handleCloseAttacksModal = () => {
        setAttacksModalOpen(false);
        setSelectedPokemonForAttacks(null);
        setSelectedAttackSlot(null);
        setAttackSearch('');
    };
    
    // Handle clicking on an attack button
    const handleAttackButtonClick = (slotNum) => {
        setSelectedAttackSlot(slotNum);
    };
    
    // Handle saving single attack
    const handleSaveSingleAttack = async (slotNum) => {
        if (!selectedPokemonForAttacks) return;
        
        const attack = editedAttacks[slotNum];
        await dispatch(adminSavePokemonAttack({
            action: 'save',
            wild_id: selectedPokemonForAttacks.wild_id,
            attack_name: attack.attack_name || '', // Allow empty to clear
            attack_slot: slotNum,
            level_learned: attack.level_learned || 1,
            attack_type: attack.attack_type || '',
            attack_power: attack.attack_power || 0,
            attack_pp: attack.attack_pp || 10,
            attack_accuracy: attack.attack_accuracy || 100,
            attack_category: attack.attack_category || 'Physical',
            is_default: true
        }));
        
        setSelectedAttackSlot(null);
        dispatch(adminGetPokemonAttacks(selectedPokemonForAttacks.wild_id));
        dispatch(adminGetAllPokemons()); // Refresh the list
    };
    
    // Handle saving all attacks
    const handleSaveAllAttacks = async () => {
        if (!selectedPokemonForAttacks) return;
        
        const attacks = [1, 2, 3, 4].map(slot => ({
            ...editedAttacks[slot],
            attack_slot: slot
        }));
        
        await dispatch(adminSavePokemonAttack({
            action: 'save_all',
            wild_id: selectedPokemonForAttacks.wild_id,
            attacks
        }));
        
        handleCloseAttacksModal();
        dispatch(adminGetAllPokemons());
    };
    
    // Available attack types
    const attackTypes = pokemonAttackTypes.length > 0 ? pokemonAttackTypes : 
        ['Normal', 'Fire', 'Water', 'Electric', 'Grass', 'Ice', 'Fighting', 'Poison', 
         'Ground', 'Flying', 'Psychic', 'Bug', 'Rock', 'Ghost', 'Dragon', 'Dark', 'Steel', 'Fairy'];
    
    // Get type color for styling
    const getTypeColor = (type) => {
        const colors = {
            Normal: '#A8A878', Fire: '#F08030', Water: '#6890F0', Electric: '#F8D030',
            Grass: '#78C850', Ice: '#98D8D8', Fighting: '#C03028', Poison: '#A040A0',
            Ground: '#E0C068', Flying: '#A890F0', Psychic: '#F85888', Bug: '#A8B820',
            Rock: '#B8A038', Ghost: '#705898', Dragon: '#7038F8', Dark: '#705848',
            Steel: '#B8B8D0', Fairy: '#EE99AC'
        };
        return colors[type] || '#888888';
    };
    
    // Handle opening evolutions modal
    const handleOpenEvolutionsModal = (pokemon) => {
        setSelectedPokemonForEvolutions(pokemon);
        setNewEvolution({
            level: 16,
            nieuw_id: '',
            trade: 0,
            item: '',
            time: ''
        });
        setEditingEvolution(null);
        setEvolutionPokemonSearch('');
        setEvolutionPokemonSearchResults([]);
        setEvolutionsModalOpen(true);
    };
    
    // Handle closing evolutions modal
    const handleCloseEvolutionsModal = () => {
        setEvolutionsModalOpen(false);
        setSelectedPokemonForEvolutions(null);
        setEditingEvolution(null);
        setEvolutionPokemonSearch('');
        setEvolutionPokemonSearchResults([]);
    };
    
    // Handle opening import modal
    const handleOpenImportModal = async (pokemon) => {
        setImportingPokemon(pokemon);
        setImportPreviewData(null);
        setImportResults(null);
        setImportModalOpen(true);
        
        // Automatically fetch preview data
        setImportLoading(true);
        try {
            const pokemonName = pokemon.naam.toLowerCase().replace(/\s+/g, '-');
            const response = await axios.get(`/api/api/adminImportPokemonFromDB.php?pokemon_name=${encodeURIComponent(pokemonName)}`);
            if (response.data.success) {
                setImportPreviewData(response.data.data);
            } else {
                toast.error(response.data.error || 'Failed to fetch Pokemon data');
            }
        } catch (error) {
            console.error('Import preview error:', error);
            toast.error('Failed to fetch Pokemon data from PokemonDB');
        } finally {
            setImportLoading(false);
        }
    };
    
    // Handle closing import modal
    const handleCloseImportModal = () => {
        setImportModalOpen(false);
        setImportingPokemon(null);
        setImportPreviewData(null);
        setImportResults(null);
    };
    
    // Handle importing a completely new Pokemon from PokemonDB
    const handleImportNewPokemon = async (searchName) => {
        if (!searchName) return;
        
        const pokemonName = searchName.toLowerCase().replace(/\s+/g, '-');
        setImportLoading(true);
        
        try {
            // First, preview the data
            const previewResponse = await axios.get(`/api/api/adminImportPokemonFromDB.php?pokemon_name=${encodeURIComponent(pokemonName)}`);
            
            if (!previewResponse.data.success) {
                toast.error(previewResponse.data.error || 'Pokemon not found on PokemonDB');
                return;
            }
            
            // Show confirmation
            const confirmed = window.confirm(
                `Found "${previewResponse.data.data.name}" on PokemonDB!\n\n` +
                `Types: ${previewResponse.data.data.types?.join(', ') || 'Unknown'}\n` +
                `Base Stats Total: ${previewResponse.data.data.base_stats?.total || 0}\n` +
                `Level Moves: ${previewResponse.data.data.level_moves?.length || 0}\n` +
                `TM Moves: ${previewResponse.data.data.tm_moves?.length || 0}\n\n` +
                `Do you want to import this Pokemon to the database?`
            );
            
            if (!confirmed) return;
            
            // Create new Pokemon
            const importResponse = await axios.post('/api/api/adminImportPokemonFromDB.php', {
                pokemon_name: pokemonName,
                create_new: true,
                import_stats: true,
                import_moves: true
            });
            
            if (importResponse.data.success) {
                toast.success(`✅ ${searchName} imported successfully! (ID: ${importResponse.data.wild_id})`);
                // Refresh Pokemon list
                dispatch(adminGetAllPokemons());
                // Clear search
                setPokemonSearch('');
            } else {
                toast.error(importResponse.data.error || 'Import failed');
            }
        } catch (error) {
            console.error('Import new Pokemon error:', error);
            toast.error(error.response?.data?.error || 'Failed to import Pokemon');
        } finally {
            setImportLoading(false);
        }
    };
    
    // Handle import confirm
    const handleImportConfirm = async (importStats = true, importMoves = true) => {
        if (!importingPokemon || !importPreviewData) return;
        
        setImportLoading(true);
        try {
            const pokemonName = importingPokemon.naam.toLowerCase().replace(/\s+/g, '-');
            const response = await axios.post('/api/api/adminImportPokemonFromDB.php', {
                pokemon_name: pokemonName,
                wild_id: importingPokemon.wild_id,
                import_stats: importStats,
                import_moves: importMoves
            });
            
            if (response.data.success) {
                setImportResults(response.data.results);
                toast.success('Pokemon data imported successfully!');
                // Refresh Pokemon list
                dispatch(adminGetAllPokemons());
            } else {
                toast.error(response.data.error || 'Import failed');
            }
        } catch (error) {
            console.error('Import error:', error);
            toast.error('Failed to import Pokemon data');
        } finally {
            setImportLoading(false);
        }
    };
    
    // Handle editing evolution
    const handleEditEvolution = (evolution) => {
        setEditingEvolution(evolution);
        setNewEvolution({
            level: evolution.level,
            nieuw_id: evolution.nieuw_id,
            trade: evolution.trade || 0,
            item: evolution.item || '',
            time: evolution.time || ''
        });
        // Find evolved Pokemon name
        const evolvedPokemon = pokemons.find(p => p.wild_id === evolution.nieuw_id);
        if (evolvedPokemon) {
            setEvolutionPokemonSearch(evolvedPokemon.naam);
        }
    };
    
    // Handle saving evolution
    const handleSaveEvolution = async () => {
        if (!selectedPokemonForEvolutions) return;
        
        if (!newEvolution.level || newEvolution.level < 1 || newEvolution.level > 100) {
            toast.error('Level must be between 1 and 100');
            return;
        }
        
        if (!newEvolution.nieuw_id) {
            toast.error('Please select an evolved Pokemon');
            return;
        }
        
        await dispatch(adminSavePokemonEvolution({
            action: 'save',
            wild_id: selectedPokemonForEvolutions.wild_id,
            level: newEvolution.level,
            nieuw_id: newEvolution.nieuw_id,
            trade: newEvolution.trade,
            item: newEvolution.item,
            time: newEvolution.time,
            evolution_id: editingEvolution ? editingEvolution.id : 0
        }));
        
        dispatch(adminGetPokemonEvolutions(selectedPokemonForEvolutions.wild_id));
        setEditingEvolution(null);
        setNewEvolution({
            level: 16,
            nieuw_id: '',
            trade: 0,
            item: '',
            time: ''
        });
        setEvolutionPokemonSearch('');
        setEvolutionPokemonSearchResults([]);
    };
    
    // Handle deleting evolution
    const handleDeleteEvolution = async (evolution) => {
        if (!selectedPokemonForEvolutions) return;
        
        if (window.confirm(`Are you sure you want to delete this evolution at level ${evolution.level}?`)) {
            await dispatch(adminSavePokemonEvolution({
                action: 'delete',
                wild_id: selectedPokemonForEvolutions.wild_id,
                evolution_id: evolution.id
            }));
            
            dispatch(adminGetPokemonEvolutions(selectedPokemonForEvolutions.wild_id));
        }
    };
    
    // Handle evolution Pokemon search
    const handleEvolutionPokemonSearch = (searchTerm) => {
        setEvolutionPokemonSearch(searchTerm);
        if (searchTerm.length >= 2) {
            const results = pokemons.filter(p => 
                p.naam.toLowerCase().includes(searchTerm.toLowerCase()) ||
                p.wild_id.toString().includes(searchTerm)
            ).slice(0, 10);
            setEvolutionPokemonSearchResults(results);
        } else {
            setEvolutionPokemonSearchResults([]);
        }
    };
    
    // Handle selecting evolved Pokemon
    const handleSelectEvolvedPokemon = (pokemon) => {
        setNewEvolution({ ...newEvolution, nieuw_id: pokemon.wild_id });
        setEvolutionPokemonSearch(pokemon.naam);
        setEvolutionPokemonSearchResults([]);
    };

    useEffect(() => {
        // Only check once after profile is loaded
        if (checkedAdmin) {
            return; // Already checked, don't check again
        }
        
        // Wait for profile to load before checking
        if (profileLoading) {
            console.log('[ADMIN] Waiting for profile to load...');
            return; // Don't redirect while loading
        }
        
        // Only redirect if we have user data and user is not admin
        const hasUserData = userData || localUserData || profile;
        if (hasUserData) {
            setCheckedAdmin(true);
            // Wait a bit to ensure getProfile has completed
            const timeoutId = setTimeout(() => {
                const currentStatus = checkAdminStatus();
                console.log('[ADMIN] Final check - Status:', currentStatus);
                if (!currentStatus.isAdmin) {
                    console.log('[ADMIN] Redirecting to /home - Not admin. Status:', currentStatus);
                    navigate('/home', { replace: true });
                } else {
                    console.log('[ADMIN] Admin access granted. Level:', currentStatus.level);
                }
            }, 1000); // Wait 1 second for data to settle
            
            return () => clearTimeout(timeoutId);
        }
    }, [userData, localUserData, profile, profileLoading, checkedAdmin, navigate]);
    
    const handleGivePokemon = async (e) => {
        e.preventDefault();
        if (!targetUsername || !selectedPokemonId) {
            alert('Please fill in all required fields.');
            return;
        }
        
        try {
            await dispatch(adminGivePokemon({
                target_username: targetUsername,
                pokemon_id: parseInt(selectedPokemonId),
                level: parseInt(pokemonLevel),
                add_to_team: addToTeam
            })).unwrap();
            
            // Reset form
            setTargetUsername('');
            setSelectedPokemonId('');
            setPokemonLevel(5);
            setAddToTeam(false);
            
            // Refresh user pokemons if viewing
            if (selectedUser) {
                dispatch(adminGetUserPokemons(selectedUser));
            }
        } catch (error) {
            console.error('Failed to give Pokemon:', error);
        }
    };
    
    const handleLoadUserPokemons = async (username) => {
        setSelectedUser(username);
        dispatch(adminGetUserPokemons(username));
    };
    
    const handleTakePokemon = async (pokemonId) => {
        if (window.confirm('Are you sure you want to remove this Pokemon?')) {
            try {
                await dispatch(adminTakePokemon(pokemonId)).unwrap();
                // Refresh user pokemons
                if (selectedUser) {
                    dispatch(adminGetUserPokemons(selectedUser));
                }
            } catch (error) {
                console.error('Failed to take Pokemon:', error);
            }
        }
    };
    
    const handleEditUser = async (e) => {
        e.preventDefault();
        if (!editingUser) return;
        
        try {
            await dispatch(adminEditUser({
                username: editingUser.username,
                ...editingUser
            })).unwrap();
            
            setEditingUser(null);
            // Refresh users list
            dispatch(adminGetAllUsers({ page: usersPage, limit: 50, search: usersSearch }));
        } catch (error) {
            console.error('Failed to edit user:', error);
        }
    };
    
    const handleAddPokemonToDB = async (e) => {
        e.preventDefault();
        
        try {
            await dispatch(adminAddPokemonToDB(newPokemonData)).unwrap();
            // Reset form
            setNewPokemonData({
                naam: '',
                type1: '',
                type2: '',
                groei: '',
                attack_base: '',
                defence_base: '',
                speed_base: '',
                'spc.attack_base': '',
                'spc.defence_base': '',
                hp_base: '',
                aanval_1: '',
                aanval_2: '',
                aanval_3: '',
                aanval_4: '',
                ability: '',
                wereld: '',
                zeldzaamheid: ''
            });
            // Refresh pokemons list
            dispatch(getPokemons());
        } catch (error) {
            console.error('Failed to add Pokemon:', error);
        }
    };
    
    const handleEditPokemonInDB = async (e) => {
        e.preventDefault();
        if (!editingPokemon) return;
        
        try {
            await dispatch(adminEditPokemonInDB({
                wild_id: editingPokemon.wild_id,
                ...editingPokemon
            })).unwrap();
            
            setEditingPokemon(null);
            // Refresh pokemons list
            dispatch(getPokemons());
        } catch (error) {
            console.error('Failed to edit Pokemon:', error);
        }
    };
    
    const handleSearchUsers = () => {
        setUsersPage(1);
        dispatch(adminGetAllUsers({ page: 1, limit: 50, search: usersSearch }));
    };
    
    const handleUpdateChatSettings = async (e) => {
        e.preventDefault();
        try {
            await dispatch(adminUpdateChatSettings({ display_mode: chatDisplayMode })).unwrap();
        } catch (error) {
            console.error('Failed to update chat settings:', error);
        }
    };
    
    const handleUpdatePaypalSettings = async (e) => {
        e.preventDefault();
        try {
            await dispatch(adminUpdatePaypalSettings({
                email: paypalEmail,
                client_id: paypalClientId,
                client_secret: paypalClientSecret,
                mode: paypalMode,
                currency: paypalCurrency
            })).unwrap();
        } catch (error) {
            console.error('Failed to update PayPal settings:', error);
        }
    };
    
    // Handle Initialize Database
    const handleInitDatabase = async () => {
        setInitDbLoading(true);
        try {
            const response = await fetch('/api/api/adminInitDatabase.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include'
            });
            const data = await response.json();
            if (data.success) {
                alert(`Database initialized!\n\nCreated tables: ${data.created_tables.join(', ') || 'None'}\nExisting tables: ${data.existing_tables.join(', ') || 'None'}\nErrors: ${data.errors.length > 0 ? data.errors.map(e => e.table).join(', ') : 'None'}`);
            } else {
                alert('Error: ' + data.error);
            }
        } catch (error) {
            alert('Error initializing database: ' + error.message);
        } finally {
            setInitDbLoading(false);
        }
    };
    
    // Handle Reset Game
    // Ad Tags Management Functions
    const handleAddAdTag = async () => {
        if (!newAdTag.tag_name || !newAdTag.tag_code) {
            toast.error('Tag name and code are required');
            return;
        }
        
        try {
            await dispatch(updateAdTags({
                action: 'add',
                ...newAdTag
            })).unwrap();
            toast.success('Ad tag added successfully!');
            setNewAdTag({ tag_name: '', tag_code: '', position: 'header_top', display_order: 0, is_active: 1 });
            dispatch(adminGetAdTags());
        } catch (error) {
            toast.error(error || 'Failed to add ad tag');
        }
    };
    
    const handleUpdateAdTag = async (tag) => {
        try {
            await dispatch(updateAdTags({
                action: 'update',
                id: tag.id,
                tag_name: tag.tag_name,
                tag_code: tag.tag_code,
                position: tag.position,
                display_order: tag.display_order,
                is_active: tag.is_active
            })).unwrap();
            toast.success('Ad tag updated successfully!');
            dispatch(adminGetAdTags());
        } catch (error) {
            toast.error(error || 'Failed to update ad tag');
        }
    };
    
    const handleDeleteAdTag = async (id) => {
        if (!window.confirm('Are you sure you want to delete this ad tag?')) {
            return;
        }
        
        try {
            await dispatch(updateAdTags({
                action: 'delete',
                id: id
            })).unwrap();
            toast.success('Ad tag deleted successfully!');
            dispatch(adminGetAdTags());
        } catch (error) {
            toast.error(error || 'Failed to delete ad tag');
        }
    };
    
    // PVP Management Functions
    const loadPvpSettings = async () => {
        setPvpSettingsLoading(true);
        try {
            const response = await axios.get(API_ENDPOINTS.ADMIN_GET_PVP_SETTINGS);
            if (response.data && response.data.success) {
                setPvpSettings(response.data.settings || {});
            }
        } catch (error) {
            console.error('Error loading PVP settings:', error);
            toast.error('Failed to load PVP settings');
        } finally {
            setPvpSettingsLoading(false);
        }
    };
    
    const handleUpdatePvpSettings = async () => {
        setPvpSettingsLoading(true);
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_UPDATE_PVP_SETTINGS, {
                settings: pvpSettings
            });
            if (response.data && response.data.success) {
                toast.success('PVP settings updated successfully');
            } else {
                toast.error(response.data?.error || 'Failed to update PVP settings');
            }
        } catch (error) {
            console.error('Error updating PVP settings:', error);
            toast.error('Failed to update PVP settings');
        } finally {
            setPvpSettingsLoading(false);
        }
    };
    
    const loadPvpRewards = async () => {
        setPvpRewardsLoading(true);
        try {
            const response = await axios.get(API_ENDPOINTS.ADMIN_GET_PVP_REWARDS);
            if (response.data && response.data.success) {
                setPvpRewards(response.data.rewards || []);
            }
        } catch (error) {
            console.error('Error loading PVP rewards:', error);
            toast.error('Failed to load PVP rewards');
        } finally {
            setPvpRewardsLoading(false);
        }
    };
    
    const handleUpdatePvpRewards = async () => {
        setPvpRewardsLoading(true);
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_UPDATE_PVP_REWARDS, {
                rewards: pvpRewards
            });
            if (response.data && response.data.success) {
                toast.success('PVP rewards updated successfully');
            } else {
                toast.error(response.data?.error || 'Failed to update PVP rewards');
            }
        } catch (error) {
            console.error('Error updating PVP rewards:', error);
            toast.error('Failed to update PVP rewards');
        } finally {
            setPvpRewardsLoading(false);
        }
    };
    
    const loadPvpLeaderboard = async () => {
        setPvpLeaderboardLoading(true);
        try {
            const response = await axios.get(API_ENDPOINTS.ADMIN_GET_PVP_LEADERBOARD);
            if (response.data && response.data.success) {
                console.log('PVP Leaderboard loaded:', {
                    leaderboard_count: response.data.leaderboard?.length || 0,
                    all_statistics_count: response.data.all_statistics?.length || 0,
                    total_silver_won: response.data.total_silver_won || 0
                });
                setPvpLeaderboard(response.data.leaderboard || []);
                setPvpAllStatistics(response.data.all_statistics || []);
                setPvpTotalSilverWon(response.data.total_silver_won || 0);
                
                if ((response.data.leaderboard?.length || 0) === 0 && (response.data.all_statistics?.length || 0) === 0) {
                    toast.info('No PVP statistics found. Statistics will appear after players complete PVP battles.');
                }
            } else {
                console.error('Failed to load PVP leaderboard:', response.data);
                toast.error(response.data?.error || 'Failed to load PVP leaderboard');
                setPvpLeaderboard([]);
                setPvpAllStatistics([]);
            }
        } catch (error) {
            console.error('Error loading PVP leaderboard:', error);
            const errorMessage = error.response?.data?.error || error.message || 'Failed to load PVP leaderboard';
            console.error('Error details:', {
                message: errorMessage,
                response: error.response?.data,
                status: error.response?.status
            });
            toast.error(errorMessage);
            // Set empty arrays to prevent errors
            setPvpLeaderboard([]);
            setPvpAllStatistics([]);
        } finally {
            setPvpLeaderboardLoading(false);
        }
    };
    
    const handleDistributePvpRewards = async () => {
        if (!pvpRewardDistribution.total_reward || pvpRewardDistribution.total_reward <= 0) {
            toast.error('Total reward must be greater than 0');
            return;
        }
        
        setPvpDistributeLoading(true);
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_DISTRIBUTE_PVP_REWARDS, {
                total_reward: pvpRewardDistribution.total_reward,
                criteria: pvpRewardDistribution.criteria
            });
            if (response.data && response.data.success) {
                toast.success(response.data.message || 'Rewards distributed successfully');
                loadPvpLeaderboard(); // Reload leaderboard
            } else {
                toast.error(response.data?.error || 'Failed to distribute rewards');
            }
        } catch (error) {
            console.error('Error distributing PVP rewards:', error);
            toast.error('Failed to distribute rewards');
        } finally {
            setPvpDistributeLoading(false);
        }
    };
    
    const handleResetGame = async () => {
        const confirmed = window.confirm('⚠️ WARNING: This will DELETE ALL user data!\n\nA new Dev admin account will be created.\nUsername: Dev\nPassword: 123123\nEmail: kfir@spo.co.il\n\nAre you SURE you want to continue?');
        if (!confirmed) return;
        
        const doubleConfirm = window.prompt('Type "RESET" to confirm game reset:');
        if (doubleConfirm !== 'RESET') {
            alert('Reset cancelled.');
            return;
        }
        
        setResetGameLoading(true);
        try {
            const response = await fetch('/api/api/adminResetGame.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ confirm: 'RESET_GAME_CONFIRM' })
            });
            const data = await response.json();
            if (data.success) {
                alert(`Game reset successful!\n\nCleared tables: ${data.cleared_tables.join(', ')}\n\nNew Dev account created:\nUsername: ${data.dev_account.username}\nEmail: ${data.dev_account.email}\nAdmin Level: ${data.dev_account.admin_level}\n\nYou will be logged out.`);
                // Clear local storage and redirect to login
                localStorage.clear();
                window.location.href = '/login';
            } else {
                alert('Error: ' + data.error);
            }
        } catch (error) {
            alert('Error resetting game: ' + error.message);
        } finally {
            setResetGameLoading(false);
        }
    };
    
    // Chat Management Functions
    const loadChatLogs = async () => {
        setChatLogsLoading(true);
        try {
            const response = await axios.post(API_ENDPOINTS.CHAT_MODERATION, {
                action: 'get_admin_logs',
                user_id: logsFilterUser || 0,
                days_back: logsDaysBack
            });
            if (response.data.success) {
                setChatLogs(response.data.logs || []);
                toast.success(`Loaded ${response.data.logs?.length || 0} log entries`);
            }
        } catch (error) {
            toast.error(error.response?.data?.error || 'Failed to load logs');
        } finally {
            setChatLogsLoading(false);
        }
    };
    
    const loadChatReports = async () => {
        setChatReportsLoading(true);
        try {
            const response = await axios.post(API_ENDPOINTS.CHAT_MODERATION, {
                action: 'get_reports'
            });
            if (response.data.success) {
                setChatReports(response.data.reports || []);
                toast.success(`Loaded ${response.data.reports?.length || 0} reports`);
            }
        } catch (error) {
            toast.error(error.response?.data?.error || 'Failed to load reports');
        } finally {
            setChatReportsLoading(false);
        }
    };
    
    const loadMutedAndBannedUsers = async () => {
        try {
            // Load muted users
            const mutedResponse = await axios.post(API_ENDPOINTS.CHAT_MODERATION, {
                action: 'get_muted_users'
            });
            if (mutedResponse.data.success) {
                setMutedUsers(mutedResponse.data.users || []);
            }
            
            // Load banned users
            const bannedResponse = await axios.post(API_ENDPOINTS.CHAT_MODERATION, {
                action: 'get_banned_users'
            });
            if (bannedResponse.data.success) {
                setBannedUsers(bannedResponse.data.users || []);
            }
        } catch (error) {
            console.error('Failed to load muted/banned users:', error);
        }
    };
    
    const handleUnmuteFromAdmin = async (userId) => {
        if (!window.confirm(`Are you sure you want to unmute user ${userId}?`)) return;
        try {
            const response = await axios.post(API_ENDPOINTS.CHAT_MODERATION, {
                action: 'unmute_user',
                user_id: userId
            });
            if (response.data.success) {
                toast.success('User unmuted successfully');
                loadMutedAndBannedUsers();
            }
        } catch (error) {
            toast.error(error.response?.data?.error || 'Failed to unmute');
        }
    };
    
    const handleUnbanFromAdmin = async (userId) => {
        if (!window.confirm(`Are you sure you want to unban user ${userId}?`)) return;
        try {
            const response = await axios.post(API_ENDPOINTS.CHAT_MODERATION, {
                action: 'unban_user',
                user_id: userId,
                reason: 'Unbanned from admin panel'
            });
            if (response.data.success) {
                toast.success('User unbanned successfully');
                loadMutedAndBannedUsers();
            }
        } catch (error) {
            toast.error(error.response?.data?.error || 'Failed to unban');
        }
    };
    
    const loadRooms = async () => {
        setChatRoomsLoading(true);
        try {
            const response = await axios.post(API_ENDPOINTS.CHAT_MODERATION, {
                action: 'list_rooms'
            });
            if (response.data.success) {
                setChatRooms(response.data.rooms || []);
            }
        } catch (error) {
            toast.error(error.response?.data?.error || 'Failed to load rooms');
        } finally {
            setChatRoomsLoading(false);
        }
    };
    
    const loadBroadcasts = async () => {
        setBroadcastsLoading(true);
        try {
            const response = await axios.post(API_ENDPOINTS.CHAT_MODERATION, {
                action: 'list_broadcasts'
            });
            if (response.data.success) {
                setChatBroadcasts(response.data.broadcasts || []);
            }
        } catch (error) {
            toast.error(error.response?.data?.error || 'Failed to load broadcasts');
        } finally {
            setBroadcastsLoading(false);
        }
    };
    
    const handleCreateRoom = async () => {
        if (!newRoomName.trim()) {
            toast.error('Room name is required');
            return;
        }
        
        try {
            const response = await axios.post(API_ENDPOINTS.CHAT_MODERATION, {
                action: 'create_room',
                room_name: newRoomName,
                room_type: newRoomType
            });
            
            if (response.data.success) {
                toast.success(`Room created! URL: ${response.data.room_url}`);
                setShowCreateRoomModal(false);
                setNewRoomName('');
                setNewRoomType('public');
                loadRooms();
            }
        } catch (error) {
            toast.error(error.response?.data?.error || 'Failed to create room');
        }
    };
    
    const handleDeleteRoom = async (roomId) => {
        if (!window.confirm(`Are you sure you want to delete room ${roomId}? This cannot be undone.`)) return;
        
        try {
            const response = await axios.post(API_ENDPOINTS.CHAT_MODERATION, {
                action: 'delete_room',
                room_id: roomId
            });
            
            if (response.data.success) {
                toast.success('Room deleted successfully');
                loadRooms();
            }
        } catch (error) {
            toast.error(error.response?.data?.error || 'Failed to delete room');
        }
    };
    
    const handleSuspendRoom = async (roomId, isSuspended) => {
        try {
            const response = await axios.post(API_ENDPOINTS.CHAT_MODERATION, {
                action: isSuspended ? 'unsuspend_room' : 'suspend_room',
                room_id: roomId
            });
            
            if (response.data.success) {
                toast.success(response.data.message);
                loadRooms();
            }
        } catch (error) {
            toast.error(error.response?.data?.error || 'Failed to update room');
        }
    };
    
    const handleDeleteBroadcast = async (broadcastId) => {
        if (!window.confirm('Are you sure you want to delete this broadcast?')) return;
        
        try {
            const response = await axios.post(API_ENDPOINTS.CHAT_MODERATION, {
                action: 'delete_broadcast',
                broadcast_id: broadcastId
            });
            
            if (response.data.success) {
                toast.success('Broadcast deleted successfully');
                loadBroadcasts();
            }
        } catch (error) {
            toast.error(error.response?.data?.error || 'Failed to delete broadcast');
        }
    };
    
    // Load muted/banned users when tab is opened
    useEffect(() => {
        if (activeTab === 'chat-management') {
            loadMutedAndBannedUsers();
            loadRooms();
            loadBroadcasts();
        }
    }, [activeTab]);
    
    // State for Pokemon Market Management
    const [pendingApprovals, setPendingApprovals] = useState([]);
    const [approvalsLoading, setApprovalsLoading] = useState(false);
    const [marketLogs, setMarketLogs] = useState([]);
    const [logsLoading, setLogsLoading] = useState(false);
    const [logsActionType, setLogsActionType] = useState('');
    const [logsSaleId, setLogsSaleId] = useState('');
    const [cancelSaleModal, setCancelSaleModal] = useState({ show: false, sale: null, reason: '' });
    const [buyPriceChangeModal, setBuyPriceChangeModal] = useState({ show: false, sale: null, newPrice: '', reason: '' });
    const [activeSales, setActiveSales] = useState([]);
    const [activeSalesLoading, setActiveSalesLoading] = useState(false);
    
    // Load pending approvals when market management tab is opened
    useEffect(() => {
        if (activeTab === 'market-management' && adminLevel >= 2) {
            loadPendingApprovals();
            loadMarketLogs();
            loadActiveSales();
        }
    }, [activeTab, adminLevel]);
    
    const loadActiveSales = async () => {
        setActiveSalesLoading(true);
        try {
            const response = await axios.get(API_ENDPOINTS.GET_MARKET_LISTINGS);
            if (response.data && response.data.success) {
                setActiveSales(response.data.listings || []);
            }
        } catch (error) {
            console.error('Error loading active sales:', error);
            toast.error('Failed to load active sales');
        } finally {
            setActiveSalesLoading(false);
        }
    };
    
    const loadPendingApprovals = async () => {
        setApprovalsLoading(true);
        try {
            const response = await axios.get(API_ENDPOINTS.ADMIN_GET_PENDING_APPROVALS);
            if (response.data && response.data.success) {
                setPendingApprovals(response.data.approvals || []);
            }
        } catch (error) {
            console.error('Error loading pending approvals:', error);
            toast.error('Failed to load pending approvals');
        } finally {
            setApprovalsLoading(false);
        }
    };
    
    const handleApproveGoldSale = async (saleId, action, reason = '') => {
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_APPROVE_GOLD_SALE, {
                sale_id: saleId,
                action: action,
                reason: reason
            });
            if (response.data && response.data.success) {
                toast.success(response.data.message || `Gold sale ${action}d successfully`);
                loadPendingApprovals();
                loadMarketLogs();
            } else {
                toast.error(response.data.error || `Failed to ${action} gold sale`);
            }
        } catch (error) {
            console.error(`Error ${action}ing gold sale:`, error);
            toast.error(error.response?.data?.error || `Failed to ${action} gold sale`);
        }
    };
    
    const loadMarketLogs = async () => {
        setLogsLoading(true);
        try {
            const params = new URLSearchParams();
            if (logsActionType) params.append('action_type', logsActionType);
            if (logsSaleId) params.append('sale_id', logsSaleId);
            params.append('limit', '100');
            
            const response = await axios.get(`${API_ENDPOINTS.ADMIN_GET_MARKET_LOGS}?${params}`);
            if (response.data && response.data.success) {
                setMarketLogs(response.data.logs || []);
            }
        } catch (error) {
            console.error('Error loading market logs:', error);
            toast.error('Failed to load market logs');
        } finally {
            setLogsLoading(false);
        }
    };
    
    // Maps Management Functions
    const loadMaps = async () => {
        setMapsLoading(true);
        try {
            // Use admin endpoint that shows all maps regardless of level
            const response = await axios.get(API_ENDPOINTS.ADMIN_GET_MAPS);
            if (response.data && response.data.success) {
                setMaps(response.data.maps || []);
            }
        } catch (error) {
            console.error('Error loading maps:', error);
            toast.error('Failed to load maps');
        } finally {
            setMapsLoading(false);
        }
    };
    
    const loadMapPoints = async (mapId) => {
        setMapPointsLoading(true);
        try {
            // Use admin endpoint to get all points without filtering by is_active or required_level
            const response = await axios.get(`${API_ENDPOINTS.ADMIN_GET_MAP_POINTS}?map_id=${mapId}`);
            if (response.data && response.data.success) {
                setMapPoints(response.data.points || []);
            }
        } catch (error) {
            console.error('Error loading map points:', error);
            toast.error('Failed to load map points');
        } finally {
            setMapPointsLoading(false);
        }
    };
    
    // Trainers Management Functions
    const loadTrainers = async () => {
        setTrainersLoading(true);
        try {
            const response = await axios.get(API_ENDPOINTS.ADMIN_GET_TRAINERS);
            if (response.data && response.data.success) {
                setTrainers(response.data.trainers || []);
            }
        } catch (error) {
            console.error('Error loading trainers:', error);
            toast.error('Failed to load trainers');
        } finally {
            setTrainersLoading(false);
        }
    };
    
    const handleCreateTrainer = async (e) => {
        e.preventDefault();
        try {
            const trainerData = {
                ...newTrainer,
                pokemon: trainerPokemon,
                rewards: trainerRewards
            };
            const response = await axios.post(API_ENDPOINTS.ADMIN_CREATE_TRAINER, trainerData);
            if (response.data && response.data.success) {
                toast.success('Trainer created successfully');
                setShowTrainerModal(false);
                setNewTrainer({
                    trainer_name: '',
                    trainer_image: '',
                    silver_cost: 100,
                    level_range_min: 1,
                    level_range_max: 100,
                    is_active: 1
                });
                setTrainerPokemon([]);
                setTrainerRewards([]);
                loadTrainers();
            }
        } catch (error) {
            console.error('Error creating trainer:', error);
            toast.error(error.response?.data?.error || 'Failed to create trainer');
        }
    };
    
    const handleUpdateTrainer = async (e) => {
        e.preventDefault();
        if (!editingTrainer) return;
        try {
            const response = await axios.put(API_ENDPOINTS.ADMIN_UPDATE_TRAINER, editingTrainer);
            if (response.data && response.data.success) {
                toast.success('Trainer updated successfully');
                setShowTrainerModal(false);
                setEditingTrainer(null);
                loadTrainers();
            }
        } catch (error) {
            console.error('Error updating trainer:', error);
            toast.error(error.response?.data?.error || 'Failed to update trainer');
        }
    };
    
    const handleDeleteTrainer = async (trainerId) => {
        if (!window.confirm('Are you sure you want to delete this trainer?')) return;
        try {
            const response = await axios.delete(`${API_ENDPOINTS.ADMIN_DELETE_TRAINER}?id=${trainerId}`);
            if (response.data && response.data.success) {
                toast.success('Trainer deleted successfully');
                loadTrainers();
            }
        } catch (error) {
            console.error('Error deleting trainer:', error);
            toast.error(error.response?.data?.error || 'Failed to delete trainer');
        }
    };
    
    const handleAddTrainerPokemon = async () => {
        if (!selectedTrainer || !newTrainerPokemon.wild_id) return;
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_ADD_TRAINER_POKEMON, {
                trainer_id: selectedTrainer.id,
                ...newTrainerPokemon
            });
            if (response.data && response.data.success) {
                toast.success('Pokemon added to trainer');
                setShowTrainerPokemonModal(false);
                setNewTrainerPokemon({
                    wild_id: null,
                    slot_position: 1,
                    level_min: 5,
                    level_max: 100
                });
                loadTrainers();
            }
        } catch (error) {
            console.error('Error adding pokemon:', error);
            toast.error(error.response?.data?.error || 'Failed to add pokemon');
        }
    };
    
    const handleDeleteTrainerPokemon = async (pokemonId) => {
        if (!window.confirm('Are you sure you want to remove this pokemon from the trainer?')) return;
        try {
            const response = await axios.delete(`${API_ENDPOINTS.ADMIN_DELETE_TRAINER_POKEMON}?id=${pokemonId}`);
            if (response.data && response.data.success) {
                toast.success('Pokemon removed from trainer');
                loadTrainers();
            }
        } catch (error) {
            console.error('Error deleting pokemon:', error);
            toast.error(error.response?.data?.error || 'Failed to remove pokemon');
        }
    };
    
    const handleAddTrainerReward = async () => {
        if (!selectedTrainer || !newTrainerReward.reward_value || !newTrainerReward.reward_name) return;
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_ADD_TRAINER_REWARD, {
                trainer_id: selectedTrainer.id,
                ...newTrainerReward
            });
            if (response.data && response.data.success) {
                toast.success('Reward added to trainer');
                setShowTrainerRewardModal(false);
                setNewTrainerReward({
                    reward_type: 'item',
                    reward_value: '',
                    reward_quantity: 1,
                    reward_name: '',
                    chance_percentage: 2.0
                });
                loadTrainers();
            }
        } catch (error) {
            console.error('Error adding reward:', error);
            toast.error(error.response?.data?.error || 'Failed to add reward');
        }
    };
    
    const handleDeleteTrainerReward = async (rewardId) => {
        if (!window.confirm('Are you sure you want to delete this reward?')) return;
        try {
            const response = await axios.delete(`${API_ENDPOINTS.ADMIN_DELETE_TRAINER_REWARD}?id=${rewardId}`);
            if (response.data && response.data.success) {
                toast.success('Reward deleted successfully');
                loadTrainers();
            }
        } catch (error) {
            console.error('Error deleting reward:', error);
            toast.error(error.response?.data?.error || 'Failed to delete reward');
        }
    };
    
    const loadPointPokemon = async (pointId) => {
        setPointPokemonLoading(true);
        try {
            const response = await axios.get(`${API_ENDPOINTS.ADMIN_GET_MAP_POINT_POKEMON}?point_id=${pointId}`);
            if (response.data && response.data.success) {
                setPointPokemon(response.data.pokemon || []);
            }
        } catch (error) {
            console.error('Error loading point pokemon:', error);
            toast.error('Failed to load point pokemon');
        } finally {
            setPointPokemonLoading(false);
        }
    };
    
    const loadWildPokemon = async () => {
        setWildPokemonLoading(true);
        try {
            // Get all wild pokemon - use the adminGetAllPokemons action from Redux
            await dispatch(adminGetAllPokemons());
            // The pokemons will be in the Redux store, but we need to get them from there
            // For now, let's use a direct API call to get pokemon_wild
            const response = await axios.get(API_ENDPOINTS.ADMIN_GET_ALL_POKEMONS);
            if (response.data) {
                // Check different response formats
                if (response.data.pokemons) {
                    setAllWildPokemon(response.data.pokemons || []);
                } else if (Array.isArray(response.data)) {
                    setAllWildPokemon(response.data || []);
                } else if (response.data.data && Array.isArray(response.data.data)) {
                    setAllWildPokemon(response.data.data || []);
                }
            }
        } catch (error) {
            console.error('Error loading wild pokemon:', error);
            toast.error('Failed to load wild pokemon');
        } finally {
            setWildPokemonLoading(false);
        }
    };
    
    // Handle Pokemon search input
    const handlePokemonSearchChange = (value, index = null) => {
        if (index !== null) {
            if (typeof index === 'string' && index.startsWith('pvp_reward_')) {
                // PVP reward Pokemon selection
                setActiveSearchIndex(index);
                if (value.trim().length > 0) {
                    const filtered = allWildPokemon.filter(p => 
                        p.naam.toLowerCase().includes(value.toLowerCase()) ||
                        p.wild_id.toString().includes(value) ||
                        (p.type1 && p.type1.toLowerCase().includes(value.toLowerCase())) ||
                        (p.type2 && p.type2.toLowerCase().includes(value.toLowerCase()))
                    ).slice(0, 10);
                    setPokemonSearchResults(filtered);
                    setShowPokemonSearch(true);
                } else {
                    setShowPokemonSearch(false);
                    setActiveSearchIndex(null);
                }
            } else {
                // Bulk import mode
                const updated = [...bulkPokemonList];
                updated[index] = { ...updated[index], search: value };
                setBulkPokemonList(updated);
                setActiveSearchIndex(index);
                
                if (value.trim().length > 0) {
                    const filtered = allWildPokemon.filter(p => 
                        p.naam.toLowerCase().includes(value.toLowerCase()) ||
                        p.wild_id.toString().includes(value) ||
                        (p.type1 && p.type1.toLowerCase().includes(value.toLowerCase())) ||
                        (p.type2 && p.type2.toLowerCase().includes(value.toLowerCase()))
                    ).slice(0, 10);
                    setPokemonSearchResults(filtered);
                    setShowPokemonSearch(true);
                } else {
                    setShowPokemonSearch(false);
                    setActiveSearchIndex(null);
                }
            }
        } else {
            // Single Pokemon mode
            setPokemonSearchInput(value);
            setActiveSearchIndex(null);
            if (value.trim().length > 0) {
                const filtered = allWildPokemon.filter(p => 
                    p.naam.toLowerCase().includes(value.toLowerCase()) ||
                    p.wild_id.toString().includes(value) ||
                    (p.type1 && p.type1.toLowerCase().includes(value.toLowerCase())) ||
                    (p.type2 && p.type2.toLowerCase().includes(value.toLowerCase()))
                ).slice(0, 10);
                setPokemonSearchResults(filtered);
                setShowPokemonSearch(true);
            } else {
                setShowPokemonSearch(false);
            }
        }
    };
    
    // Handle Pokemon selection from search
    const handlePokemonSelect = (pokemon, index = null) => {
        if (index !== null) {
            // Bulk import mode
            const updated = [...bulkPokemonList];
            updated[index] = { ...updated[index], pokemon_wild_id: pokemon.wild_id, search: pokemon.naam };
            setBulkPokemonList(updated);
            setShowPokemonSearch(false);
            setActiveSearchIndex(null);
        } else {
            // Single Pokemon mode
            setNewPokemonToPoint({ ...newPokemonToPoint, pokemon_wild_id: pokemon.wild_id });
            setPokemonSearchInput(pokemon.naam);
            setShowPokemonSearch(false);
        }
    };
    
    // Handle CSV file upload
    const handleCsvUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        
        const reader = new FileReader();
        reader.onload = (e) => {
            const text = e.target.result;
            const lines = text.split('\n').filter(line => line.trim());
            if (lines.length < 2) {
                toast.error('CSV file must have at least a header row and one data row');
                return;
            }
            
            const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
            
            const pokemonList = [];
            for (let i = 1; i < lines.length; i++) {
                const values = lines[i].split(',').map(v => v.trim());
                const row = {};
                headers.forEach((header, idx) => {
                    row[header] = values[idx] || '';
                });
                
                // Find pokemon by name or ID
                const pokemonName = row['pokemon'] || row['name'] || row['pokemon_name'] || '';
                const pokemonId = row['pokemon_id'] || row['id'] || row['wild_id'] || '';
                
                let foundPokemon = null;
                if (pokemonId) {
                    foundPokemon = allWildPokemon.find(p => p.wild_id.toString() === pokemonId.toString());
                }
                if (!foundPokemon && pokemonName) {
                    foundPokemon = allWildPokemon.find(p => 
                        p.naam.toLowerCase() === pokemonName.toLowerCase()
                    );
                }
                
                if (foundPokemon) {
                    pokemonList.push({
                        pokemon_wild_id: foundPokemon.wild_id,
                        spawn_rate: parseInt(row['spawn_rate'] || row['rate'] || '100') || 100,
                        min_level: parseInt(row['min_level'] || row['min'] || '1') || 1,
                        max_level: parseInt(row['max_level'] || row['max'] || '100') || 100,
                        search: foundPokemon.naam
                    });
                }
            }
            
            if (pokemonList.length > 0) {
                setBulkPokemonList(pokemonList);
                setBulkImportMode(true);
                toast.success(`Loaded ${pokemonList.length} Pokemon from CSV`);
            } else {
                toast.error('No valid Pokemon found in CSV file');
            }
        };
        reader.readAsText(file);
    };
    
    // Add row to bulk import table
    const addBulkPokemonRow = () => {
        setBulkPokemonList([...bulkPokemonList, { pokemon_wild_id: null, spawn_rate: 100, min_level: 1, max_level: 100, search: '' }]);
    };
    
    // Remove row from bulk import table
    const removeBulkPokemonRow = (index) => {
        const updated = bulkPokemonList.filter((_, i) => i !== index);
        setBulkPokemonList(updated);
    };
    
    // Parse HTML table and extract Pokemon data
    const parseHtmlTable = (htmlString, wildPokemonList = []) => {
        try {
            // Create a temporary DOM element to parse HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlString, 'text/html');
            const table = doc.querySelector('table.data-table');
            
            if (!table) {
                toast.error('No table found in HTML. Please make sure the HTML contains a table with class "data-table"');
                return [];
            }
            
            const rows = table.querySelectorAll('tbody tr');
            const pokemonList = [];
            // Removed duplicate tracking - allow same Pokemon to be added multiple times
            
            rows.forEach((row) => {
                try {
                    // Get Pokemon name from the first cell
                    const nameCell = row.querySelector('td.cell-name');
                    if (!nameCell) return;
                    
                    // Try to find the Pokemon name from the link or span
                    const nameLink = nameCell.querySelector('a.ent-name');
                    const nameSpan = nameCell.querySelector('span.infocard-cell-data');
                    let pokemonName = '';
                    
                    if (nameLink) {
                        pokemonName = nameLink.textContent.trim();
                    } else if (nameSpan) {
                        pokemonName = nameSpan.textContent.trim();
                    } else {
                        pokemonName = nameCell.textContent.trim();
                    }
                    
                    if (!pokemonName) return;
                    
                    // Try to find the Pokemon in wildPokemonList by name (case-insensitive)
                    // Try exact match first, then partial match
                    let matchedPokemon = null;
                    const searchName = pokemonName.toLowerCase().trim();
                    
                    // First try exact match (case-insensitive)
                    matchedPokemon = wildPokemonList.find(p => 
                        p.naam && p.naam.toLowerCase().trim() === searchName
                    );
                    
                    // If not found, try partial match (Pokemon name contains the search term or vice versa)
                    if (!matchedPokemon) {
                        matchedPokemon = wildPokemonList.find(p => {
                            if (!p.naam) return false;
                            const pName = p.naam.toLowerCase().trim();
                            return pName.includes(searchName) || searchName.includes(pName);
                        });
                    }
                    
                    // Get level range from the "Levels" column
                    const levelCell = row.querySelector('td.cell-num');
                    let minLevel = 1;
                    let maxLevel = 100;
                    
                    if (levelCell) {
                        const levelText = levelCell.textContent.trim();
                        // Parse formats like "14-17", "20", "11-17", etc.
                        if (levelText.includes('-')) {
                            const [min, max] = levelText.split('-').map(s => parseInt(s.trim()));
                            if (!isNaN(min)) minLevel = min;
                            if (!isNaN(max)) maxLevel = max;
                        } else {
                            const level = parseInt(levelText);
                            if (!isNaN(level)) {
                                minLevel = level;
                                maxLevel = level;
                            }
                        }
                    }
                    
                    // Get spawn rate based on Rarity icon or span
                    let spawnRate = 50; // Default spawn rate
                    
                    // First, check for span with exact percentage (new format)
                    const raritySpan = row.querySelector('span.icon-rarity, span[class*="rarity"]');
                    if (raritySpan) {
                        const spanText = raritySpan.textContent.trim();
                        // Extract percentage from text like "20%" or "20"
                        const percentMatch = spanText.match(/(\d+)%/);
                        if (percentMatch) {
                            spawnRate = parseInt(percentMatch[1]);
                        } else {
                            // Try to parse as number
                            const numMatch = spanText.match(/(\d+)/);
                            if (numMatch) {
                                spawnRate = parseInt(numMatch[1]);
                            }
                        }
                    }
                    
                    // If no span found, check for rarity icon image (old format)
                    if (spawnRate === 50) {
                        const rarityImg = row.querySelector('img.icon-loc');
                        if (rarityImg) {
                            const imgSrc = rarityImg.getAttribute('src') || '';
                            const imgAlt = rarityImg.getAttribute('alt') || '';
                            const imgTitle = rarityImg.getAttribute('title') || '';
                            
                            // Check for Common (80-100%)
                            if (imgSrc.includes('common.png') || imgAlt.toLowerCase() === 'common' || imgTitle.toLowerCase() === 'common') {
                                spawnRate = Math.floor(Math.random() * 21) + 80; // Random between 80-100
                            }
                            // Check for Uncommon (20%)
                            else if (imgSrc.includes('uncommon.png') || imgAlt.toLowerCase() === 'uncommon' || imgTitle.toLowerCase() === 'uncommon') {
                                spawnRate = 20; // Fixed 20%
                            }
                            // Check for Rare (10%)
                            else if (imgSrc.includes('rare.png') || imgAlt.toLowerCase() === 'rare' || imgTitle.toLowerCase() === 'rare') {
                                spawnRate = 10; // Fixed 10%
                            }
                            // Check for Limited (1-20)
                            else if (imgSrc.includes('limited.png') || imgAlt.toLowerCase() === 'limited' || imgTitle.toLowerCase() === 'limited') {
                                spawnRate = Math.floor(Math.random() * 20) + 1; // Random between 1-20
                            }
                            // If no match, use default
                            else {
                                spawnRate = 50;
                            }
                        }
                    }
                    
                    // If Pokemon was found, use its wild_id
                    // If not found, set pokemon_wild_id to null (user will need to search manually)
                    const pokemonWildId = matchedPokemon ? matchedPokemon.wild_id : null;
                    
                    // Allow duplicates - same Pokemon can be added multiple times with different options
                    
                    pokemonList.push({
                        pokemon_name: pokemonName,
                        spawn_rate: spawnRate,
                        min_level: minLevel,
                        max_level: maxLevel,
                        pokemon_wild_id: pokemonWildId, // Auto-matched if found
                        search: pokemonName
                    });
                } catch (error) {
                    console.error('Error parsing row:', error);
                }
            });
            
            return pokemonList;
        } catch (error) {
            console.error('Error parsing HTML:', error);
            toast.error('Error parsing HTML: ' + error.message);
            return [];
        }
    };
    
    // Handle HTML import
    const handleHtmlImport = () => {
        if (!htmlInput.trim()) {
            toast.error('Please paste HTML content');
            return;
        }
        
        if (allWildPokemon.length === 0) {
            toast.warning('Loading Pokemon database... Please wait.');
            loadWildPokemon().then(() => {
                // Retry after loading
                setTimeout(() => {
                    handleHtmlImport();
                }, 1000);
            });
            return;
        }
        
        const parsedPokemon = parseHtmlTable(htmlInput, allWildPokemon);
        
        if (parsedPokemon.length === 0) {
            toast.error('No Pokemon found in HTML. Please check the format.');
            return;
        }
        
        // Count how many were auto-matched vs need manual search
        const autoMatched = parsedPokemon.filter(p => p.pokemon_wild_id !== null).length;
        const needsSearch = parsedPokemon.filter(p => p.pokemon_wild_id === null).length;
        
        // Allow duplicates - same Pokemon can be added multiple times with different options
        // Set all parsed Pokemon to bulkPokemonList (no duplicate removal)
        setBulkPokemonList(parsedPokemon);
        setBulkImportMode(true);
        setHtmlImportMode(false);
        
        let message = `Found ${parsedPokemon.length} Pokemon in HTML.`;
        if (autoMatched > 0) {
            message += ` ${autoMatched} auto-matched.`;
        }
        if (needsSearch > 0) {
            message += ` ${needsSearch} need manual search.`;
        }
        toast.success(message);
    };
    
    // Handle bulk Pokemon addition
    const handleBulkAddPokemon = async () => {
        if (!selectedPoint || !selectedPoint.id) {
            toast.error('Please select a point first');
            return;
        }
        
        const validPokemon = bulkPokemonList.filter(p => p.pokemon_wild_id);
        if (validPokemon.length === 0) {
            toast.error('Please add at least one Pokemon');
            return;
        }
        
        try {
            let successCount = 0;
            let failCount = 0;
            
            for (const pokemon of validPokemon) {
                try {
                    const pokemonData = { ...pokemon, point_id: selectedPoint.id };
                    const response = await axios.post(API_ENDPOINTS.ADMIN_ADD_POKEMON_TO_POINT, pokemonData);
                    if (response.data && response.data.success) {
                        successCount++;
                    } else {
                        failCount++;
                    }
                } catch (error) {
                    failCount++;
                }
            }
            
            if (successCount > 0) {
                toast.success(`Successfully added ${successCount} Pokemon${successCount > 1 ? 's' : ''}`);
                if (failCount > 0) {
                    toast.warning(`Failed to add ${failCount} Pokemon${failCount > 1 ? 's' : ''}`);
                }
                setShowPokemonModal(false);
                setBulkImportMode(false);
                setBulkPokemonList([{ pokemon_wild_id: null, spawn_rate: 100, min_level: 1, max_level: 100, search: '' }]);
                loadPointPokemon(selectedPoint.id);
            } else {
                toast.error('Failed to add any Pokemon');
            }
        } catch (error) {
            console.error('Error bulk adding pokemon:', error);
            toast.error('Failed to bulk add pokemon');
        }
    };
    
    const handleCreateMap = async () => {
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_CREATE_MAP, newMap);
            if (response.data && response.data.success) {
                toast.success('Map created successfully');
                setShowMapModal(false);
                setNewMap({ name: '', image_path: '', city_id: null, city_name: '', order: 0, is_active: 1 });
                loadMaps();
            } else {
                toast.error(response.data.error || 'Failed to create map');
            }
        } catch (error) {
            console.error('Error creating map:', error);
            toast.error(error.response?.data?.error || 'Failed to create map');
        }
    };
    
    const handleUpdateMap = async () => {
        if (!editingMap) return;
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_UPDATE_MAP, editingMap);
            if (response.data && response.data.success) {
                toast.success('Map updated successfully');
                setShowMapModal(false);
                setEditingMap(null);
                loadMaps();
            } else {
                toast.error(response.data.error || 'Failed to update map');
            }
        } catch (error) {
            console.error('Error updating map:', error);
            toast.error(error.response?.data?.error || 'Failed to update map');
        }
    };
    
    const handleDeleteMap = async (mapId) => {
        if (!window.confirm('Are you sure you want to delete this map? This will also delete all points and pokemon associated with it.')) {
            return;
        }
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_DELETE_MAP, { id: mapId });
            if (response.data && response.data.success) {
                toast.success('Map deleted successfully');
                if (selectedMap && selectedMap.id === mapId) {
                    setSelectedMap(null);
                    setMapPoints([]);
                }
                loadMaps();
            } else {
                toast.error(response.data.error || 'Failed to delete map');
            }
        } catch (error) {
            console.error('Error deleting map:', error);
            toast.error(error.response?.data?.error || 'Failed to delete map');
        }
    };
    
    // Handle updating point position after dragging
    const handleUpdatePointPosition = async (pointId, newX, newY) => {
        try {
            const point = mapPoints.find(p => p.id === pointId);
            if (!point) return;
            
            const pointData = {
                id: pointId,
                map_id: point.map_id,
                name: point.name,
                gebied: point.gebied,
                x: newX,
                y: newY,
                width: point.width,
                height: point.height,
                tooltip: point.tooltip || '',
                is_active: point.is_active ? 1 : 0,
                point_type: point.point_type || 'battle',
                target_url: point.target_url || '',
                required_level: point.required_level || 0,
                required_attacks: point.required_attacks || 0,
                next_point_id: point.next_point_id || null,
                trainer_id: point.trainer_id || null,
                silver_cost: point.silver_cost || null,
                trainer_image: point.trainer_image || null
            };
            
            const response = await axios.post(API_ENDPOINTS.ADMIN_UPDATE_MAP_POINT, pointData);
            if (response.data && response.data.success) {
                toast.success('Point position updated');
                if (selectedMap) {
                    loadMapPoints(selectedMap.id);
                }
            } else {
                toast.error(response.data.error || 'Failed to update point position');
            }
        } catch (error) {
            console.error('Error updating point position:', error);
            toast.error('Failed to update point position');
        }
    };
    
    const handleCreateMapPoint = async () => {
        // Use newPoint.map_id if available, otherwise use selectedMap.id
        const mapId = newPoint.map_id || (selectedMap ? selectedMap.id : null);
        
        if (!mapId) {
            toast.error('Please select a map first');
            return;
        }
        
        // Validate required fields
        if (!newPoint.name || newPoint.name.trim() === '') {
            toast.error('Point name is required');
            return;
        }
        
        const pointType = newPoint.point_type || 'battle';
        
        if (pointType === 'battle' && (!newPoint.gebied || newPoint.gebied.trim() === '')) {
            toast.error('Gebied (Area Identifier) is required for battle points');
            return;
        }
        
        if (pointType === 'trainer' && !newPoint.trainer_id) {
            toast.error('Trainer is required for trainer battle points');
            return;
        }
        
        if (pointType === 'navigation' && (!newPoint.target_url || newPoint.target_url.trim() === '')) {
            toast.error('Target URL is required for navigation points');
            return;
        }
        
        try {
                const pointData = {
                map_id: mapId,
                name: newPoint.name.trim(),
                gebied: pointType === 'trainer' ? '' : (newPoint.gebied ? newPoint.gebied.trim() : ''),
                x: newPoint.x || 0,
                y: newPoint.y || 0,
                width: newPoint.width || 100,
                height: newPoint.height || 100,
                tooltip: newPoint.tooltip || null,
                is_active: newPoint.is_active !== undefined ? newPoint.is_active : 1,
                point_type: pointType,
                target_url: newPoint.target_url || null,
                required_level: newPoint.required_level || 0,
                required_attacks: newPoint.required_attacks || 0,
                next_point_id: newPoint.next_point_id || null,
                trainer_id: newPoint.trainer_id || null,
                silver_cost: newPoint.silver_cost || null,
                trainer_image: newPoint.trainer_image || null
            };
            
            console.log('Creating map point with data:', pointData);
            
            const response = await axios.post(API_ENDPOINTS.ADMIN_CREATE_MAP_POINT, pointData);
            if (response.data && response.data.success) {
                toast.success('Map point created successfully');
                setShowPointModal(false);
                // Don't reset newPoint if we're in the middle of creating points from rectangles
                // The useEffect will handle opening the next modal
                if (pendingRectangles.length === 0) {
                    setNewPoint({ map_id: null, name: '', gebied: '', point_type: 'battle', target_url: '', x: 0, y: 0, width: 100, height: 100, tooltip: '', is_active: 1, required_level: 0, required_attacks: 0, next_point_id: null, trainer_id: null, silver_cost: null, trainer_image: null });
                }
                loadMapPoints(selectedMap.id);
                return true; // Return true on success
            } else {
                toast.error(response.data.error || 'Failed to create map point');
                return false;
            }
        } catch (error) {
            console.error('Error creating map point:', error);
            toast.error(error.response?.data?.error || 'Failed to create map point');
            return false;
        }
    };
    
    // Handle creating points from rectangles
    const [pendingRectangles, setPendingRectangles] = useState([]);
    const [currentRectangleIndex, setCurrentRectangleIndex] = useState(0);
    
    const handleCreatePointsFromRectangles = () => {
        const rectangles = drawings.filter(d => d.type === 'rectangle');
        if (rectangles.length === 0) {
            toast.error('No rectangles to create points from');
            return;
        }
        
        if (!selectedMap || !selectedMap.id) {
            toast.error('Please select a map first');
            return;
        }
        
        if (!mapContainerRef || !originalImageSize.width || !originalImageSize.height) {
            toast.error('Map not loaded yet');
            return;
        }
        
        // Calculate positions for each rectangle
        const containerRect = mapContainerRef.getBoundingClientRect();
        const containerAspect = containerRect.width / containerRect.height;
        const imageAspect = originalImageSize.width / originalImageSize.height;
        
        let displayedWidth, displayedHeight;
        if (imageAspect > containerAspect) {
            displayedWidth = containerRect.width;
            displayedHeight = containerRect.width / imageAspect;
        } else {
            displayedHeight = containerRect.height;
            displayedWidth = containerRect.height * imageAspect;
        }
        
        let offsetX = 0, offsetY = 0;
        if (imageAspect > containerAspect) {
            offsetY = (containerRect.height - displayedHeight) / 2;
        } else {
            offsetX = (containerRect.width - displayedWidth) / 2;
        }
        
        // Convert rectangles to point data
        // Note: rect.start and rect.end are already relative to displayed image (offset already subtracted)
        console.log('Converting rectangles to points:', {
            rectanglesCount: rectangles.length,
            containerRect: { width: containerRect.width, height: containerRect.height },
            displayedSize: { width: displayedWidth, height: displayedHeight },
            offset: { x: offsetX, y: offsetY },
            originalImageSize: { width: originalImageSize.width, height: originalImageSize.height },
            imageAspect,
            containerAspect
        });
        
        const pointsData = rectangles.map((rect, index) => {
            // Calculate center and dimensions in displayed image coordinates
            // The coordinates are already relative to the displayed image (offset already subtracted)
            const minX = Math.min(rect.start.x, rect.end.x);
            const maxX = Math.max(rect.start.x, rect.end.x);
            const minY = Math.min(rect.start.y, rect.end.y);
            const maxY = Math.max(rect.start.y, rect.end.y);
            
            const centerX = (minX + maxX) / 2;
            const centerY = (minY + maxY) / 2;
            const width = maxX - minX;
            const height = maxY - minY;
            
            // Use the stored displayedWidth and displayedHeight from when the rectangle was drawn
            // This ensures consistency - use stored values if available, otherwise recalculate
            const rectDisplayedWidth = rect.displayedWidth || displayedWidth;
            const rectDisplayedHeight = rect.displayedHeight || displayedHeight;
            
            // Convert to percentage (rect coordinates are already relative to displayed image, no offset)
            // Use the stored displayedWidth/Height to ensure exact match with drawing time
            // The coordinates are in pixels relative to the displayed image, so divide by displayed size
            // Don't clamp to 0-100 here - let the database/store handle validation
            const x = (centerX / rectDisplayedWidth) * 100;
            const y = (centerY / rectDisplayedHeight) * 100;
            
            console.log('Converting rectangle to point:', {
                rectCoords: { start: rect.start, end: rect.end },
                center: { x: centerX, y: centerY },
                storedDisplayedSize: { width: rectDisplayedWidth, height: rectDisplayedHeight },
                currentDisplayedSize: { width: displayedWidth, height: displayedHeight },
                percentage: { x, y },
                calculation: {
                    xCalc: `${centerX} / ${rectDisplayedWidth} * 100 = ${x}`,
                    yCalc: `${centerY} / ${rectDisplayedHeight} * 100 = ${y}`
                },
                note: 'These percentages will be used to calculate position on display'
            });
            
            // Convert width/height from displayed pixels to original image pixels
            // Scale factor: how many original pixels per displayed pixel
            // Use stored displayedWidth/Height for consistency
            const scaleX = originalImageSize.width / rectDisplayedWidth;
            const scaleY = originalImageSize.height / rectDisplayedHeight;
            
            // Convert to original image pixels
            const pointWidth = width * scaleX;
            const pointHeight = height * scaleY;
            
            console.log(`Rectangle ${index + 1}:`, {
                rect: { start: rect.start, end: rect.end },
                bounds: { minX, maxX, minY, maxY },
                center: { x: centerX, y: centerY },
                size: { width, height },
                storedDisplayedSize: { width: rectDisplayedWidth, height: rectDisplayedHeight },
                currentDisplayedSize: { width: displayedWidth, height: displayedHeight },
                percentage: { x, y },
                pixelSize: { width: pointWidth, height: pointHeight },
                scale: { x: scaleX, y: scaleY },
                originalImageSize: { width: originalImageSize.width, height: originalImageSize.height }
            });
            
            return {
                x: Math.max(0, Math.min(100, x)),
                y: Math.max(0, Math.min(100, y)),
                width: Math.max(10, Math.round(pointWidth)),
                height: Math.max(10, Math.round(pointHeight)),
                index: index
            };
        });
        
        // Find the highest number in existing point names
        // Extract numbers from names like "Kanto 1", "Kanto 2", etc.
        let highestNumber = 0;
        const namePattern = /(\d+)$/; // Matches number at the end of the name
        
        mapPoints.forEach(point => {
            if (point.name) {
                const match = point.name.match(namePattern);
                if (match) {
                    const num = parseInt(match[1]);
                    if (num > highestNumber) {
                        highestNumber = num;
                    }
                }
            }
        });
        
        // Set pending rectangles and start with first one
        setPendingRectangles(pointsData);
        setCurrentRectangleIndex(0);
        
        // Open first modal with name based on highest number + 1
        const firstPoint = pointsData[0];
        const baseName = selectedMap?.name || 'Point';
        const nextNumber = highestNumber + 1;
        setNewPoint({
            map_id: selectedMap.id,
            name: `${baseName} ${nextNumber}`,
            gebied: '',
            point_type: 'battle',
            target_url: '',
            x: firstPoint.x,
            y: firstPoint.y,
            width: firstPoint.width,
            height: firstPoint.height,
            tooltip: '',
            is_active: 1,
            required_level: 0,
            required_attacks: 0,
            next_point_id: null
        });
        setShowPointModal(true);
    };
    
    // Handle when point modal is closed (after creating or canceling)
    useEffect(() => {
        if (showPointModal === false && pendingRectangles.length > 0) {
            // If we just closed a modal and there are more rectangles, move to next
            if (currentRectangleIndex < pendingRectangles.length - 1) {
                const nextIndex = currentRectangleIndex + 1;
                setCurrentRectangleIndex(nextIndex);
                
                // Small delay before opening next modal
                setTimeout(() => {
                    const nextPoint = pendingRectangles[nextIndex];
                    // Find the highest number in existing point names (including newly created ones)
                    let highestNumber = 0;
                    const namePattern = /(\d+)$/;
                    
                    mapPoints.forEach(point => {
                        if (point.name) {
                            const match = point.name.match(namePattern);
                            if (match) {
                                const num = parseInt(match[1]);
                                if (num > highestNumber) {
                                    highestNumber = num;
                                }
                            }
                        }
                    });
                    
                    // Also check the name we just created (if any)
                    if (newPoint.name) {
                        const match = newPoint.name.match(namePattern);
                        if (match) {
                            const num = parseInt(match[1]);
                            if (num > highestNumber) {
                                highestNumber = num;
                            }
                        }
                    }
                    
                    const baseName = selectedMap?.name || 'Point';
                    const nextNumber = highestNumber + 1;
                    setNewPoint({
                        map_id: selectedMap.id,
                        name: `${baseName} ${nextNumber}`,
                        gebied: '',
                        point_type: 'battle',
                        target_url: '',
                        x: nextPoint.x,
                        y: nextPoint.y,
                        width: nextPoint.width,
                        height: nextPoint.height,
                        tooltip: '',
                        is_active: 1,
                        required_level: 0,
                        required_attacks: 0,
                        next_point_id: null
                    });
                    setShowPointModal(true);
                }, 300);
            } else {
                // All rectangles processed
                setPendingRectangles([]);
                setCurrentRectangleIndex(0);
                setDrawings([]); // Clear drawings after all points are created
            }
        }
    }, [showPointModal, pendingRectangles, currentRectangleIndex, selectedMap?.id, mapPoints]);
    
    const handleUpdateMapPoint = async () => {
        if (!editingPoint) return;
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_UPDATE_MAP_POINT, editingPoint);
            if (response.data && response.data.success) {
                toast.success('Map point updated successfully');
                setShowPointModal(false);
                setEditingPoint(null);
                if (selectedMap) {
                    loadMapPoints(selectedMap.id);
                }
            } else {
                toast.error(response.data.error || 'Failed to update map point');
            }
        } catch (error) {
            console.error('Error updating map point:', error);
            toast.error(error.response?.data?.error || 'Failed to update map point');
        }
    };
    
    const handleDeleteMapPoint = async (pointId) => {
        if (!window.confirm('Are you sure you want to delete this map point? This will also delete all pokemon associated with it.')) {
            return;
        }
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_DELETE_MAP_POINT, { id: pointId });
            if (response.data && response.data.success) {
                toast.success('Map point deleted successfully');
                if (selectedPoint && selectedPoint.id === pointId) {
                    setSelectedPoint(null);
                    setPointPokemon([]);
                }
                if (selectedMap) {
                    loadMapPoints(selectedMap.id);
                }
            } else {
                toast.error(response.data.error || 'Failed to delete map point');
            }
        } catch (error) {
            console.error('Error deleting map point:', error);
            toast.error(error.response?.data?.error || 'Failed to delete map point');
        }
    };
    
    const handleAddPokemonToPoint = async () => {
        if (!selectedPoint) {
            toast.error('Please select a map point first');
            return;
        }
        if (!newPokemonToPoint.pokemon_wild_id) {
            toast.error('Please select a pokemon');
            return;
        }
        try {
            if (editingPokemonId) {
                // Update existing pokemon
                const pokemonData = { 
                    id: editingPokemonId,
                    pokemon_wild_id: newPokemonToPoint.pokemon_wild_id,
                    spawn_rate: newPokemonToPoint.spawn_rate,
                    min_level: newPokemonToPoint.min_level,
                    max_level: newPokemonToPoint.max_level
                };
                const response = await axios.post(API_ENDPOINTS.ADMIN_UPDATE_MAP_POINT_POKEMON, pokemonData);
                if (response.data && response.data.success) {
                    toast.success('Pokemon updated successfully');
                    setShowPokemonModal(false);
                    setNewPokemonToPoint({ pokemon_wild_id: null, spawn_rate: 100, min_level: 1, max_level: 100 });
                    setEditingPokemonId(null);
                    loadPointPokemon(selectedPoint.id);
                } else {
                    toast.error(response.data.error || 'Failed to update pokemon');
                }
            } else {
                // Add new pokemon
                const pokemonData = { ...newPokemonToPoint, point_id: selectedPoint.id };
                const response = await axios.post(API_ENDPOINTS.ADMIN_ADD_POKEMON_TO_POINT, pokemonData);
                if (response.data && response.data.success) {
                    toast.success('Pokemon added to point successfully');
                    setShowPokemonModal(false);
                    setNewPokemonToPoint({ pokemon_wild_id: null, spawn_rate: 100, min_level: 1, max_level: 100 });
                    loadPointPokemon(selectedPoint.id);
                } else {
                    toast.error(response.data.error || 'Failed to add pokemon to point');
                }
            }
        } catch (error) {
            console.error('Error adding/updating pokemon to point:', error);
            toast.error(error.response?.data?.error || 'Failed to add/update pokemon to point');
        }
    };
    
    const handleRemovePokemonFromPoint = async (id) => {
        if (!window.confirm('Are you sure you want to remove this pokemon from the point?')) {
            return;
        }
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_REMOVE_POKEMON_FROM_POINT, { id });
            if (response.data && response.data.success) {
                toast.success('Pokemon removed from point successfully');
                if (selectedPoint) {
                    loadPointPokemon(selectedPoint.id);
                }
            } else {
                toast.error(response.data.error || 'Failed to remove pokemon from point');
            }
        } catch (error) {
            console.error('Error removing pokemon from point:', error);
            toast.error(error.response?.data?.error || 'Failed to remove pokemon from point');
        }
    };
    
    const handleDuplicatePoint = async (point) => {
        if (!selectedMap || !point) {
            toast.error('Please select a map and point first');
            return;
        }
        
        if (!window.confirm(`Are you sure you want to duplicate point "${point.name}" with all its pokemon?`)) {
            return;
        }
        
        try {
            // Create new point with same data but different name
            const newPointData = {
                map_id: selectedMap.id,
                name: `${point.name} (Copy)`,
                gebied: point.gebied,
                x: point.x,
                y: point.y,
                width: point.width,
                height: point.height,
                tooltip: point.tooltip || '',
                is_active: point.is_active
            };
            
            const response = await axios.post(API_ENDPOINTS.ADMIN_CREATE_MAP_POINT, newPointData);
            if (response.data && response.data.success) {
                const newPointId = response.data.point_id;
                
                // Load pokemon from original point
                const pokemonResponse = await axios.get(`${API_ENDPOINTS.ADMIN_GET_MAP_POINT_POKEMON}?point_id=${point.id}`);
                if (pokemonResponse.data && pokemonResponse.data.success && pokemonResponse.data.pokemon && pokemonResponse.data.pokemon.length > 0) {
                    // Copy all pokemon to new point
                    const copyPromises = pokemonResponse.data.pokemon.map(pokemon => 
                        axios.post(API_ENDPOINTS.ADMIN_ADD_POKEMON_TO_POINT, {
                            point_id: newPointId,
                            pokemon_wild_id: pokemon.pokemon_wild_id,
                            spawn_rate: pokemon.spawn_rate,
                            min_level: pokemon.min_level,
                            max_level: pokemon.max_level,
                            is_active: pokemon.is_active !== undefined ? pokemon.is_active : 1
                        })
                    );
                    
                    await Promise.all(copyPromises);
                    toast.success(`Point duplicated successfully with ${pokemonResponse.data.pokemon.length} pokemon!`);
                } else {
                    toast.success('Point duplicated successfully (no pokemon to copy)');
                }
                
                loadMapPoints(selectedMap.id);
            } else {
                toast.error(response.data.error || 'Failed to duplicate point');
            }
        } catch (error) {
            console.error('Error duplicating point:', error);
            toast.error(error.response?.data?.error || 'Failed to duplicate point');
        }
    };
    
    const handleMapImageUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        
        const mapName = editingMap ? editingMap.name : newMap.name;
        if (!mapName || mapName.trim() === '') {
            toast.error('Please enter map name first');
            return;
        }
        
        setUploadingImage(true);
        try {
            const formData = new FormData();
            formData.append('image', file);
            formData.append('map_name', mapName.trim());
            
            const response = await axios.post(API_ENDPOINTS.ADMIN_UPLOAD_MAP_IMAGE, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            
            if (response.data && response.data.success) {
                const imagePath = response.data.image_path;
                if (editingMap) {
                    setEditingMap({ ...editingMap, image_path: imagePath });
                } else {
                    setNewMap({ ...newMap, image_path: imagePath });
                }
                toast.success('Image uploaded successfully');
            } else {
                toast.error(response.data.error || 'Failed to upload image');
            }
        } catch (error) {
            console.error('Error uploading image:', error);
            toast.error(error.response?.data?.error || 'Failed to upload image');
        } finally {
            setUploadingImage(false);
        }
    };
    
    const loadImageBrowser = async (path = '') => {
        setImageBrowserLoading(true);
        setImageBrowserPath(path);
        try {
            const url = path 
                ? `${API_ENDPOINTS.ADMIN_GET_MAP_IMAGES}?path=${encodeURIComponent(path)}`
                : API_ENDPOINTS.ADMIN_GET_MAP_IMAGES;
            const response = await axios.get(url);
            if (response.data && response.data.success) {
                setImageBrowserItems(response.data.items || []);
            } else {
                // Show debug info if available
                const errorMsg = response.data?.error || 'Failed to load images';
                const debugInfo = response.data?.debug;
                console.error('Error loading images:', errorMsg, debugInfo);
                if (debugInfo) {
                    toast.error(`${errorMsg}. Check console for details.`);
                } else {
                    toast.error(errorMsg);
                }
            }
        } catch (error) {
            console.error('Error loading images:', error);
            if (error.response?.data?.debug) {
                console.error('Debug info:', error.response.data.debug);
                toast.error(`Failed to load images. Check console for path details.`);
            } else {
                toast.error('Failed to load images');
            }
        } finally {
            setImageBrowserLoading(false);
        }
    };
    
    const loadCities = async (search = '') => {
        if (search.length < 1) {
            setCities([]);
            return;
        }
        
        setCitySearchLoading(true);
        try {
            const response = await axios.get(`${API_ENDPOINTS.ADMIN_GET_CITIES}?search=${encodeURIComponent(search)}`);
            if (response.data && response.data.success) {
                setCities(response.data.cities || []);
            }
        } catch (error) {
            console.error('Error loading cities:', error);
        } finally {
            setCitySearchLoading(false);
        }
    };
    
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (citySearch) {
                loadCities(citySearch);
            } else {
                setCities([]);
            }
        }, 300);
        
        return () => clearTimeout(timeoutId);
    }, [citySearch]);
    
    const handleCancelSale = async () => {
        if (!cancelSaleModal.sale) return;
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_CANCEL_SALE, {
                sale_id: cancelSaleModal.sale.id,
                reason: cancelSaleModal.reason
            });
            if (response.data && response.data.success) {
                toast.success(response.data.message || 'Sale cancelled successfully');
                setCancelSaleModal({ show: false, sale: null, reason: '' });
                loadMarketLogs();
                loadActiveSales(); // Refresh active sales list
            } else {
                toast.error(response.data.error || 'Failed to cancel sale');
            }
        } catch (error) {
            console.error('Error cancelling sale:', error);
            toast.error(error.response?.data?.error || 'Failed to cancel sale');
        }
    };
    
    const handleBuyWithPriceChange = async () => {
        if (!buyPriceChangeModal.sale || !buyPriceChangeModal.newPrice || buyPriceChangeModal.newPrice <= 0) {
            toast.error('Please enter a valid new price');
            return;
        }
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_BUY_WITH_PRICE_CHANGE, {
                sale_id: buyPriceChangeModal.sale.id,
                new_price: parseInt(buyPriceChangeModal.newPrice),
                reason: buyPriceChangeModal.reason
            });
            if (response.data && response.data.success) {
                toast.success(response.data.message || 'Pokemon purchased successfully');
                setBuyPriceChangeModal({ show: false, sale: null, newPrice: '', reason: '' });
                loadMarketLogs();
                loadActiveSales(); // Refresh active sales list
            } else {
                toast.error(response.data.error || 'Failed to purchase Pokemon');
            }
        } catch (error) {
            console.error('Error buying with price change:', error);
            toast.error(error.response?.data?.error || 'Failed to purchase Pokemon');
        }
    };
    
    // Show loading while checking admin status
    if (profileLoading || (!checkedAdmin && (userData || localUserData))) {
        return (
            <div>
                <GoldSiverHeader previous={'/home'} title='Admin Panel'>
                    <Container className="mt-4">
                        <Alert variant="info">
                            <Alert.Heading>Loading...</Alert.Heading>
                            <p>Checking admin permissions...</p>
                        </Alert>
                    </Container>
                </GoldSiverHeader>
            </div>
        );
    }
    
    // Show access denied if not admin
    if (!isAdmin && checkedAdmin) {
        return (
            <div>
                <GoldSiverHeader previous={'/home'} title='Admin Panel'>
                    <Container className="mt-4">
                        <Alert variant="danger">
                            <Alert.Heading>Access Denied</Alert.Heading>
                            <p>You do not have permission to access this page.</p>
                            <p><small>Admin status: {adminLevel} (0 = Regular User, 1 = Moderator, 2 = Supervisor, 3 = Administrator)</small></p>
                        </Alert>
                    </Container>
                </GoldSiverHeader>
            </div>
        );
    }

    return (
        <div>
            <GoldSiverHeader previous={'/home'} title='Admin Panel'>
                <Container className="mt-4">
                    {/* Navigation Tabs */}
                    <Row className="mb-4">
                        <Col md={12}>
                            <Nav variant="pills" activeKey={activeTab} className="d-flex gap-2 flex-wrap">
                                <Nav.Item>
                                    <Nav.Link 
                                        eventKey="dashboard" 
                                        onClick={() => setActiveTab('dashboard')}
                                        className={activeTab === 'dashboard' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                    >
                                        Dashboard
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link 
                                        eventKey="give-pokemon" 
                                        onClick={() => setActiveTab('give-pokemon')}
                                        className={activeTab === 'give-pokemon' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                    >
                                        Give Pokemon
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link 
                                        eventKey="user-management" 
                                        onClick={() => setActiveTab('user-management')}
                                        className={activeTab === 'user-management' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                    >
                                        User Management
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link 
                                        eventKey="all-pokemons" 
                                        onClick={() => setActiveTab('all-pokemons')}
                                        className={activeTab === 'all-pokemons' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                    >
                                        All Pokemons
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link 
                                        eventKey="pokemon-db" 
                                        onClick={() => setActiveTab('pokemon-db')}
                                        className={activeTab === 'pokemon-db' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                    >
                                        Pokemon Database
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link 
                                        eventKey="moves-import" 
                                        onClick={() => setActiveTab('moves-import')}
                                        className={activeTab === 'moves-import' ? 'bg-warning text-dark' : 'bg-light-theme text-white'}
                                    >
                                        ⚔️ Import Moves
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link 
                                        eventKey="chat-settings" 
                                        onClick={() => setActiveTab('chat-settings')}
                                        className={activeTab === 'chat-settings' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                    >
                                        Chat Settings
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link 
                                        eventKey="paypal-settings" 
                                        onClick={() => setActiveTab('paypal-settings')}
                                        className={activeTab === 'paypal-settings' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                    >
                                        PayPal Settings
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link 
                                        eventKey="menu-management" 
                                        onClick={() => setActiveTab('menu-management')}
                                        className={activeTab === 'menu-management' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                    >
                                        Menu Management
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link 
                                        eventKey="battle-settings" 
                                        onClick={() => setActiveTab('battle-settings')}
                                        className={activeTab === 'battle-settings' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                    >
                                        Battle Settings
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link 
                                        eventKey="pvp-management" 
                                        onClick={() => setActiveTab('pvp-management')}
                                        className={activeTab === 'pvp-management' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                    >
                                        PVP Management
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link 
                                        eventKey="ad-tags-management" 
                                        onClick={() => setActiveTab('ad-tags-management')}
                                        className={activeTab === 'ad-tags-management' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                    >
                                        Ad Tags Management
                                    </Nav.Link>
                                </Nav.Item>
                                {adminLevel >= 3 && (
                                    <>
                                        <Nav.Item>
                                            <Nav.Link 
                                                eventKey="maps-management" 
                                                onClick={() => setActiveTab('maps-management')}
                                                className={activeTab === 'maps-management' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                            >
                                                Maps Management
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link 
                                                eventKey="trainers-management" 
                                                onClick={() => {
                                                    setActiveTab('trainers-management');
                                                    loadTrainers();
                                                }}
                                                className={activeTab === 'trainers-management' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                            >
                                                Trainers Management
                                            </Nav.Link>
                                        </Nav.Item>
                                    </>
                                )}
                                <Nav.Item>
                                    <Nav.Link 
                                        eventKey="chat-management" 
                                        onClick={() => setActiveTab('chat-management')}
                                        className={activeTab === 'chat-management' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                    >
                                        Chat Management
                                    </Nav.Link>
                                </Nav.Item>
                                {adminLevel >= 2 && (
                                    <Nav.Item>
                                        <Nav.Link 
                                            eventKey="market-management" 
                                            onClick={() => setActiveTab('market-management')}
                                            className={activeTab === 'market-management' ? 'bg-primary text-white' : 'bg-light-theme text-white'}
                                        >
                                            Pokemon Market Management
                                        </Nav.Link>
                                    </Nav.Item>
                                )}
                            </Nav>
                        </Col>
                    </Row>
                    
                    {/* Dashboard Tab */}
                    {activeTab === 'dashboard' && (
                        <Row>
                            <Col md={12}>
                                <Card className="mb-4">
                                    <Card.Header>
                                        <h2>Admin Dashboard</h2>
                                    </Card.Header>
                                    <Card.Body>
                                        <Alert variant="success">
                                            <Alert.Heading>Welcome, Administrator!</Alert.Heading>
                                            <p>You have administrator privileges.</p>
                                            <hr />
                                            <p className="mb-0">
                                                <strong>Admin Level:</strong> {
                                                    adminLevel === 3 ? 'Administrator' :
                                                    adminLevel === 2 ? 'Supervisor' :
                                                    adminLevel === 1 ? 'Moderator' :
                                                    'Regular User'
                                                } ({adminLevel})
                                            </p>
                                        </Alert>
                                        
                                        {/* Database Tools */}
                                        <Card className="mt-4 border-info">
                                            <Card.Header className="bg-info text-white">
                                                <strong>🔧 Database Tools</strong>
                                            </Card.Header>
                                            <Card.Body>
                                                <Row>
                                                    <Col md={6}>
                                                        <Card className="h-100">
                                                            <Card.Body>
                                                                <h5>📊 Initialize Database Tables</h5>
                                                                <p className="text-muted">
                                                                    Creates missing tables like daily_spins, fortune_prizes, pokemon_healing, etc.
                                                                    Safe to run - won't affect existing data.
                                                                </p>
                                                                <Button 
                                                                    variant="primary" 
                                                                    onClick={handleInitDatabase}
                                                                    disabled={initDbLoading}
                                                                >
                                                                    {initDbLoading ? 'Initializing...' : 'Initialize Missing Tables'}
                                                                </Button>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Card className="h-100 border-danger">
                                                            <Card.Body>
                                                                <h5>⚠️ Reset Game</h5>
                                                                <p className="text-danger">
                                                                    <strong>WARNING:</strong> This will delete ALL user data and create a fresh Dev admin account.
                                                                </p>
                                                                <p className="text-muted small">
                                                                    New Dev account: Dev / 123123 / kfir@spo.co.il
                                                                </p>
                                                                <Button 
                                                                    variant="danger" 
                                                                    onClick={handleResetGame}
                                                                    disabled={resetGameLoading || adminLevel < 3}
                                                                >
                                                                    {resetGameLoading ? 'Resetting...' : '🗑️ Reset Game'}
                                                                </Button>
                                                                {adminLevel < 3 && (
                                                                    <p className="text-warning mt-2 small">
                                                                        Requires Admin Level 3
                                                                    </p>
                                                                )}
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}
                    
                    {/* Give Pokemon Tab */}
                    {activeTab === 'give-pokemon' && (
                    <>
                    <Row>
                        <Col md={12}>
                            <Card>
                                <Card.Header>
                                    <h3>Give Pokemon to Player</h3>
                                </Card.Header>
                                <Card.Body>
                                    <Form onSubmit={handleGivePokemon}>
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Target Username *</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter username"
                                                        value={targetUsername}
                                                        onChange={(e) => setTargetUsername(e.target.value)}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Search Pokemon *</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Search by name or ID..."
                                                        value={pokemonSearch}
                                                        onChange={(e) => setPokemonSearch(e.target.value)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <Col md={12}>
                                                <Form.Label>Select Pokemon *</Form.Label>
                                                <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #ccc', borderRadius: '4px', padding: '10px' }}>
                                                    {pokemons
                                                        .filter(p => 
                                                            !pokemonSearch || 
                                                            p.naam.toLowerCase().includes(pokemonSearch.toLowerCase()) ||
                                                            p.wild_id.toString().includes(pokemonSearch)
                                                        )
                                                        .slice((pokemonPage - 1) * pokemonsPerPage, pokemonPage * pokemonsPerPage)
                                                        .map((pokemon) => (
                                                            <div
                                                                key={pokemon.wild_id}
                                                                onClick={() => setSelectedPokemonId(pokemon.wild_id.toString())}
                                                                style={{
                                                                    padding: '10px',
                                                                    margin: '5px 0',
                                                                    cursor: 'pointer',
                                                                    backgroundColor: selectedPokemonId === pokemon.wild_id.toString() ? '#007bff' : '#f8f9fa',
                                                                    color: selectedPokemonId === pokemon.wild_id.toString() ? 'white' : 'black',
                                                                    borderRadius: '4px',
                                                                    border: selectedPokemonId === pokemon.wild_id.toString() ? '2px solid #0056b3' : '1px solid #ddd'
                                                                }}
                                                            >
                                                                <strong>#{pokemon.wild_id}</strong> - {pokemon.naam}
                                                                {pokemon.type1 && <span className="ms-2">({pokemon.type1}{pokemon.type2 ? `, ${pokemon.type2}` : ''})</span>}
                                                            </div>
                                                        ))}
                                                    {pokemons.filter(p => 
                                                        !pokemonSearch || 
                                                        p.naam.toLowerCase().includes(pokemonSearch.toLowerCase()) ||
                                                        p.wild_id.toString().includes(pokemonSearch)
                                                    ).length === 0 && (
                                                        <div className="text-center p-3">No pokemons found</div>
                                                    )}
                                                </div>
                                                {pokemons.filter(p => 
                                                    !pokemonSearch || 
                                                    p.naam.toLowerCase().includes(pokemonSearch.toLowerCase()) ||
                                                    p.wild_id.toString().includes(pokemonSearch)
                                                ).length > pokemonsPerPage && (
                                                    <div className="d-flex justify-content-between mt-2">
                                                        <Button
                                                            variant="secondary"
                                                            size="sm"
                                                            disabled={pokemonPage === 1}
                                                            onClick={() => setPokemonPage(pokemonPage - 1)}
                                                        >
                                                            Previous
                                                        </Button>
                                                        <span className="align-self-center">
                                                            Page {pokemonPage} of {Math.ceil(pokemons.filter(p => 
                                                                !pokemonSearch || 
                                                                p.naam.toLowerCase().includes(pokemonSearch.toLowerCase()) ||
                                                                p.wild_id.toString().includes(pokemonSearch)
                                                            ).length / pokemonsPerPage)}
                                                        </span>
                                                        <Button
                                                            variant="secondary"
                                                            size="sm"
                                                            disabled={pokemonPage >= Math.ceil(pokemons.filter(p => 
                                                                !pokemonSearch || 
                                                                p.naam.toLowerCase().includes(pokemonSearch.toLowerCase()) ||
                                                                p.wild_id.toString().includes(pokemonSearch)
                                                            ).length / pokemonsPerPage)}
                                                            onClick={() => setPokemonPage(pokemonPage + 1)}
                                                        >
                                                            Next
                                                        </Button>
                                                    </div>
                                                )}
                                                {selectedPokemonId && (
                                                    <Alert variant="info" className="mt-3">
                                                        Selected: <strong>#{selectedPokemonId}</strong> - {
                                                            pokemons.find(p => p.wild_id.toString() === selectedPokemonId)?.naam || 'Unknown'
                                                        }
                                                    </Alert>
                                                )}
                                            </Col>
                                        </Row>
                                        
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Level</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="1"
                                                        max="100"
                                                        value={pokemonLevel}
                                                        onChange={(e) => setPokemonLevel(e.target.value)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Check
                                                        type="checkbox"
                                                        label="Add to Team (if team has space)"
                                                        checked={addToTeam}
                                                        onChange={(e) => setAddToTeam(e.target.checked)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        
                                        <Button 
                                            variant="primary" 
                                            type="submit" 
                                            disabled={givePokemonLoading || !selectedPokemonId}
                                        >
                                            {givePokemonLoading ? 'Giving...' : 'Give Pokemon'}
                                        </Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    </>
                    )}
                    
                    {/* All Pokemons Tab */}
                    {activeTab === 'all-pokemons' && (
                    <Row>
                        <Col md={12}>
                            <Card>
                                <Card.Header>
                                    <h3>All Pokemons in System</h3>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="mb-3">
                                        <Col md={6}>
                                            <Form.Control
                                                type="text"
                                                placeholder="Search pokemons by name or ID..."
                                                value={pokemonSearch}
                                                onChange={(e) => {
                                                    setPokemonSearch(e.target.value);
                                                    setPokemonPage(1);
                                                }}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <Alert variant="info" className="mb-0">
                                                Total: {pokemons.length} pokemons
                                                {pokemonSearch && ` (${pokemons.filter(p => 
                                                    p.naam.toLowerCase().includes(pokemonSearch.toLowerCase()) ||
                                                    p.wild_id.toString().includes(pokemonSearch)
                                                ).length} found)`}
                                            </Alert>
                                        </Col>
                                    </Row>
                                    
                                    <Table striped bordered hover variant="dark" responsive>
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Name</th>
                                                <th>Type 1</th>
                                                <th>Type 2</th>
                                                <th>Growth</th>
                                                <th>Rarity</th>
                                                <th>World</th>
                                                <th>Base Stats</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pokemons
                                                .filter(p => 
                                                    !pokemonSearch || 
                                                    p.naam.toLowerCase().includes(pokemonSearch.toLowerCase()) ||
                                                    p.wild_id.toString().includes(pokemonSearch)
                                                )
                                                .slice((pokemonPage - 1) * pokemonsPerPage, pokemonPage * pokemonsPerPage)
                                                .map((pokemon) => (
                                                    <tr key={pokemon.wild_id}>
                                                        <td>{pokemon.wild_id}</td>
                                                        <td>
                                                            <Button 
                                                                variant="link" 
                                                                className="p-0 text-info fw-bold"
                                                                onClick={() => handleOpenAttacksModal(pokemon)}
                                                                title="Click to manage attacks"
                                                            >
                                                                {pokemon.naam}
                                                            </Button>
                                                        </td>
                                                        <td>{pokemon.type1 || '-'}</td>
                                                        <td>{pokemon.type2 || '-'}</td>
                                                        <td>{pokemon.groei || '-'}</td>
                                                        <td>{pokemon.zeldzaamheid || '-'}</td>
                                                        <td>{pokemon.wereld || '-'}</td>
                                                        <td>
                                                            <small>
                                                                HP: {pokemon.hp_base || 0} | 
                                                                ATK: {pokemon.attack_base || 0} | 
                                                                DEF: {pokemon.defence_base || 0} | 
                                                                SPD: {pokemon.speed_base || 0}
                                                            </small>
                                                        </td>
                                                        <td>
                                                            <Button
                                                                variant="success"
                                                                size="sm"
                                                                className="me-2"
                                                                onClick={() => handleOpenEvolutionsModal(pokemon)}
                                                                title="Manage Evolutions"
                                                            >
                                                                Evolutions
                                                            </Button>
                                                            <Button
                                                                variant="info"
                                                                size="sm"
                                                                onClick={() => handleOpenImportModal(pokemon)}
                                                                title="Import data from PokemonDB.net"
                                                            >
                                                                Import
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            {pokemons.filter(p => 
                                                !pokemonSearch || 
                                                p.naam.toLowerCase().includes(pokemonSearch.toLowerCase()) ||
                                                p.wild_id.toString().includes(pokemonSearch)
                                            ).length === 0 && (
                                                <tr>
                                                    <td colSpan="9" className="text-center py-4">
                                                        <div className="mb-2">No pokemons found matching "{pokemonSearch}"</div>
                                                        {pokemonSearch && (
                                                            <Button
                                                                variant="success"
                                                                size="sm"
                                                                onClick={() => handleImportNewPokemon(pokemonSearch)}
                                                                disabled={importLoading}
                                                            >
                                                                {importLoading ? 'Importing...' : `📥 Import "${pokemonSearch}" from PokemonDB`}
                                                            </Button>
                                                        )}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                    
                                    {pokemons.filter(p => 
                                        !pokemonSearch || 
                                        p.naam.toLowerCase().includes(pokemonSearch.toLowerCase()) ||
                                        p.wild_id.toString().includes(pokemonSearch)
                                    ).length > pokemonsPerPage && (
                                        <div className="d-flex justify-content-between mt-3">
                                            <Button
                                                variant="secondary"
                                                disabled={pokemonPage === 1}
                                                onClick={() => setPokemonPage(pokemonPage - 1)}
                                            >
                                                Previous
                                            </Button>
                                            <span className="align-self-center">
                                                Page {pokemonPage} of {Math.ceil(pokemons.filter(p => 
                                                    !pokemonSearch || 
                                                    p.naam.toLowerCase().includes(pokemonSearch.toLowerCase()) ||
                                                    p.wild_id.toString().includes(pokemonSearch)
                                                ).length / pokemonsPerPage)}
                                            </span>
                                            <Button
                                                variant="secondary"
                                                disabled={pokemonPage >= Math.ceil(pokemons.filter(p => 
                                                    !pokemonSearch || 
                                                    p.naam.toLowerCase().includes(pokemonSearch.toLowerCase()) ||
                                                    p.wild_id.toString().includes(pokemonSearch)
                                                ).length / pokemonsPerPage)}
                                                onClick={() => setPokemonPage(pokemonPage + 1)}
                                            >
                                                Next
                                            </Button>
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    )}
                    
                    {/* User Management Tab */}
                    {activeTab === 'user-management' && (
                    <>
                    <Row className="mt-4">
                        <Col md={12}>
                            <Card>
                                <Card.Header>
                                    <h3>User Management</h3>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="mb-3">
                                        <Col md={6}>
                                            <Form.Control
                                                type="text"
                                                placeholder="Search users..."
                                                value={usersSearch}
                                                onChange={(e) => setUsersSearch(e.target.value)}
                                                onKeyPress={(e) => e.key === 'Enter' && handleSearchUsers()}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <Button variant="primary" onClick={handleSearchUsers}>
                                                Search
                                            </Button>
                                        </Col>
                                    </Row>
                                    
                                    {adminUsersLoading ? (
                                        <Alert variant="info">Loading users...</Alert>
                                    ) : (
                                        <Table striped bordered hover variant="dark" responsive>
                                            <thead>
                                                <tr>
                                                    <th>Username</th>
                                                    <th>Rank</th>
                                                    <th>Silver</th>
                                                    <th>Gold</th>
                                                    <th>VIP</th>
                                                    <th>Admin</th>
                                                    <th>Pokemons</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {adminUsers.map((user) => (
                                                    <tr key={user.user_id}>
                                                        <td>{user.username}</td>
                                                        <td>{user.rank}</td>
                                                        <td>{user.silver}</td>
                                                        <td>{user.gold}</td>
                                                        <td>{user.is_vip ? 'Yes' : 'No'}</td>
                                                        <td>{user.admin}</td>
                                                        <td>{user.aantalpokemon}</td>
                                                        <td>
                                                            <Button
                                                                variant="info"
                                                                size="sm"
                                                                className="me-2"
                                                                onClick={() => handleLoadUserPokemons(user.username)}
                                                            >
                                                                View Pokemons
                                                            </Button>
                                                            <Button
                                                                variant="warning"
                                                                size="sm"
                                                                onClick={() => setEditingUser({ ...user })}
                                                            >
                                                                Edit
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    
                    {/* Edit User Modal */}
                    {editingUser && (
                        <Row className="mt-4">
                            <Col md={12}>
                                <Card>
                                    <Card.Header>
                                        <h4>Edit User: {editingUser.username}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <Form onSubmit={handleEditUser}>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Silver</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={editingUser.silver || 0}
                                                            onChange={(e) => setEditingUser({ ...editingUser, silver: parseInt(e.target.value) || 0 })}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Gold</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={editingUser.gold || 0}
                                                            onChange={(e) => setEditingUser({ ...editingUser, gold: parseInt(e.target.value) || 0 })}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Rank</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={editingUser.rank || 0}
                                                            onChange={(e) => setEditingUser({ ...editingUser, rank: parseInt(e.target.value) || 0 })}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Admin Level</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            min="0"
                                                            max="3"
                                                            value={editingUser.admin || 0}
                                                            onChange={(e) => setEditingUser({ ...editingUser, admin: parseInt(e.target.value) || 0 })}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>VIP Days (0 to remove VIP)</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={editingUser.premiumaccount ? Math.floor((editingUser.premiumaccount - Date.now() / 1000) / 86400) : 0}
                                                            onChange={(e) => {
                                                                const days = parseInt(e.target.value) || 0;
                                                                const timestamp = days > 0 ? Math.floor(Date.now() / 1000) + (days * 86400) : 0;
                                                                setEditingUser({ ...editingUser, premiumaccount: timestamp });
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Banned</Form.Label>
                                                        <Form.Select
                                                            value={editingUser.banned || 'N'}
                                                            onChange={(e) => setEditingUser({ ...editingUser, banned: e.target.value })}
                                                        >
                                                            <option value="N">No</option>
                                                            <option value="Y">Yes</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Button variant="primary" type="submit" className="me-2">
                                                Save Changes
                                            </Button>
                                            <Button variant="secondary" onClick={() => setEditingUser(null)}>
                                                Cancel
                                            </Button>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}
                    
                    {/* User Pokemons Section */}
                    {selectedUser && (
                        <Row className="mt-4">
                            <Col md={12}>
                                <Card>
                                    <Card.Header>
                                        <h4>Pokemons of: {selectedUser}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        {adminUserPokemonsLoading ? (
                                            <Alert variant="info">Loading pokemons...</Alert>
                                        ) : (
                                            <Table striped bordered hover variant="dark" responsive>
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Name</th>
                                                        <th>Level</th>
                                                        <th>In Team</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {adminUserPokemons.length > 0 ? (
                                                        adminUserPokemons.map((pokemon) => (
                                                            <tr key={pokemon.id}>
                                                                <td>{pokemon.id}</td>
                                                                <td>{pokemon.naam}</td>
                                                                <td>{pokemon.level}</td>
                                                                <td>{pokemon.opzak === 'ja' ? 'Yes' : 'No'}</td>
                                                                <td>
                                                                    <Button
                                                                        variant="danger"
                                                                        size="sm"
                                                                        onClick={() => handleTakePokemon(pokemon.id)}
                                                                    >
                                                                        Remove
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center">No pokemons found.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}
                    </>
                    )}
                    
                    {/* Pokemon Database Tab */}
                    {activeTab === 'pokemon-db' && (
                    <Row className="mt-4">
                        <Col md={12}>
                            <Card>
                                <Card.Header>
                                    <h3>Add Pokemon to Database</h3>
                                </Card.Header>
                                <Card.Body>
                                    <Form onSubmit={handleAddPokemonToDB}>
                                        <Row>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Name *</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={newPokemonData.naam}
                                                        onChange={(e) => setNewPokemonData({ ...newPokemonData, naam: e.target.value })}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Type 1 *</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={newPokemonData.type1}
                                                        onChange={(e) => setNewPokemonData({ ...newPokemonData, type1: e.target.value })}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Type 2</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={newPokemonData.type2}
                                                        onChange={(e) => setNewPokemonData({ ...newPokemonData, type2: e.target.value })}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Attack Base</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={newPokemonData.attack_base}
                                                        onChange={(e) => setNewPokemonData({ ...newPokemonData, attack_base: e.target.value })}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Defence Base</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={newPokemonData.defence_base}
                                                        onChange={(e) => setNewPokemonData({ ...newPokemonData, defence_base: e.target.value })}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Speed Base</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={newPokemonData.speed_base}
                                                        onChange={(e) => setNewPokemonData({ ...newPokemonData, speed_base: e.target.value })}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>HP Base</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={newPokemonData.hp_base}
                                                        onChange={(e) => setNewPokemonData({ ...newPokemonData, hp_base: e.target.value })}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Button variant="primary" type="submit">
                                            Add Pokemon
                                        </Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    )}
                    
                    {/* Moves Import Tab */}
                    {activeTab === 'moves-import' && (
                    <Row className="mt-4">
                        <Col md={12}>
                            <Card className="bg-dark text-white">
                                <Card.Header className="bg-warning text-dark">
                                    <h3>⚔️ Import Move Effects from PokemonDB</h3>
                                </Card.Header>
                                <Card.Body>
                                    <Alert variant="info">
                                        <strong>How it works:</strong> This tool fetches move data (effects, stat changes, status conditions) from 
                                        <a href="https://pokemondb.net/move/all" target="_blank" rel="noreferrer" className="ms-1">PokemonDB</a> 
                                        and updates the <code>aanval</code> table in your database.
                                    </Alert>
                                    
                                    <div className="d-flex gap-3 mb-4">
                                        <Button 
                                            variant="warning" 
                                            size="lg"
                                            onClick={async () => {
                                                const moveName = prompt('Enter move name (e.g., Growl, Swords Dance):');
                                                if (!moveName) return;
                                                try {
                                                    const response = await axios.get(`/api/api/adminImportAllMoves.php?action=import_move&name=${encodeURIComponent(moveName)}`);
                                                    if (response.data.success) {
                                                        toast.success(`✅ Imported: ${response.data.move.name} - ${response.data.move.effect || 'No effect'}`);
                                                        console.log('Move data:', response.data.move);
                                                    } else {
                                                        toast.error(response.data.error || 'Failed to import');
                                                    }
                                                } catch (error) {
                                                    toast.error('Error: ' + (error.response?.data?.error || error.message));
                                                }
                                            }}
                                        >
                                            📥 Import Single Move
                                        </Button>
                                        
                                        <Button 
                                            variant="success" 
                                            size="lg"
                                            onClick={async () => {
                                                if (!window.confirm('This will import 50 moves from PokemonDB. Continue?')) return;
                                                toast.info('Starting import... This may take a minute.');
                                                try {
                                                    const response = await axios.get('/api/api/adminImportAllMoves.php?action=import_all&limit=50&offset=0');
                                                    if (response.data.success) {
                                                        toast.success(`✅ Imported ${response.data.imported} moves! Total available: ${response.data.total_moves}`);
                                                        if (response.data.errors.length > 0) {
                                                            console.log('Errors:', response.data.errors);
                                                        }
                                                    } else {
                                                        toast.error(response.data.error || 'Failed to import');
                                                    }
                                                } catch (error) {
                                                    toast.error('Error: ' + (error.response?.data?.error || error.message));
                                                }
                                            }}
                                        >
                                            🚀 Batch Import (50 Moves)
                                        </Button>
                                    </div>
                                    
                                    <Card className="bg-secondary">
                                        <Card.Header>📊 Effect Types Supported</Card.Header>
                                        <Card.Body>
                                            <Row>
                                                <Col md={4}>
                                                    <h6>🎯 Stat Changes</h6>
                                                    <ul className="small">
                                                        <li>Attack ↑↓</li>
                                                        <li>Defense ↑↓</li>
                                                        <li>Speed ↑↓</li>
                                                        <li>Sp. Attack ↑↓</li>
                                                        <li>Sp. Defense ↑↓</li>
                                                    </ul>
                                                </Col>
                                                <Col md={4}>
                                                    <h6>☠️ Status Conditions</h6>
                                                    <ul className="small">
                                                        <li>🔥 Burn</li>
                                                        <li>☠️ Poison / Toxic</li>
                                                        <li>⚡ Paralysis</li>
                                                        <li>😴 Sleep</li>
                                                        <li>❄️ Freeze</li>
                                                        <li>😵 Confusion</li>
                                                    </ul>
                                                </Col>
                                                <Col md={4}>
                                                    <h6>✨ Special Effects</h6>
                                                    <ul className="small">
                                                        <li>💚 HP Drain (Absorb, Giga Drain)</li>
                                                        <li>💥 Recoil (Take Down, Double-Edge)</li>
                                                        <li>😱 Flinch</li>
                                                    </ul>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    )}
                    
                    {/* Chat Settings Tab */}
                    {activeTab === 'chat-settings' && (
                    <Row className="mt-4">
                        <Col md={12}>
                            <Card>
                                <Card.Header>
                                    <h3>Chat Display Settings</h3>
                                </Card.Header>
                                <Card.Body>
                                    {chatSettingsLoading ? (
                                        <Alert variant="info">Loading chat settings...</Alert>
                                    ) : (
                                        <Form onSubmit={handleUpdateChatSettings}>
                                            <Form.Group className="mb-3">
                                                <Form.Label><strong>Display Mode</strong></Form.Label>
                                                <Form.Select
                                                    value={chatDisplayMode}
                                                    onChange={(e) => setChatDisplayMode(e.target.value)}
                                                >
                                                    <option value="home_only">Home Page Only</option>
                                                    <option value="all_pages">All Pages</option>
                                                    <option value="sidebar">Sidebar (All Pages)</option>
                                                </Form.Select>
                                                <Form.Text className="text-muted">
                                                    <ul className="mt-2">
                                                        <li><strong>Home Page Only:</strong> Chat will only appear on the home page</li>
                                                        <li><strong>All Pages:</strong> Chat will appear on all pages (full width)</li>
                                                        <li><strong>Sidebar:</strong> Chat will appear in a sidebar on all pages</li>
                                                    </ul>
                                                </Form.Text>
                                            </Form.Group>
                                            <Button variant="primary" type="submit" disabled={chatSettingsLoading}>
                                                {chatSettingsLoading ? 'Saving...' : 'Save Settings'}
                                            </Button>
                                        </Form>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    )}
                    
                    {/* PVP Management Tab */}
                    {activeTab === 'pvp-management' && (
                    <Row className="mt-4">
                        <Col md={12}>
                            {/* PVP Settings */}
                            <Card className="mb-4">
                                <Card.Header>
                                    <h3>PVP Settings</h3>
                                </Card.Header>
                                <Card.Body>
                                    {pvpSettingsLoading ? (
                                        <Alert variant="info">Loading PVP settings...</Alert>
                                    ) : (
                                        <Form onSubmit={(e) => { e.preventDefault(); handleUpdatePvpSettings(); }}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Battle Timer (seconds)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={pvpSettings.battle_timer_seconds || '300'}
                                                    onChange={(e) => setPvpSettings({ ...pvpSettings, battle_timer_seconds: e.target.value })}
                                                    min="60"
                                                    max="3600"
                                                />
                                                <Form.Text className="text-muted">Default: 300 (5 minutes)</Form.Text>
                                            </Form.Group>
                                            
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ranking Reward - 1st Place (%)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={pvpSettings.ranking_reward_first || '50'}
                                                    onChange={(e) => setPvpSettings({ ...pvpSettings, ranking_reward_first: e.target.value })}
                                                    min="0"
                                                    max="100"
                                                />
                                            </Form.Group>
                                            
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ranking Reward - 2nd Place (%)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={pvpSettings.ranking_reward_second || '30'}
                                                    onChange={(e) => setPvpSettings({ ...pvpSettings, ranking_reward_second: e.target.value })}
                                                    min="0"
                                                    max="100"
                                                />
                                            </Form.Group>
                                            
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ranking Reward - 3rd Place (%)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={pvpSettings.ranking_reward_third || '20'}
                                                    onChange={(e) => setPvpSettings({ ...pvpSettings, ranking_reward_third: e.target.value })}
                                                    min="0"
                                                    max="100"
                                                />
                                            </Form.Group>
                                            
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ranking Reward - Default for places 4-10 (%)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={pvpSettings.ranking_reward_default_percent || '10'}
                                                    onChange={(e) => setPvpSettings({ ...pvpSettings, ranking_reward_default_percent: e.target.value })}
                                                    min="0"
                                                    max="100"
                                                />
                                                <Form.Text className="text-muted">Minimum 100 silver per player</Form.Text>
                                            </Form.Group>
                                            
                                            <Button variant="primary" type="submit" disabled={pvpSettingsLoading}>
                                                {pvpSettingsLoading ? 'Saving...' : 'Save Settings'}
                                            </Button>
                                        </Form>
                                    )}
                                </Card.Body>
                            </Card>
                            
                            {/* PVP Rewards */}
                            <Card className="mb-4">
                                <Card.Header>
                                    <h3>PVP Rewards Configuration</h3>
                                </Card.Header>
                                <Card.Body>
                                    {pvpRewardsLoading ? (
                                        <Alert variant="info">Loading rewards...</Alert>
                                    ) : (
                                        <>
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th>Type</th>
                                                        <th>Percentage</th>
                                                        <th>Min Amount</th>
                                                        <th>Max Amount</th>
                                                        <th>Pokemon ID</th>
                                                        <th>Item ID</th>
                                                        <th>Active</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {pvpRewards.map((reward, index) => (
                                                        <tr key={reward.id || index}>
                                                            <td>{reward.reward_type}</td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    step="0.01"
                                                                    value={reward.reward_percentage || 0}
                                                                    onChange={(e) => {
                                                                        const newRewards = [...pvpRewards];
                                                                        newRewards[index].reward_percentage = parseFloat(e.target.value);
                                                                        setPvpRewards(newRewards);
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    value={reward.min_amount || 0}
                                                                    onChange={(e) => {
                                                                        const newRewards = [...pvpRewards];
                                                                        newRewards[index].min_amount = parseInt(e.target.value);
                                                                        setPvpRewards(newRewards);
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    value={reward.max_amount || 0}
                                                                    onChange={(e) => {
                                                                        const newRewards = [...pvpRewards];
                                                                        newRewards[index].max_amount = parseInt(e.target.value);
                                                                        setPvpRewards(newRewards);
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                {reward.reward_type === 'pokemon' ? (
                                                                    <div style={{ position: 'relative' }}>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder="Search Pokemon..."
                                                                            value={reward.pokemon_search || (reward.pokemon_id ? `ID: ${reward.pokemon_id}` : '')}
                                                                            onChange={(e) => {
                                                                                const newRewards = [...pvpRewards];
                                                                                newRewards[index].pokemon_search = e.target.value;
                                                                                setPvpRewards(newRewards);
                                                                                if (e.target.value.trim().length > 0) {
                                                                                    handlePokemonSearchChange(e.target.value, `pvp_reward_${index}`);
                                                                                }
                                                                            }}
                                                                            onFocus={() => {
                                                                                if (allWildPokemon.length === 0) {
                                                                                    loadWildPokemon();
                                                                                }
                                                                            }}
                                                                        />
                                                                        {reward.pokemon_search && pokemonSearchResults.length > 0 && activeSearchIndex === `pvp_reward_${index}` && (
                                                                            <div style={{
                                                                                position: 'absolute',
                                                                                top: '100%',
                                                                                left: 0,
                                                                                right: 0,
                                                                                backgroundColor: 'white',
                                                                                border: '1px solid #ccc',
                                                                                borderRadius: '4px',
                                                                                maxHeight: '200px',
                                                                                overflowY: 'auto',
                                                                                zIndex: 1000,
                                                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                                                            }}>
                                                                                {pokemonSearchResults.map((poke) => (
                                                                                    <div
                                                                                        key={poke.wild_id}
                                                                                        style={{
                                                                                            padding: '8px',
                                                                                            cursor: 'pointer',
                                                                                            borderBottom: '1px solid #eee'
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            const newRewards = [...pvpRewards];
                                                                                            newRewards[index].pokemon_id = poke.wild_id;
                                                                                            newRewards[index].pokemon_search = poke.naam;
                                                                                            setPvpRewards(newRewards);
                                                                                            setActiveSearchIndex(null);
                                                                                            setPokemonSearchResults([]);
                                                                                        }}
                                                                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                                                                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                                                                    >
                                                                                        {poke.naam} (ID: {poke.wild_id})
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                        {reward.pokemon_id && !reward.pokemon_search && (
                                                                            <Form.Text className="text-muted">
                                                                                Pokemon ID: {reward.pokemon_id}
                                                                            </Form.Text>
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <Form.Text className="text-muted">N/A</Form.Text>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {reward.reward_type === 'item' ? (
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={reward.item_id || ''}
                                                                        placeholder="Item ID"
                                                                        onChange={(e) => {
                                                                            const newRewards = [...pvpRewards];
                                                                            newRewards[index].item_id = e.target.value ? parseInt(e.target.value) : null;
                                                                            setPvpRewards(newRewards);
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <Form.Text className="text-muted">N/A</Form.Text>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <Form.Check
                                                                    type="switch"
                                                                    checked={reward.is_active === 1}
                                                                    onChange={(e) => {
                                                                        const newRewards = [...pvpRewards];
                                                                        newRewards[index].is_active = e.target.checked ? 1 : 0;
                                                                        setPvpRewards(newRewards);
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                            <Button variant="primary" onClick={handleUpdatePvpRewards} disabled={pvpRewardsLoading}>
                                                {pvpRewardsLoading ? 'Saving...' : 'Save Rewards'}
                                            </Button>
                                        </>
                                    )}
                                </Card.Body>
                            </Card>
                            
                            {/* PVP Leaderboard & Statistics */}
                            <Card className="mb-4">
                                <Card.Header>
                                    <h3>PVP Leaderboard & Statistics</h3>
                                </Card.Header>
                                <Card.Body>
                                    {pvpLeaderboardLoading ? (
                                        <Alert variant="info">Loading leaderboard...</Alert>
                                    ) : (
                                        <>
                                            <h5>Top 10 Players</h5>
                                            {pvpLeaderboard.length === 0 ? (
                                                <Alert variant="info">No players in leaderboard yet. Statistics will appear after players complete PVP battles.</Alert>
                                            ) : (
                                                <Table striped bordered hover>
                                                    <thead>
                                                        <tr>
                                                            <th>Rank</th>
                                                            <th>Username</th>
                                                            <th>Wins</th>
                                                            <th>Losses</th>
                                                            <th>Total Battles</th>
                                                            <th>Silver Won</th>
                                                            <th>Gold Won</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {pvpLeaderboard.map((player, index) => (
                                                            <tr key={player.user_id}>
                                                                <td>{index + 1}</td>
                                                                <td>{player.username}</td>
                                                                <td>{player.wins || 0}</td>
                                                                <td>{player.losses || 0}</td>
                                                                <td>{player.total_battles || 0}</td>
                                                                <td>{player.total_silver_won || 0}</td>
                                                                <td>{player.total_gold_won || 0}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            )}
                                            
                                            <hr />
                                            
                                            <div className="mb-3">
                                                <Alert variant="info">
                                                    <strong>Total Silver Won (All Players):</strong> {pvpTotalSilverWon.toLocaleString()} silver
                                                    <br />
                                                    <small>This is the total amount of silver won by all players. Use this amount for weekly reward distribution.</small>
                                                </Alert>
                                            </div>
                                            
                                            <h5>All Statistics</h5>
                                            {pvpAllStatistics.length === 0 ? (
                                                <Alert variant="info">No statistics available yet.</Alert>
                                            ) : (
                                                <Table striped bordered hover size="sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Username</th>
                                                            <th>Wins</th>
                                                            <th>Losses</th>
                                                            <th>Total Battles</th>
                                                            <th>Silver Won</th>
                                                            <th>Gold Won</th>
                                                            <th>Pokemon Won</th>
                                                            <th>Items Won</th>
                                                            <th>Exp Won</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {pvpAllStatistics.map((stat) => (
                                                            <tr key={stat.user_id}>
                                                                <td>{stat.username}</td>
                                                                <td>{stat.wins || 0}</td>
                                                                <td>{stat.losses || 0}</td>
                                                                <td>{stat.total_battles || 0}</td>
                                                                <td>{stat.total_silver_won || 0}</td>
                                                                <td>{stat.total_gold_won || 0}</td>
                                                                <td>{stat.total_pokemon_won || 0}</td>
                                                                <td>{stat.total_items_won || 0}</td>
                                                                <td>{stat.total_exp_won || 0}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            )}
                                        </>
                                    )}
                                </Card.Body>
                            </Card>
                            
                            {/* Distribute Rewards */}
                            <Card className="mb-4">
                                <Card.Header>
                                    <h3>Distribute Rewards to Top Players</h3>
                                </Card.Header>
                                <Card.Body>
                                    <Form onSubmit={(e) => { e.preventDefault(); handleDistributePvpRewards(); }}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Total Reward (Silver)</Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={pvpRewardDistribution.total_reward}
                                                onChange={(e) => setPvpRewardDistribution({ ...pvpRewardDistribution, total_reward: parseInt(e.target.value) })}
                                                min="100"
                                            />
                                        </Form.Group>
                                        
                                        <Form.Group className="mb-3">
                                            <Form.Label>Distribution Criteria</Form.Label>
                                            <Form.Select
                                                value={pvpRewardDistribution.criteria}
                                                onChange={(e) => setPvpRewardDistribution({ ...pvpRewardDistribution, criteria: e.target.value })}
                                            >
                                                <option value="wins">Most Wins</option>
                                                <option value="battles">Most Battles</option>
                                            </Form.Select>
                                        </Form.Group>
                                        
                                        <Alert variant="info">
                                            <strong>Distribution:</strong><br />
                                            • 1st Place: {pvpSettings.ranking_reward_first || 50}% of total<br />
                                            • 2nd Place: {pvpSettings.ranking_reward_second || 30}% of total<br />
                                            • 3rd Place: {pvpSettings.ranking_reward_third || 20}% of total<br />
                                            • Places 4-10: {pvpSettings.ranking_reward_default_percent || 10}% of total (minimum 100 silver each)
                                        </Alert>
                                        
                                        <Button variant="success" type="submit" disabled={pvpDistributeLoading}>
                                            {pvpDistributeLoading ? 'Distributing...' : 'Distribute Rewards'}
                                        </Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    )}
                    
                    {/* Menu Management Tab */}
                    {activeTab === 'menu-management' && (
                    <Row className="mt-4">
                        <Col md={12}>
                            <Card className="mb-4">
                                <Card.Header>
                                    <h3>Menu Management</h3>
                                    <p className="text-muted mb-0">Manage which pages appear in the Header, Popup Menu, and Settings Menu</p>
                                </Card.Header>
                                <Card.Body>
                                    {adminMenusLoading ? (
                                        <Alert variant="info">Loading menu settings...</Alert>
                                    ) : adminMenusError ? (
                                        <Alert variant="danger">
                                            <Alert.Heading>Error loading menu settings</Alert.Heading>
                                            <p>{adminMenusError}</p>
                                            <Button variant="outline-danger" onClick={() => dispatch(adminGetMenuSettings())}>
                                                Try Again
                                            </Button>
                                        </Alert>
                                    ) : adminMenus.length === 0 ? (
                                        <Alert variant="warning">
                                            <Alert.Heading>No menu items found</Alert.Heading>
                                            <p>The menu_settings table may not exist yet. Please run the SQL script to create it:</p>
                                            <code>api/create_menu_settings_table.sql</code>
                                            <hr />
                                            <Button variant="outline-warning" onClick={() => dispatch(adminGetMenuSettings())}>
                                                Refresh
                                            </Button>
                                        </Alert>
                                    ) : (
                                        <>
                                            {/* Header Menu Section */}
                                            <Card className="mb-3 border-primary">
                                                <Card.Header className="bg-primary text-white">
                                                    <h5 className="mb-0">Header Menu (Top Navigation Bar)</h5>
                                                </Card.Header>
                                                <Card.Body>
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Active</th>
                                                                <th>Name</th>
                                                                <th>Route</th>
                                                                <th>Order</th>
                                                                <th>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {adminMenus
                                                                .filter(m => m.menu_type === 'header' || menuChanges[m.id]?.menu_type === 'header')
                                                                .sort((a, b) => a.menu_order - b.menu_order)
                                                                .map(menu => (
                                                                    <tr key={menu.id}>
                                                                        <td className="text-center">
                                                                            <Form.Check
                                                                                type="switch"
                                                                                checked={menuChanges[menu.id]?.is_active ?? menu.is_active}
                                                                                onChange={(e) => setMenuChanges({
                                                                                    ...menuChanges,
                                                                                    [menu.id]: { ...menuChanges[menu.id], id: menu.id, is_active: e.target.checked }
                                                                                })}
                                                                            />
                                                                        </td>
                                                                        <td>{menu.menu_name}</td>
                                                                        <td><code>{menu.menu_route}</code></td>
                                                                        <td style={{ width: '80px' }}>
                                                                            <Form.Control
                                                                                type="number"
                                                                                size="sm"
                                                                                value={menuChanges[menu.id]?.menu_order ?? menu.menu_order}
                                                                                onChange={(e) => setMenuChanges({
                                                                                    ...menuChanges,
                                                                                    [menu.id]: { ...menuChanges[menu.id], id: menu.id, menu_order: parseInt(e.target.value) }
                                                                                })}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Button
                                                                                size="sm"
                                                                                variant="outline-secondary"
                                                                                onClick={() => setMenuChanges({
                                                                                    ...menuChanges,
                                                                                    [menu.id]: { ...menuChanges[menu.id], id: menu.id, menu_type: 'popup' }
                                                                                })}
                                                                                title="Move to Popup Menu"
                                                                            >
                                                                                → Popup
                                                                            </Button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </Table>
                                                </Card.Body>
                                            </Card>
                                            
                                            {/* Popup Menu Section */}
                                            <Card className="mb-3 border-success">
                                                <Card.Header className="bg-success text-white">
                                                    <h5 className="mb-0">Popup Menu (Mobile/Hamburger Menu)</h5>
                                                </Card.Header>
                                                <Card.Body>
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Active</th>
                                                                <th>Name</th>
                                                                <th>Route</th>
                                                                <th>Order</th>
                                                                <th>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {adminMenus
                                                                .filter(m => (m.menu_type === 'popup' && menuChanges[m.id]?.menu_type !== 'header' && menuChanges[m.id]?.menu_type !== 'settings') || menuChanges[m.id]?.menu_type === 'popup')
                                                                .sort((a, b) => a.menu_order - b.menu_order)
                                                                .map(menu => (
                                                                    <tr key={menu.id}>
                                                                        <td className="text-center">
                                                                            <Form.Check
                                                                                type="switch"
                                                                                checked={menuChanges[menu.id]?.is_active ?? menu.is_active}
                                                                                onChange={(e) => setMenuChanges({
                                                                                    ...menuChanges,
                                                                                    [menu.id]: { ...menuChanges[menu.id], id: menu.id, is_active: e.target.checked }
                                                                                })}
                                                                            />
                                                                        </td>
                                                                        <td>{menu.menu_name}</td>
                                                                        <td><code>{menu.menu_route}</code></td>
                                                                        <td style={{ width: '80px' }}>
                                                                            <Form.Control
                                                                                type="number"
                                                                                size="sm"
                                                                                value={menuChanges[menu.id]?.menu_order ?? menu.menu_order}
                                                                                onChange={(e) => setMenuChanges({
                                                                                    ...menuChanges,
                                                                                    [menu.id]: { ...menuChanges[menu.id], id: menu.id, menu_order: parseInt(e.target.value) }
                                                                                })}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Button
                                                                                size="sm"
                                                                                variant="outline-primary"
                                                                                className="me-1"
                                                                                onClick={() => setMenuChanges({
                                                                                    ...menuChanges,
                                                                                    [menu.id]: { ...menuChanges[menu.id], id: menu.id, menu_type: 'header' }
                                                                                })}
                                                                                title="Move to Header"
                                                                            >
                                                                                ← Header
                                                                            </Button>
                                                                            <Button
                                                                                size="sm"
                                                                                variant="outline-warning"
                                                                                onClick={() => setMenuChanges({
                                                                                    ...menuChanges,
                                                                                    [menu.id]: { ...menuChanges[menu.id], id: menu.id, menu_type: 'settings' }
                                                                                })}
                                                                                title="Move to Settings"
                                                                            >
                                                                                → Settings
                                                                            </Button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </Table>
                                                </Card.Body>
                                            </Card>
                                            
                                            {/* Settings Menu Section */}
                                            <Card className="mb-3 border-warning">
                                                <Card.Header className="bg-warning text-dark">
                                                    <h5 className="mb-0">Settings Menu</h5>
                                                </Card.Header>
                                                <Card.Body>
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Active</th>
                                                                <th>Name</th>
                                                                <th>Route</th>
                                                                <th>Order</th>
                                                                <th>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {adminMenus
                                                                .filter(m => (m.menu_type === 'settings' && menuChanges[m.id]?.menu_type !== 'popup' && menuChanges[m.id]?.menu_type !== 'header') || menuChanges[m.id]?.menu_type === 'settings')
                                                                .sort((a, b) => a.menu_order - b.menu_order)
                                                                .map(menu => (
                                                                    <tr key={menu.id}>
                                                                        <td className="text-center">
                                                                            <Form.Check
                                                                                type="switch"
                                                                                checked={menuChanges[menu.id]?.is_active ?? menu.is_active}
                                                                                onChange={(e) => setMenuChanges({
                                                                                    ...menuChanges,
                                                                                    [menu.id]: { ...menuChanges[menu.id], id: menu.id, is_active: e.target.checked }
                                                                                })}
                                                                            />
                                                                        </td>
                                                                        <td>{menu.menu_name}</td>
                                                                        <td><code>{menu.menu_route}</code></td>
                                                                        <td style={{ width: '80px' }}>
                                                                            <Form.Control
                                                                                type="number"
                                                                                size="sm"
                                                                                value={menuChanges[menu.id]?.menu_order ?? menu.menu_order}
                                                                                onChange={(e) => setMenuChanges({
                                                                                    ...menuChanges,
                                                                                    [menu.id]: { ...menuChanges[menu.id], id: menu.id, menu_order: parseInt(e.target.value) }
                                                                                })}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Button
                                                                                size="sm"
                                                                                variant="outline-success"
                                                                                onClick={() => setMenuChanges({
                                                                                    ...menuChanges,
                                                                                    [menu.id]: { ...menuChanges[menu.id], id: menu.id, menu_type: 'popup' }
                                                                                })}
                                                                                title="Move to Popup Menu"
                                                                            >
                                                                                ← Popup
                                                                            </Button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </Table>
                                                </Card.Body>
                                            </Card>
                                            
                                            {/* Save Changes Button */}
                                            <div className="d-flex justify-content-between">
                                                <Button
                                                    variant="secondary"
                                                    onClick={() => setMenuChanges({})}
                                                    disabled={Object.keys(menuChanges).length === 0}
                                                >
                                                    Reset Changes
                                                </Button>
                                                <Button
                                                    variant="primary"
                                                    disabled={menuUpdateLoading || Object.keys(menuChanges).length === 0}
                                                    onClick={async () => {
                                                        const menus = Object.values(menuChanges).map(change => ({
                                                            id: change.id,
                                                            is_active: change.is_active,
                                                            menu_order: change.menu_order,
                                                            menu_type: change.menu_type
                                                        }));
                                                        await dispatch(adminUpdateMenuSettings({ action: 'bulk_update', menus }));
                                                        setMenuChanges({});
                                                        dispatch(adminGetMenuSettings());
                                                    }}
                                                >
                                                    {menuUpdateLoading ? 'Saving...' : `Save Changes (${Object.keys(menuChanges).length})`}
                                                </Button>
                                            </div>
                                        </>
                                    )}
                                </Card.Body>
                            </Card>
                            
                            {/* Add New Menu Item */}
                            <Card>
                                <Card.Header>
                                    <h5>Add New Menu Item</h5>
                                </Card.Header>
                                <Card.Body>
                                    <Form onSubmit={async (e) => {
                                        e.preventDefault();
                                        await dispatch(adminUpdateMenuSettings({ action: 'add', ...newMenuItem }));
                                        setNewMenuItem({ menu_key: '', menu_name: '', menu_route: '', menu_type: 'popup' });
                                        dispatch(adminGetMenuSettings());
                                    }}>
                                        <Row>
                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Key (unique identifier)</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="e.g. my-page"
                                                        value={newMenuItem.menu_key}
                                                        onChange={(e) => setNewMenuItem({ ...newMenuItem, menu_key: e.target.value })}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Display Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="e.g. My Page"
                                                        value={newMenuItem.menu_name}
                                                        onChange={(e) => setNewMenuItem({ ...newMenuItem, menu_name: e.target.value })}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Route</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="e.g. /my-page"
                                                        value={newMenuItem.menu_route}
                                                        onChange={(e) => setNewMenuItem({ ...newMenuItem, menu_route: e.target.value })}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Menu Type</Form.Label>
                                                    <Form.Select
                                                        value={newMenuItem.menu_type}
                                                        onChange={(e) => setNewMenuItem({ ...newMenuItem, menu_type: e.target.value })}
                                                    >
                                                        <option value="header">Header</option>
                                                        <option value="popup">Popup</option>
                                                        <option value="settings">Settings</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Button variant="success" type="submit" disabled={menuUpdateLoading}>
                                            Add Menu Item
                                        </Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    )}
                    
                    {/* Battle Settings Tab */}
                    {activeTab === 'battle-settings' && (
                    <Row className="mt-4">
                        <Col md={12}>
                            <Card>
                                <Card.Header>
                                    <h3>Battle Settings</h3>
                                    <p className="text-muted mb-0">Configure battle and attack display settings</p>
                                </Card.Header>
                                <Card.Body>
                                    {battleSettingsLoading ? (
                                        <Alert variant="info">Loading battle settings...</Alert>
                                    ) : (
                                        <Form onSubmit={async (e) => {
                                            e.preventDefault();
                                            await dispatch(adminUpdateBattleSettings({
                                                show_default_attacks: showDefaultAttacks,
                                                default_attacks_count: defaultAttacksCount,
                                                battle_timer_seconds: battleTimerSeconds,
                                                healing_time_seconds: healingTimeSeconds,
                                                enemy_strength_percent: enemyStrengthPercent,
                                                player_strength_percent: playerStrengthPercent
                                            }));
                                            dispatch(adminGetBattleSettings());
                                        }}>
                                            <Card className="mb-4 border-primary">
                                                <Card.Header className="bg-primary text-white">
                                                    <strong>Attack Display Settings</strong>
                                                </Card.Header>
                                                <Card.Body>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label><strong>Show Default Attacks</strong></Form.Label>
                                                        <Form.Select
                                                            value={showDefaultAttacks}
                                                            onChange={(e) => setShowDefaultAttacks(e.target.value)}
                                                        >
                                                            <option value="0">No - Show only Pokemon's actual attacks</option>
                                                            <option value="1">Yes - Fill with default attacks if less than 4</option>
                                                        </Form.Select>
                                                        <Form.Text className="text-muted">
                                                            When enabled, if a Pokemon has fewer than the specified number of attacks, 
                                                            the remaining slots will be filled with generic attacks (Tackle, Scratch, etc.)
                                                        </Form.Text>
                                                    </Form.Group>
                                                    
                                                    {showDefaultAttacks === '1' && (
                                                        <Form.Group className="mb-3">
                                                            <Form.Label><strong>Number of Attack Slots</strong></Form.Label>
                                                            <Form.Select
                                                                value={defaultAttacksCount}
                                                                onChange={(e) => setDefaultAttacksCount(e.target.value)}
                                                            >
                                                                <option value="2">2 attacks</option>
                                                                <option value="3">3 attacks</option>
                                                                <option value="4">4 attacks</option>
                                                            </Form.Select>
                                                            <Form.Text className="text-muted">
                                                                Fill up to this many attack slots with default attacks
                                                            </Form.Text>
                                                        </Form.Group>
                                                    )}
                                                </Card.Body>
                                            </Card>
                                            
                                            <Card className="mb-4 border-info">
                                                <Card.Header className="bg-info text-white">
                                                    <strong>Timer Settings</strong>
                                                </Card.Header>
                                                <Card.Body>
                                                    <Row>
                                                        <Col md={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label><strong>Battle Timer (seconds)</strong></Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    value={battleTimerSeconds}
                                                                    onChange={(e) => setBattleTimerSeconds(e.target.value)}
                                                                    min="60"
                                                                    max="600"
                                                                />
                                                                <Form.Text className="text-muted">
                                                                    Time limit for each battle (default: 180 = 3 minutes)
                                                                </Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label><strong>Healing Time per Pokemon (seconds)</strong></Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    value={healingTimeSeconds}
                                                                    onChange={(e) => setHealingTimeSeconds(e.target.value)}
                                                                    min="10"
                                                                    max="600"
                                                                />
                                                                <Form.Text className="text-muted">
                                                                    Time to heal each Pokemon at the hospital (default: 180 = 3 minutes)
                                                                </Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                            
                                            <Card className="mb-4 border-warning">
                                                <Card.Header className="bg-warning text-dark">
                                                    <strong>⚔️ Battle Strength Settings</strong>
                                                </Card.Header>
                                                <Card.Body>
                                                    <Row>
                                                        <Col md={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label><strong>Enemy Strength (%)</strong></Form.Label>
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <Form.Range
                                                                        value={enemyStrengthPercent}
                                                                        onChange={(e) => setEnemyStrengthPercent(e.target.value)}
                                                                        min="0"
                                                                        max="200"
                                                                        step="5"
                                                                        style={{ flex: 1 }}
                                                                    />
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={enemyStrengthPercent}
                                                                        onChange={(e) => setEnemyStrengthPercent(e.target.value)}
                                                                        min="0"
                                                                        max="200"
                                                                        style={{ width: '80px' }}
                                                                    />
                                                                    <span>%</span>
                                                                </div>
                                                                <Form.Text className="text-muted">
                                                                    <ul className="mb-0 mt-2">
                                                                        <li><strong>0%</strong> = Enemies deal no damage (very easy)</li>
                                                                        <li><strong>50%</strong> = Enemies deal half damage (easy)</li>
                                                                        <li><strong>100%</strong> = Normal damage (default)</li>
                                                                        <li><strong>150%</strong> = Enemies deal 1.5x damage (hard)</li>
                                                                        <li><strong>200%</strong> = Enemies deal double damage (very hard)</li>
                                                                    </ul>
                                                                </Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label><strong>Player Strength (%)</strong></Form.Label>
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <Form.Range
                                                                        value={playerStrengthPercent}
                                                                        onChange={(e) => setPlayerStrengthPercent(e.target.value)}
                                                                        min="0"
                                                                        max="200"
                                                                        step="5"
                                                                        style={{ flex: 1 }}
                                                                    />
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={playerStrengthPercent}
                                                                        onChange={(e) => setPlayerStrengthPercent(e.target.value)}
                                                                        min="0"
                                                                        max="200"
                                                                        style={{ width: '80px' }}
                                                                    />
                                                                    <span>%</span>
                                                                </div>
                                                                <Form.Text className="text-muted">
                                                                    <ul className="mb-0 mt-2">
                                                                        <li><strong>50%</strong> = Player deals half damage</li>
                                                                        <li><strong>100%</strong> = Normal damage (default)</li>
                                                                        <li><strong>150%</strong> = Player deals 1.5x damage</li>
                                                                        <li><strong>200%</strong> = Player deals double damage</li>
                                                                    </ul>
                                                                </Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Alert variant="info" className="mb-0">
                                                        <strong>💡 Tip:</strong> To make battles easier, lower enemy strength (e.g., 50%) or increase player strength (e.g., 150%).
                                                    </Alert>
                                                </Card.Body>
                                            </Card>
                                            
                                            <Button variant="primary" type="submit" disabled={battleSettingsUpdateLoading}>
                                                {battleSettingsUpdateLoading ? 'Saving...' : 'Save Battle Settings'}
                                            </Button>
                                        </Form>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    )}
                    
                    {/* Ad Tags Management Tab */}
                    {activeTab === 'ad-tags-management' && isAdmin && (
                        <Row className="mt-4">
                            <Col md={12}>
                                <Card>
                                    <Card.Header>
                                        <h3>Ad Tags Management</h3>
                                        <p className="text-muted mb-0">Manage advertisement tags displayed in the header</p>
                                    </Card.Header>
                                    <Card.Body>
                                        {adTagsLoading ? (
                                            <Alert variant="info">Loading ad tags...</Alert>
                                        ) : (
                                            <>
                                                {/* Add New Ad Tag Form */}
                                                <Card className="mb-4 border-primary">
                                                    <Card.Header className="bg-primary text-white">
                                                        <h5 className="mb-0">Add New Ad Tag</h5>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <Row>
                                                            <Col md={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Tag Name *</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        value={newAdTag.tag_name}
                                                                        onChange={(e) => setNewAdTag({ ...newAdTag, tag_name: e.target.value })}
                                                                        placeholder="e.g. Google Ads Header"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={3}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Position *</Form.Label>
                                                                    <Form.Select
                                                                        value={newAdTag.position}
                                                                        onChange={(e) => setNewAdTag({ ...newAdTag, position: e.target.value })}
                                                                    >
                                                                        <option value="header_top">Header Top</option>
                                                                        <option value="header_bottom">Header Bottom</option>
                                                                        <option value="header_left">Header Left</option>
                                                                        <option value="header_right">Header Right</option>
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={2}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Display Order</Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={newAdTag.display_order}
                                                                        onChange={(e) => setNewAdTag({ ...newAdTag, display_order: parseInt(e.target.value) || 0 })}
                                                                        min="0"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={2}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Active</Form.Label>
                                                                    <Form.Check
                                                                        type="switch"
                                                                        checked={newAdTag.is_active === 1}
                                                                        onChange={(e) => setNewAdTag({ ...newAdTag, is_active: e.target.checked ? 1 : 0 })}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Ad Tag Code (HTML/JavaScript) *</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={5}
                                                                value={newAdTag.tag_code}
                                                                onChange={(e) => setNewAdTag({ ...newAdTag, tag_code: e.target.value })}
                                                                placeholder="Paste your ad tag code here (e.g., Google AdSense, etc.)"
                                                            />
                                                            <Form.Text className="text-muted">
                                                                Paste the complete ad tag code including &lt;script&gt; tags
                                                            </Form.Text>
                                                        </Form.Group>
                                                        <Button variant="primary" onClick={handleAddAdTag} disabled={adTagsUpdateLoading}>
                                                            {adTagsUpdateLoading ? 'Adding...' : 'Add Ad Tag'}
                                                        </Button>
                                                    </Card.Body>
                                                </Card>
                                                
                                                {/* Existing Ad Tags Table */}
                                                <Card>
                                                    <Card.Header className="bg-secondary text-white">
                                                        <h5 className="mb-0">Existing Ad Tags</h5>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        {adTags.length === 0 ? (
                                                            <Alert variant="info">No ad tags found. Add your first ad tag above.</Alert>
                                                        ) : (
                                                            <Table striped bordered hover>
                                                                <thead>
                                                                    <tr>
                                                                        <th>ID</th>
                                                                        <th>Name</th>
                                                                        <th>Position</th>
                                                                        <th>Order</th>
                                                                        <th>Active</th>
                                                                        <th>Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {adTags
                                                                        .sort((a, b) => a.display_order - b.display_order)
                                                                        .map((tag) => (
                                                                            <tr key={tag.id}>
                                                                                <td>{tag.id}</td>
                                                                                <td>{tag.tag_name}</td>
                                                                                <td>
                                                                                    <Badge bg="info">{tag.position}</Badge>
                                                                                </td>
                                                                                <td>{tag.display_order}</td>
                                                                                <td>
                                                                                    <Form.Check
                                                                                        type="switch"
                                                                                        checked={tag.is_active === 1}
                                                                                        onChange={(e) => handleUpdateAdTag({ ...tag, is_active: e.target.checked ? 1 : 0 })}
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <Button
                                                                                        size="sm"
                                                                                        variant="danger"
                                                                                        onClick={() => handleDeleteAdTag(tag.id)}
                                                                                        className="me-2"
                                                                                    >
                                                                                        Delete
                                                                                    </Button>
                                                                                    <Button
                                                                                        size="sm"
                                                                                        variant="info"
                                                                                        onClick={() => {
                                                                                            setNewAdTag({
                                                                                                tag_name: tag.tag_name,
                                                                                                tag_code: tag.tag_code,
                                                                                                position: tag.position,
                                                                                                display_order: tag.display_order,
                                                                                                is_active: tag.is_active
                                                                                            });
                                                                                            // Scroll to top
                                                                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                                        }}
                                                                                    >
                                                                                        Edit
                                                                                    </Button>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                </tbody>
                                                            </Table>
                                                        )}
                                                    </Card.Body>
                                                </Card>
                                            </>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}
                    
                    {/* Maps Management Tab */}
                    {activeTab === 'maps-management' && adminLevel >= 3 && (
                        <Row className="mt-4">
                            <Col md={12}>
                                <Card>
                                    <Card.Header>
                                        <h3>Maps Management</h3>
                                        <p className="text-muted mb-0">Create and manage maps with clickable points</p>
                                    </Card.Header>
                                    <Card.Body>
                                        <div className="d-flex justify-content-between mb-3">
                                            <h5>Maps</h5>
                                            <Button variant="primary" onClick={() => {
                                                setEditingMap(null);
                                                setNewMap({ name: '', image_path: '', city_id: null, city_name: '', order: 0, is_active: 1 });
                                                setCitySearch('');
                                                setCities([]);
                                                setShowMapModal(true);
                                            }}>
                                                + Add New Map
                                            </Button>
                                        </div>
                                        
                                        {mapsLoading ? (
                                            <Alert variant="info">Loading maps...</Alert>
                                        ) : maps.length === 0 ? (
                                            <Alert variant="warning">No maps found. Create your first map!</Alert>
                                        ) : (
                                            <Row>
                                                {maps.map((map) => (
                                                    <Col md={4} key={map.id} className="mb-3">
                                                        <Card className={selectedMap?.id === map.id ? 'border-primary' : ''} style={{ cursor: 'pointer' }} onClick={() => setSelectedMap(map)}>
                                                            <Card.Img variant="top" src={map.image_path} style={{ height: '150px', objectFit: 'cover' }} onError={(e) => { e.target.src = '/images/loading.gif'; }} />
                                                            <Card.Body>
                                                                <Card.Title>
                                                                    {map.name}
                                                                    {map.required_level > 0 && (
                                                                        <small className="text-muted ms-2">(Level {map.required_level}+)</small>
                                                                    )}
                                                                </Card.Title>
                                                                <Card.Text>
                                                                    {map.city_name && <small className="text-muted">City: {map.city_name}<br /></small>}
                                                                    <small className="text-muted">Order: {map.order}</small>
                                                                    {map.required_level > 0 && (
                                                                        <><br /><small className="text-warning">Required Level: {map.required_level}</small></>
                                                                    )}
                                                                </Card.Text>
                                                                <div className="d-flex gap-2">
                                                                    <Button variant="info" size="sm" onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setEditingMap({
                                                                            ...map,
                                                                            required_level: map.required_level || 0
                                                                        });
                                                                        setCitySearch(map.city_name || '');
                                                                        setCities([]);
                                                                        setShowMapModal(true);
                                                                    }}>
                                                                        Edit
                                                                    </Button>
                                                                    <Button variant="danger" size="sm" onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleDeleteMap(map.id);
                                                                    }}>
                                                                        Delete
                                                                    </Button>
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                ))}
                                            </Row>
                                        )}
                                        
                                        {selectedMap && (
                                            <div className="ar_market_table_area mt-4">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h5 className="mb-0">Map Points - {selectedMap.name}</h5>
                                                    <Button variant="primary" size="sm" onClick={() => {
                                                        setEditingPoint(null);
                                                        setNewPoint({ map_id: selectedMap.id, name: '', gebied: '', point_type: 'battle', target_url: '', x: 0, y: 0, width: 100, height: 100, tooltip: '', is_active: 1, required_level: 0, required_attacks: 0, next_point_id: null, trainer_id: null, silver_cost: null, trainer_image: null });
                                                        setShowPointModal(true);
                                                    }}>
                                                        + Add Point
                                                    </Button>
                                                </div>
                                                <Alert variant="info" className="mb-3">
                                                    <strong>💡 Tip:</strong> Click anywhere on the map image to add a new point at that location!
                                                </Alert>
                                                <div className="mb-3 d-flex gap-2 align-items-center flex-wrap">
                                                    <Button 
                                                        variant={drawMode ? "success" : "outline-secondary"} 
                                                        size="sm"
                                                        onClick={() => {
                                                            setDrawMode(!drawMode);
                                                            if (drawMode) {
                                                                setDrawing(false);
                                                                setDrawStart(null);
                                                                setDrawEnd(null);
                                                            }
                                                        }}
                                                    >
                                                        {drawMode ? "✓ Drawing Mode" : "✏️ Drawing Mode"}
                                                    </Button>
                                                    {drawMode && (
                                                        <>
                                                            <Button 
                                                                variant={drawTool === 'line' ? "primary" : "outline-primary"} 
                                                                size="sm"
                                                                onClick={() => setDrawTool('line')}
                                                            >
                                                                📏 Line
                                                            </Button>
                                                            <Button 
                                                                variant={drawTool === 'rectangle' ? "primary" : "outline-primary"} 
                                                                size="sm"
                                                                onClick={() => setDrawTool('rectangle')}
                                                            >
                                                                ▭ Rectangle
                                                            </Button>
                                                            <Button 
                                                                variant={showGrid ? "success" : "outline-secondary"} 
                                                                size="sm"
                                                                onClick={() => setShowGrid(!showGrid)}
                                                            >
                                                                {showGrid ? "✓ Grid" : "⊞ Grid"}
                                                            </Button>
                                                            <Form.Control
                                                                type="number"
                                                                placeholder="Grid size"
                                                                value={gridSize}
                                                                onChange={(e) => setGridSize(parseInt(e.target.value) || 50)}
                                                                style={{ width: '100px' }}
                                                                size="sm"
                                                                min="10"
                                                                max="200"
                                                            />
                                                            <Button 
                                                                variant="danger" 
                                                                size="sm"
                                                                onClick={() => {
                                                                    setDrawings([]);
                                                                    setDrawStart(null);
                                                                    setDrawEnd(null);
                                                                }}
                                                            >
                                                                🗑️ Clear All
                                                            </Button>
                                                            {drawings.filter(d => d.type === 'rectangle').length > 0 && (
                                                                <Button 
                                                                    variant="success" 
                                                                    size="sm"
                                                                    onClick={handleCreatePointsFromRectangles}
                                                                >
                                                                    ✓ Done - Create Points ({drawings.filter(d => d.type === 'rectangle').length})
                                                                </Button>
                                                            )}
                                                        </>
                                                    )}
                                                    <Button 
                                                        variant={moveMode ? "success" : "outline-secondary"} 
                                                        size="sm"
                                                        onClick={() => {
                                                            setMoveMode(!moveMode);
                                                            if (moveMode) {
                                                                setDraggingPoint(null);
                                                                setDragOffset({ x: 0, y: 0 });
                                                            }
                                                        }}
                                                    >
                                                        {moveMode ? "✓ Moving Mode" : "✏️ Moving Mode"}
                                                    </Button>
                                                </div>
                                                <div 
                                                    ref={(el) => setMapContainerRef(el)}
                                                    className="position-relative" 
                                                    style={{ 
                                                        border: '2px solid #ccc', 
                                                        minHeight: '700px',
                                                        maxWidth: '1200px',
                                                        margin: '0 auto',
                                                        maxHeight: '800px',
                                                        backgroundImage: `url(${selectedMap.image_path})`, 
                                                        backgroundSize: 'contain', 
                                                        backgroundRepeat: 'no-repeat', 
                                                        backgroundPosition: 'center',
                                                        backgroundAttachment: 'local',
                                                        cursor: drawMode ? (drawTool === 'line' ? 'crosshair' : 'crosshair') : 'crosshair'
                                                    }}
                                                        onMouseDown={(e) => {
                                                            if (drawMode && !drawing) {
                                                                const rect = mapContainerRef?.getBoundingClientRect();
                                                                if (rect && mapContainerRef && originalImageSize.width && originalImageSize.height) {
                                                                    // Use mapImageSize if available for consistency, otherwise recalculate
                                                                    let displayedWidth, displayedHeight;
                                                                    if (mapImageSize.width > 0 && mapImageSize.height > 0) {
                                                                        displayedWidth = mapImageSize.width;
                                                                        displayedHeight = mapImageSize.height;
                                                                    } else {
                                                                        const containerAspect = rect.width / rect.height;
                                                                        const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                        
                                                                        if (imageAspect > containerAspect) {
                                                                            displayedWidth = rect.width;
                                                                            displayedHeight = rect.width / imageAspect;
                                                                        } else {
                                                                            displayedHeight = rect.height;
                                                                            displayedWidth = rect.height * imageAspect;
                                                                        }
                                                                    }
                                                                    
                                                                    const containerAspect = rect.width / rect.height;
                                                                    const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                    
                                                                    let offsetX = 0, offsetY = 0;
                                                                    if (imageAspect > containerAspect) {
                                                                        offsetY = (rect.height - displayedHeight) / 2;
                                                                    } else {
                                                                        offsetX = (rect.width - displayedWidth) / 2;
                                                                    }
                                                                    
                                                                    // Calculate click position relative to container
                                                                    // e.clientX/Y are relative to viewport, rect.left/top are also relative to viewport
                                                                    // So e.clientX - rect.left gives position relative to container
                                                                    const clickX = e.clientX - rect.left - offsetX;
                                                                    const clickY = e.clientY - rect.top - offsetY;
                                                                    
                                                                    // Validate click is within displayed image bounds
                                                                    if (clickX >= 0 && clickX <= displayedWidth && clickY >= 0 && clickY <= displayedHeight) {
                                                                        setDrawing(true);
                                                                        setDrawStart({ x: clickX, y: clickY });
                                                                        setDrawEnd({ x: clickX, y: clickY });
                                                                    }
                                                                }
                                                            }
                                                        }}
                                                        onMouseMove={(e) => {
                                                            // Handle dragging points in move mode
                                                            if (moveMode && draggingPoint && mapContainerRef && originalImageSize.width && originalImageSize.height) {
                                                                const rect = mapContainerRef.getBoundingClientRect();
                                                                
                                                                let displayedWidth, displayedHeight;
                                                                if (mapImageSize.width > 0 && mapImageSize.height > 0) {
                                                                    displayedWidth = mapImageSize.width;
                                                                    displayedHeight = mapImageSize.height;
                                                                } else {
                                                                    const containerAspect = rect.width / rect.height;
                                                                    const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                    if (imageAspect > containerAspect) {
                                                                        displayedWidth = rect.width;
                                                                        displayedHeight = rect.width / imageAspect;
                                                                    } else {
                                                                        displayedHeight = rect.height;
                                                                        displayedWidth = rect.height * imageAspect;
                                                                    }
                                                                }
                                                                
                                                                const containerAspect = rect.width / rect.height;
                                                                const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                let offsetX = 0, offsetY = 0;
                                                                if (imageAspect > containerAspect) {
                                                                    offsetY = (rect.height - displayedHeight) / 2;
                                                                } else {
                                                                    offsetX = (rect.width - displayedWidth) / 2;
                                                                }
                                                                
                                                                // Calculate new position
                                                                // Mouse position in container coordinates
                                                                const mouseXInContainer = e.clientX - rect.left;
                                                                const mouseYInContainer = e.clientY - rect.top;
                                                                
                                                                // Calculate new point position so the dragOffset stays under the mouse
                                                                const newPointLeft = mouseXInContainer - dragOffset.x;
                                                                const newPointTop = mouseYInContainer - dragOffset.y;
                                                                
                                                                // Convert to percentage relative to displayed image (subtract offset first)
                                                                const newXPercent = Math.max(0, Math.min(100, ((newPointLeft - offsetX) / displayedWidth) * 100));
                                                                const newYPercent = Math.max(0, Math.min(100, ((newPointTop - offsetY) / displayedHeight) * 100));
                                                                
                                                                // Update point position in state (temporary, will save on mouse up)
                                                                setMapPoints(prevPoints => prevPoints.map(p => 
                                                                    p.id === draggingPoint.id 
                                                                        ? { ...p, x: newXPercent, y: newYPercent }
                                                                        : p
                                                                ));
                                                            }
                                                            
                                                            if (drawMode && drawing && drawStart && mapContainerRef && originalImageSize.width && originalImageSize.height) {
                                                                const rect = mapContainerRef.getBoundingClientRect();
                                                                
                                                                // Use mapImageSize if available for consistency, otherwise recalculate
                                                                let displayedWidth, displayedHeight;
                                                                if (mapImageSize.width > 0 && mapImageSize.height > 0) {
                                                                    displayedWidth = mapImageSize.width;
                                                                    displayedHeight = mapImageSize.height;
                                                                } else {
                                                                    const containerAspect = rect.width / rect.height;
                                                                    const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                    
                                                                    if (imageAspect > containerAspect) {
                                                                        displayedWidth = rect.width;
                                                                        displayedHeight = rect.width / imageAspect;
                                                                    } else {
                                                                        displayedHeight = rect.height;
                                                                        displayedWidth = rect.height * imageAspect;
                                                                    }
                                                                }
                                                                
                                                                const containerAspect = rect.width / rect.height;
                                                                const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                
                                                                let offsetX = 0, offsetY = 0;
                                                                if (imageAspect > containerAspect) {
                                                                    offsetY = (rect.height - displayedHeight) / 2;
                                                                } else {
                                                                    offsetX = (rect.width - displayedWidth) / 2;
                                                                }
                                                                
                                                                // Calculate move position relative to container
                                                                // e.clientX/Y are relative to viewport, rect.left/top are also relative to viewport
                                                                const moveX = e.clientX - rect.left - offsetX;
                                                                const moveY = e.clientY - rect.top - offsetY;
                                                                
                                                                // Clamp to displayed image bounds
                                                                const clampedX = Math.max(0, Math.min(displayedWidth, moveX));
                                                                const clampedY = Math.max(0, Math.min(displayedHeight, moveY));
                                                                
                                                                setDrawEnd({ x: clampedX, y: clampedY });
                                                            }
                                                        }}
                                                        onMouseUp={(e) => {
                                                            // Handle end of dragging
                                                            if (moveMode && draggingPoint) {
                                                                // Save the new position
                                                                const updatedPoint = mapPoints.find(p => p.id === draggingPoint.id);
                                                                if (updatedPoint && (updatedPoint.x !== draggingPoint.x || updatedPoint.y !== draggingPoint.y)) {
                                                                    // Update the point via API
                                                                    handleUpdatePointPosition(draggingPoint.id, updatedPoint.x, updatedPoint.y);
                                                                }
                                                                setDraggingPoint(null);
                                                                setDragOffset({ x: 0, y: 0 });
                                                                // Set flag to prevent onClick from opening modal
                                                                setJustFinishedDragging(true);
                                                                // Clear the flag after a short delay to allow normal clicks again
                                                                setTimeout(() => {
                                                                    setJustFinishedDragging(false);
                                                                }, 100);
                                                            }
                                                            
                                                            if (drawMode && drawing && drawStart && drawEnd && mapContainerRef && originalImageSize.width && originalImageSize.height) {
                                                                const rect = mapContainerRef.getBoundingClientRect();
                                                                
                                                                // Use mapImageSize if available for consistency, otherwise recalculate
                                                                let displayedWidth, displayedHeight;
                                                                if (mapImageSize.width > 0 && mapImageSize.height > 0) {
                                                                    displayedWidth = mapImageSize.width;
                                                                    displayedHeight = mapImageSize.height;
                                                                } else {
                                                                    const containerAspect = rect.width / rect.height;
                                                                    const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                    
                                                                    if (imageAspect > containerAspect) {
                                                                        displayedWidth = rect.width;
                                                                        displayedHeight = rect.width / imageAspect;
                                                                    } else {
                                                                        displayedHeight = rect.height;
                                                                        displayedWidth = rect.height * imageAspect;
                                                                    }
                                                                }
                                                                
                                                                const containerAspect = rect.width / rect.height;
                                                                const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                
                                                                let offsetX = 0, offsetY = 0;
                                                                if (imageAspect > containerAspect) {
                                                                    offsetY = (rect.height - displayedHeight) / 2;
                                                                } else {
                                                                    offsetX = (rect.width - displayedWidth) / 2;
                                                                }
                                                                
                                                                // Recalculate end position to ensure accuracy
                                                                const endX = e.clientX - rect.left - offsetX;
                                                                const endY = e.clientY - rect.top - offsetY;
                                                                
                                                                // Use the drawEnd from state (which is updated in real-time) for better accuracy
                                                                // But validate it's within bounds
                                                                const finalEnd = { 
                                                                    x: Math.max(0, Math.min(displayedWidth, drawEnd.x)), 
                                                                    y: Math.max(0, Math.min(displayedHeight, drawEnd.y))
                                                                };
                                                                
                                                                console.log('Saving rectangle:', {
                                                                    drawStart,
                                                                    drawEnd,
                                                                    finalEnd,
                                                                    calculatedEnd: { x: endX, y: endY },
                                                                    displayedWidth,
                                                                    displayedHeight,
                                                                    offsetX,
                                                                    offsetY,
                                                                    containerRect: { width: rect.width, height: rect.height },
                                                                    originalImageSize: { width: originalImageSize.width, height: originalImageSize.height },
                                                                    mapImageSize: mapImageSize
                                                                });
                                                                
                                                                // Add to drawings array
                                                                // Store displayedWidth and displayedHeight with the rectangle to ensure consistent conversion
                                                                const newDrawing = {
                                                                    id: Date.now(),
                                                                    type: drawTool,
                                                                    start: drawStart,
                                                                    end: finalEnd,
                                                                    color: drawTool === 'line' ? '#ff0000' : '#00ff00',
                                                                    displayedWidth: displayedWidth, // Store for consistent conversion
                                                                    displayedHeight: displayedHeight // Store for consistent conversion
                                                                };
                                                                
                                                                setDrawings([...drawings, newDrawing]);
                                                                setDrawing(false);
                                                                setDrawStart(null);
                                                                setDrawEnd(null);
                                                            }
                                                        }}
                                                        onClick={(e) => {
                                                            // Only handle click if not in draw mode
                                                            if (drawMode) return;
                                                            
                                                            // Don't open modal if in move mode (we're just moving points, not adding new ones)
                                                            if (moveMode) return;
                                                            
                                                            // Don't open modal if we just finished dragging in move mode
                                                            if (justFinishedDragging) {
                                                                return;
                                                            }
                                                            
                                                            // Check if click was on a point (don't open modal if clicking existing point)
                                                            const clickedOnPoint = e.target !== e.currentTarget && !e.target.classList.contains('map-background-clickable');
                                                            
                                                            if (!clickedOnPoint && mapContainerRef && originalImageSize.width && originalImageSize.height) {
                                                                const rect = mapContainerRef.getBoundingClientRect();
                                                                const containerAspect = rect.width / rect.height;
                                                                const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                
                                                                let displayedWidth, displayedHeight;
                                                                if (imageAspect > containerAspect) {
                                                                    displayedWidth = rect.width;
                                                                    displayedHeight = rect.width / imageAspect;
                                                                } else {
                                                                    displayedHeight = rect.height;
                                                                    displayedWidth = rect.height * imageAspect;
                                                                }
                                                                
                                                                let offsetX = 0, offsetY = 0;
                                                                if (imageAspect > containerAspect) {
                                                                    offsetY = (rect.height - displayedHeight) / 2;
                                                                } else {
                                                                    offsetX = (rect.width - displayedWidth) / 2;
                                                                }
                                                                
                                                                const clickX = e.clientX - rect.left - offsetX;
                                                                const clickY = e.clientY - rect.top - offsetY;
                                                                
                                                                const x = (clickX / displayedWidth) * 100;
                                                                const y = (clickY / displayedHeight) * 100;
                                                                
                                                                // Set default size (can be adjusted in modal)
                                                                const defaultWidth = 100;
                                                                const defaultHeight = 100;
                                                                
                                                                if (selectedMap && selectedMap.id) {
                                                                    setNewPoint({ 
                                                                        map_id: selectedMap.id, 
                                                                        name: '', 
                                                                        gebied: '', 
                                                                        point_type: 'battle',
                                                                        target_url: '',
                                                                        x: Math.max(0, Math.min(100, x)), 
                                                                        y: Math.max(0, Math.min(100, y)), 
                                                                        width: defaultWidth, 
                                                                        height: defaultHeight, 
                                                                        tooltip: '', 
                                                                        is_active: 1,
                                                                        required_level: 0
                                                                    });
                                                                    setEditingPoint(null);
                                                                    setShowPointModal(true);
                                                                } else {
                                                                    toast.error('Please select a map first');
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        {mapPointsLoading ? (
                                                            <div className="text-center p-5">
                                                                <Alert variant="info">Loading points...</Alert>
                                                            </div>
                                                        ) : (
                                                            <>
                                                                {/* Grid overlay */}
                                                                {showGrid && mapContainerRef && mapImageSize.width && mapImageSize.height && originalImageSize.width && originalImageSize.height && (
                                                                    <div
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: 0,
                                                                            left: 0,
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            pointerEvents: 'none',
                                                                            zIndex: 1
                                                                        }}
                                                                    >
                                                                        {(() => {
                                                                            const containerRect = mapContainerRef.getBoundingClientRect();
                                                                            const containerAspect = containerRect.width / containerRect.height;
                                                                            const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                            
                                                                            let displayedWidth, displayedHeight;
                                                                            if (imageAspect > containerAspect) {
                                                                                displayedWidth = containerRect.width;
                                                                                displayedHeight = containerRect.width / imageAspect;
                                                                            } else {
                                                                                displayedHeight = containerRect.height;
                                                                                displayedWidth = containerRect.height * imageAspect;
                                                                            }
                                                                            
                                                                            let offsetX = 0, offsetY = 0;
                                                                            if (imageAspect > containerAspect) {
                                                                                offsetY = (containerRect.height - displayedHeight) / 2;
                                                                            } else {
                                                                                offsetX = (containerRect.width - displayedWidth) / 2;
                                                                            }
                                                                            
                                                                            const lines = [];
                                                                            const scale = displayedWidth / originalImageSize.width;
                                                                            const scaledGridSize = gridSize * scale;
                                                                            
                                                                            // Vertical lines
                                                                            for (let x = offsetX; x <= offsetX + displayedWidth; x += scaledGridSize) {
                                                                                lines.push(
                                                                                    <line
                                                                                        key={`v-${x}`}
                                                                                        x1={x}
                                                                                        y1={offsetY}
                                                                                        x2={x}
                                                                                        y2={offsetY + displayedHeight}
                                                                                        stroke="rgba(255, 255, 0, 0.3)"
                                                                                        strokeWidth="1"
                                                                                    />
                                                                                );
                                                                            }
                                                                            
                                                                            // Horizontal lines
                                                                            for (let y = offsetY; y <= offsetY + displayedHeight; y += scaledGridSize) {
                                                                                lines.push(
                                                                                    <line
                                                                                        key={`h-${y}`}
                                                                                        x1={offsetX}
                                                                                        y1={y}
                                                                                        x2={offsetX + displayedWidth}
                                                                                        y2={y}
                                                                                        stroke="rgba(255, 255, 0, 0.3)"
                                                                                        strokeWidth="1"
                                                                                    />
                                                                                );
                                                                            }
                                                                            
                                                                            return (
                                                                                <svg
                                                                                    style={{
                                                                                        position: 'absolute',
                                                                                        top: 0,
                                                                                        left: 0,
                                                                                        width: '100%',
                                                                                        height: '100%'
                                                                                    }}
                                                                                >
                                                                                    {lines}
                                                                                </svg>
                                                                            );
                                                                        })()}
                                                                    </div>
                                                                )}
                                                                
                                                                {/* Drawings overlay */}
                                                                {drawMode && mapContainerRef && mapImageSize.width && mapImageSize.height && originalImageSize.width && originalImageSize.height && (
                                                                    <div
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: 0,
                                                                            left: 0,
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            pointerEvents: 'none',
                                                                            zIndex: 2
                                                                        }}
                                                                    >
                                                                        {(() => {
                                                                            const containerRect = mapContainerRef.getBoundingClientRect();
                                                                            
                                                                            // Use mapImageSize if available for consistency, otherwise recalculate
                                                                            let displayedWidth, displayedHeight;
                                                                            if (mapImageSize.width > 0 && mapImageSize.height > 0) {
                                                                                displayedWidth = mapImageSize.width;
                                                                                displayedHeight = mapImageSize.height;
                                                                            } else {
                                                                                const containerAspect = containerRect.width / containerRect.height;
                                                                                const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                                
                                                                                if (imageAspect > containerAspect) {
                                                                                    displayedWidth = containerRect.width;
                                                                                    displayedHeight = containerRect.width / imageAspect;
                                                                                } else {
                                                                                    displayedHeight = containerRect.height;
                                                                                    displayedWidth = containerRect.height * imageAspect;
                                                                                }
                                                                            }
                                                                            
                                                                            const containerAspect = containerRect.width / containerRect.height;
                                                                            const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                            
                                                                            let offsetX = 0, offsetY = 0;
                                                                            if (imageAspect > containerAspect) {
                                                                                offsetY = (containerRect.height - displayedHeight) / 2;
                                                                            } else {
                                                                                offsetX = (containerRect.width - displayedWidth) / 2;
                                                                            }
                                                                            
                                                                            return (
                                                                                <svg
                                                                                    style={{
                                                                                        position: 'absolute',
                                                                                        top: 0,
                                                                                        left: 0,
                                                                                        width: '100%',
                                                                                        height: '100%'
                                                                                    }}
                                                                                >
                                                                                    {/* Existing drawings */}
                                                                                    {drawings.map((drawing) => {
                                                                                        if (drawing.type === 'line') {
                                                                                            return (
                                                                                                <line
                                                                                                    key={drawing.id}
                                                                                                    x1={drawing.start.x + offsetX}
                                                                                                    y1={drawing.start.y + offsetY}
                                                                                                    x2={drawing.end.x + offsetX}
                                                                                                    y2={drawing.end.y + offsetY}
                                                                                                    stroke={drawing.color}
                                                                                                    strokeWidth="2"
                                                                                                />
                                                                                            );
                                                                                        } else if (drawing.type === 'rectangle') {
                                                                                            const minX = Math.min(drawing.start.x, drawing.end.x);
                                                                                            const minY = Math.min(drawing.start.y, drawing.end.y);
                                                                                            const width = Math.abs(drawing.end.x - drawing.start.x);
                                                                                            const height = Math.abs(drawing.end.y - drawing.start.y);
                                                                                            
                                                                                            // Note: drawing.start and drawing.end are already relative to displayed image (offset already subtracted)
                                                                                            // So we need to add offset back for display
                                                                                            return (
                                                                                                <rect
                                                                                                    key={drawing.id}
                                                                                                    x={minX + offsetX}
                                                                                                    y={minY + offsetY}
                                                                                                    width={width}
                                                                                                    height={height}
                                                                                                    fill="none"
                                                                                                    stroke={drawing.color}
                                                                                                    strokeWidth="2"
                                                                                                    strokeDasharray="5,5"
                                                                                                />
                                                                                            );
                                                                                        }
                                                                                        return null;
                                                                                    })}
                                                                                    
                                                                                    {/* Current drawing in progress */}
                                                                                    {drawing && drawStart && drawEnd && (
                                                                                        drawTool === 'line' ? (
                                                                                            <line
                                                                                                x1={drawStart.x + offsetX}
                                                                                                y1={drawStart.y + offsetY}
                                                                                                x2={drawEnd.x + offsetX}
                                                                                                y2={drawEnd.y + offsetY}
                                                                                                stroke="#ff0000"
                                                                                                strokeWidth="2"
                                                                                            />
                                                                                        ) : (
                                                                                            <rect
                                                                                                x={Math.min(drawStart.x, drawEnd.x) + offsetX}
                                                                                                y={Math.min(drawStart.y, drawEnd.y) + offsetY}
                                                                                                width={Math.abs(drawEnd.x - drawStart.x)}
                                                                                                height={Math.abs(drawEnd.y - drawStart.y)}
                                                                                                fill="none"
                                                                                                stroke="#00ff00"
                                                                                                strokeWidth="2"
                                                                                                strokeDasharray="5,5"
                                                                                            />
                                                                                        )
                                                                                    )}
                                                                                </svg>
                                                                            );
                                                                        })()}
                                                                    </div>
                                                                )}
                                                                
                                                                {/* Hidden img to get natural dimensions */}
                                                                <img
                                                                    src={selectedMap.image_path}
                                                                    alt={selectedMap.name}
                                                                    style={{
                                                                        width: '100%',
                                                                        height: 'auto',
                                                                        opacity: 0,
                                                                        pointerEvents: 'none',
                                                                        position: 'absolute'
                                                                    }}
                                                                    onLoad={(e) => {
                                                                        if (mapContainerRef) {
                                                                            const img = e.target;
                                                                            
                                                                            if (img.naturalWidth && img.naturalHeight) {
                                                                                setOriginalImageSize({
                                                                                    width: img.naturalWidth,
                                                                                    height: img.naturalHeight
                                                                                });
                                                                                
                                                                                const containerRect = mapContainerRef.getBoundingClientRect();
                                                                                const containerAspect = containerRect.width / containerRect.height;
                                                                                const imageAspect = img.naturalWidth / img.naturalHeight;
                                                                                
                                                                                let displayedWidth, displayedHeight;
                                                                                if (imageAspect > containerAspect) {
                                                                                    displayedWidth = containerRect.width;
                                                                                    displayedHeight = containerRect.width / imageAspect;
                                                                                } else {
                                                                                    displayedHeight = containerRect.height;
                                                                                    displayedWidth = containerRect.height * imageAspect;
                                                                                }
                                                                                
                                                                                setMapImageSize({
                                                                                    width: displayedWidth,
                                                                                    height: displayedHeight
                                                                                });
                                                                            }
                                                                        }
                                                                    }}
                                                                    onError={(e) => {
                                                                        e.target.src = '/images/loading.gif';
                                                                    }}
                                                                />
                                                                {mapPoints.map((point) => {
                                                                    // Calculate point position exactly like in Map.js
                                                                    const getPointStyle = () => {
                                                                        if (!mapContainerRef || !originalImageSize.width || !originalImageSize.height) {
                                                                            return { display: 'none' };
                                                                        }
                                                                        
                                                                        // Use mapImageSize if available (set from onLoad), otherwise recalculate
                                                                        // This ensures consistency with how the image is displayed
                                                                        let displayedWidth, displayedHeight;
                                                                        if (mapImageSize.width > 0 && mapImageSize.height > 0) {
                                                                            // Use stored mapImageSize from onLoad event
                                                                            displayedWidth = mapImageSize.width;
                                                                            displayedHeight = mapImageSize.height;
                                                                        } else {
                                                                            // Fallback: recalculate displayed size
                                                                            const containerRect = mapContainerRef.getBoundingClientRect();
                                                                            const containerAspect = containerRect.width / containerRect.height;
                                                                            const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                            
                                                                            if (imageAspect > containerAspect) {
                                                                                displayedWidth = containerRect.width;
                                                                                displayedHeight = containerRect.width / imageAspect;
                                                                            } else {
                                                                                displayedHeight = containerRect.height;
                                                                                displayedWidth = containerRect.height * imageAspect;
                                                                            }
                                                                        }
                                                                        
                                                                        // Calculate offset for centered image
                                                                        const containerRect = mapContainerRef.getBoundingClientRect();
                                                                        const containerAspect = containerRect.width / containerRect.height;
                                                                        const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                        
                                                                        let offsetX = 0, offsetY = 0;
                                                                        if (imageAspect > containerAspect) {
                                                                            offsetY = (containerRect.height - displayedHeight) / 2;
                                                                        } else {
                                                                            offsetX = (containerRect.width - displayedWidth) / 2;
                                                                        }
                                                                        
                                                                        // Calculate scale factor based on displayed image size vs original
                                                                        const scale = displayedWidth / originalImageSize.width;
                                                                        
                                                                        // Scale width and height proportionally
                                                                        const scaledWidth = point.width * scale;
                                                                        const scaledHeight = point.height * scale;
                                                                        
                                                                        // Calculate position in pixels based on percentage of displayed image
                                                                        // The point.x and point.y are percentages (0-100) relative to the displayed image
                                                                        // IMPORTANT: The percentages are calculated as (pixel_position / displayed_size) * 100
                                                                        // So to convert back: (percentage / 100) * displayed_size + offset
                                                                        const left = (point.x / 100) * displayedWidth + offsetX;
                                                                        const top = (point.y / 100) * displayedHeight + offsetY;
                                                                        
                                                                        return {
                                                                            position: 'absolute',
                                                                            left: `${left}px`,
                                                                            top: `${top}px`,
                                                                            width: `${scaledWidth}px`,
                                                                            height: `${scaledHeight}px`,
                                                                            border: selectedPoint?.id === point.id ? '1px solid red' : '1px solid blue',
                                                                            backgroundColor: selectedPoint?.id === point.id ? 'rgba(255, 0, 0, 0.3)' : 'rgba(0, 0, 255, 0.2)',
                                                                            cursor: 'pointer',
                                                                            borderRadius: '4px',
                                                                            boxShadow: selectedPoint?.id === point.id ? '0 0 10px rgba(255, 0, 0, 0.5)' : '0 0 5px rgba(0, 0, 255, 0.3)',
                                                                            transition: 'all 0.2s ease',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            zIndex: selectedPoint?.id === point.id ? 10 : 5
                                                                        };
                                                                    };
                                                                    
                                                                    return (
                                                                        <div
                                                                            key={point.id}
                                                                            onClick={(e) => {
                                                                                if (!moveMode) {
                                                                                    e.stopPropagation();
                                                                                    setSelectedPoint(point);
                                                                                    if (!allWildPokemon.length) {
                                                                                        loadWildPokemon();
                                                                                    }
                                                                                }
                                                                            }}
                                                                            onMouseDown={(e) => {
                                                                                if (moveMode) {
                                                                                    e.stopPropagation();
                                                                                    setDraggingPoint(point);
                                                                                    const rect = mapContainerRef?.getBoundingClientRect();
                                                                                    if (rect && mapContainerRef && originalImageSize.width && originalImageSize.height) {
                                                                                        // Calculate current position
                                                                                        let displayedWidth, displayedHeight;
                                                                                        if (mapImageSize.width > 0 && mapImageSize.height > 0) {
                                                                                            displayedWidth = mapImageSize.width;
                                                                                            displayedHeight = mapImageSize.height;
                                                                                        } else {
                                                                                            const containerAspect = rect.width / rect.height;
                                                                                            const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                                            if (imageAspect > containerAspect) {
                                                                                                displayedWidth = rect.width;
                                                                                                displayedHeight = rect.width / imageAspect;
                                                                                            } else {
                                                                                                displayedHeight = rect.height;
                                                                                                displayedWidth = rect.height * imageAspect;
                                                                                            }
                                                                                        }
                                                                                        
                                                                                        const containerAspect = rect.width / rect.height;
                                                                                        const imageAspect = originalImageSize.width / originalImageSize.height;
                                                                                        let offsetX = 0, offsetY = 0;
                                                                                        if (imageAspect > containerAspect) {
                                                                                            offsetY = (rect.height - displayedHeight) / 2;
                                                                                        } else {
                                                                                            offsetX = (rect.width - displayedWidth) / 2;
                                                                                        }
                                                                                        
                                                                                        const currentLeft = (point.x / 100) * displayedWidth + offsetX;
                                                                                        const currentTop = (point.y / 100) * displayedHeight + offsetY;
                                                                                        
                                                                                        // Calculate dragOffset relative to container (not viewport)
                                                                                        // This represents where on the point element the mouse clicked
                                                                                        const mouseXInContainer = e.clientX - rect.left;
                                                                                        const mouseYInContainer = e.clientY - rect.top;
                                                                                        
                                                                                        setDragOffset({
                                                                                            x: mouseXInContainer - currentLeft,
                                                                                            y: mouseYInContainer - currentTop
                                                                                        });
                                                                                    }
                                                                                }
                                                                            }}
                                                                            style={{
                                                                                ...getPointStyle(),
                                                                                cursor: moveMode ? 'move' : 'pointer',
                                                                                transition: draggingPoint?.id === point.id ? 'none' : 'all 0.2s ease'
                                                                            }}
                                                                            title={moveMode ? `Drag to move ${point.name}` : (point.tooltip || point.name)}
                                                                        >
                                                                            {selectedPoint?.id === point.id && (
                                                                                <span style={{ 
                                                                                    color: 'white', 
                                                                                    fontWeight: 'bold', 
                                                                                    fontSize: '12px',
                                                                                    textShadow: '1px 1px 2px black',
                                                                                    pointerEvents: 'none'
                                                                                }}>
                                                                                    {point.name}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </>
                                                        )}
                                                    </div>
                                                    
                                                    {mapPoints.length > 0 && (
                                                        <Table striped bordered hover className="mt-3">
                                                            <thead>
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <th>Type</th>
                                                                    <th>Gebied / Target</th>
                                                                    <th>Position (X, Y)</th>
                                                                    <th>Size (W, H)</th>
                                                                    <th>Has Restrictions</th>
                                                                    <th>Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {mapPoints.map((point) => {
                                                                    const hasRestrictions = (point.required_level && point.required_level > 0) || 
                                                                                           (point.required_attacks && point.required_attacks > 0) ||
                                                                                           (point.next_point_id && point.next_point_id > 0);
                                                                    return (
                                                                    <tr 
                                                                        key={point.id} 
                                                                        className={selectedPoint?.id === point.id ? 'table-primary' : ''}
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => {
                                                                            setSelectedPoint(point);
                                                                            if (!allWildPokemon.length) {
                                                                                loadWildPokemon();
                                                                            }
                                                                        }}
                                                                    >
                                                                        <td>{point.name}</td>
                                                                        <td>{point.point_type || 'battle'}</td>
                                                                        <td>{point.point_type === 'navigation' ? (point.target_url || 'N/A') : (point.gebied || 'N/A')}</td>
                                                                        <td>({typeof point.x === 'number' ? point.x.toFixed(2) : point.x}%, {typeof point.y === 'number' ? point.y.toFixed(2) : point.y}%)</td>
                                                                        <td>({point.width}px, {point.height}px)</td>
                                                                        <td>
                                                                            {hasRestrictions ? (
                                                                                <Badge bg="warning">
                                                                                    Yes
                                                                                    {point.required_level > 0 && ` (Lv.${point.required_level})`}
                                                                                    {point.required_attacks > 0 && ` (${point.required_attacks} attacks)`}
                                                                                    {point.next_point_id > 0 && ` (Next: ${point.next_point_id})`}
                                                                                </Badge>
                                                                            ) : (
                                                                                <Badge bg="success">No</Badge>
                                                                            )}
                                                                        </td>
                                                                        <td onClick={(e) => e.stopPropagation()}>
                                                                            <Button variant="info" size="sm" className="me-2" onClick={() => {
                                                                                setEditingPoint({
                                                                                    ...point,
                                                                                    point_type: point.point_type || 'battle',
                                                                                    target_url: point.target_url || '',
                                                                                    required_level: point.required_level || 0,
                                                                                    required_attacks: point.required_attacks || 0,
                                                                                    next_point_id: point.next_point_id || null
                                                                                });
                                                                                setShowPointModal(true);
                                                                            }}>
                                                                                Edit
                                                                            </Button>
                                                                            <Button variant="warning" size="sm" className="me-2" onClick={() => handleDuplicatePoint(point)}>
                                                                                Duplicate
                                                                            </Button>
                                                                            <Button variant="danger" size="sm" onClick={() => handleDeleteMapPoint(point.id)}>
                                                                                Delete
                                                                            </Button>
                                                                        </td>
                                                                    </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </Table>
                                                    )}
                                                    
                                                    {selectedPoint && selectedPoint.point_type === 'battle' && (
                                                        <Card className="mt-3 border-success">
                                                            <Card.Header className="bg-success text-white">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <h6 className="mb-0">Pokemon for Point: {selectedPoint.name}</h6>
                                                                    <div>
                                                                        <Button variant="light" size="sm" className="me-2" onClick={() => {
                                                                            if (!allWildPokemon.length) {
                                                                                loadWildPokemon();
                                                                            }
                                                                            setShowPokemonModal(true);
                                                                        }}>
                                                                            + Add Pokemon
                                                                        </Button>
                                                                        <Button variant="info" size="sm" onClick={() => {
                                                                            // Edit point pokemon - reload the list
                                                                            if (selectedPoint) {
                                                                                loadPointPokemon(selectedPoint.id);
                                                                            }
                                                                        }}>
                                                                            Refresh
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </Card.Header>
                                                            <Card.Body>
                                                                {pointPokemonLoading ? (
                                                                    <Alert variant="info">Loading pokemon...</Alert>
                                                                ) : pointPokemon.length === 0 ? (
                                                                    <Alert variant="warning">No pokemon assigned to this point. Add some pokemon!</Alert>
                                                                ) : (
                                                                    <Table striped bordered hover size="sm">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Pokemon</th>
                                                                                <th>Type</th>
                                                                                <th>Spawn Rate</th>
                                                                                <th>Level Range</th>
                                                                                <th>Actions</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {pointPokemon.map((p) => (
                                                                                <tr key={p.id}>
                                                                                    <td>{p.pokemon_name}</td>
                                                                                    <td>{p.type1}{p.type2 ? ` / ${p.type2}` : ''}</td>
                                                                                    <td>{p.spawn_rate}%</td>
                                                                                    <td>{p.min_level}-{p.max_level}</td>
                                                                                    <td>
                                                                                        <Button variant="info" size="sm" className="me-2" onClick={() => {
                                                                                            // Edit pokemon - set it in the modal
                                                                                            setEditingPokemonId(p.id);
                                                                                            setNewPokemonToPoint({
                                                                                                pokemon_wild_id: p.pokemon_wild_id,
                                                                                                spawn_rate: p.spawn_rate,
                                                                                                min_level: p.min_level,
                                                                                                max_level: p.max_level
                                                                                            });
                                                                                            if (!allWildPokemon.length) {
                                                                                                loadWildPokemon();
                                                                                            }
                                                                                            setShowPokemonModal(true);
                                                                                        }}>
                                                                                            Edit
                                                                                        </Button>
                                                                                        <Button variant="danger" size="sm" onClick={() => handleRemovePokemonFromPoint(p.id)}>
                                                                                            Remove
                                                                                        </Button>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </Table>
                                                                )}
                                                            </Card.Body>
                                                        </Card>
                                                    )}
                                                    {selectedPoint && selectedPoint.point_type === 'navigation' && (
                                                        <Card className="mt-3 border-info">
                                                            <Card.Header className="bg-info text-white">
                                                                <h6 className="mb-0">Navigation Point: {selectedPoint.name}</h6>
                                                            </Card.Header>
                                                            <Card.Body>
                                                                <Alert variant="info">
                                                                    <strong>Navigation Point:</strong> This point will navigate to <code>{selectedPoint.target_url || 'N/A'}</code> when clicked.
                                                                    <br />
                                                                    <small>Navigation points do not have Pokémon associated with them.</small>
                                                                </Alert>
                                                            </Card.Body>
                                                        </Card>
                                                    )}
                                                </div>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}
                    
                    {/* Trainers Management Tab */}
                    {activeTab === 'trainers-management' && adminLevel >= 3 && (
                    <Row className="mt-4">
                        <Col md={12}>
                            <Card>
                                <Card.Header className="d-flex justify-content-between align-items-center">
                                    <h3>Trainers Management</h3>
                                    <Button variant="success" onClick={() => {
                                        setEditingTrainer(null);
                                        setSelectedTrainer(null);
                                        setTrainerPokemon([]);
                                        setTrainerRewards([]);
                                        setShowTrainerModal(true);
                                    }}>
                                        + Create New Trainer
                                    </Button>
                                </Card.Header>
                                <Card.Body>
                                    {trainersLoading ? (
                                        <Alert variant="info">Loading trainers...</Alert>
                                    ) : trainers.length === 0 ? (
                                        <Alert variant="warning">No trainers found. Create your first trainer!</Alert>
                                    ) : (
                                        <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Name</th>
                                                    <th>Image</th>
                                                    <th>Silver Cost</th>
                                                    <th>Level Range</th>
                                                    <th>Pokemon Count</th>
                                                    <th>Rewards Count</th>
                                                    <th>Status</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {trainers.map((trainer) => (
                                                    <tr key={trainer.id}>
                                                        <td>{trainer.id}</td>
                                                        <td><strong>{trainer.trainer_name}</strong></td>
                                                        <td>
                                                            {trainer.trainer_image && (
                                                                <img 
                                                                    src={trainer.trainer_image.startsWith('/') ? trainer.trainer_image : `/api/assets/images/attack/${trainer.trainer_image}`}
                                                                    alt={trainer.trainer_name}
                                                                    style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                                                    onError={(e) => {
                                                                        e.target.src = '/images/pvp/pvp-empty.png';
                                                                    }}
                                                                />
                                                            )}
                                                        </td>
                                                        <td>{trainer.silver_cost}</td>
                                                        <td>{trainer.level_range_min}-{trainer.level_range_max}</td>
                                                        <td>{trainer.pokemon?.length || 0}</td>
                                                        <td>{trainer.rewards?.length || 0}</td>
                                                        <td>
                                                            <Badge bg={trainer.is_active ? 'success' : 'secondary'}>
                                                                {trainer.is_active ? 'Active' : 'Inactive'}
                                                            </Badge>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex gap-2">
                                                                <Button
                                                                    size="sm"
                                                                    variant="info"
                                                                    onClick={() => {
                                                                        setSelectedTrainer(trainer);
                                                                        setTrainerPokemon(trainer.pokemon || []);
                                                                        setTrainerRewards(trainer.rewards || []);
                                                                    }}
                                                                >
                                                                    View
                                                                </Button>
                                                                <Button
                                                                    size="sm"
                                                                    variant="warning"
                                                                    onClick={() => {
                                                                        setEditingTrainer(trainer);
                                                                        setShowTrainerModal(true);
                                                                    }}
                                                                >
                                                                    Edit
                                                                </Button>
                                                                <Button
                                                                    size="sm"
                                                                    variant="danger"
                                                                    onClick={() => handleDeleteTrainer(trainer.id)}
                                                                >
                                                                    Delete
                                                                </Button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </Card.Body>
                            </Card>
                            
                            {/* Trainer Details */}
                            {selectedTrainer && (
                                <Row className="mt-4">
                                    <Col md={6}>
                                        <Card>
                                            <Card.Header>
                                                <h5>{selectedTrainer.trainer_name} - Pokemon ({trainerPokemon.length}/6)</h5>
                                                <Button 
                                                    size="sm" 
                                                    variant="success"
                                                    onClick={() => {
                                                        if (trainerPokemon.length >= 6) {
                                                            toast.warning('Trainer can only have up to 6 Pokemon');
                                                            return;
                                                        }
                                                        setShowTrainerPokemonModal(true);
                                                    }}
                                                    disabled={trainerPokemon.length >= 6}
                                                >
                                                    + Add Pokemon
                                                </Button>
                                            </Card.Header>
                                            <Card.Body>
                                                {trainerPokemon.length === 0 ? (
                                                    <Alert variant="info">No Pokemon assigned. Add Pokemon to this trainer.</Alert>
                                                ) : (
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Slot</th>
                                                                <th>Pokemon</th>
                                                                <th>Level Range</th>
                                                                <th>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {trainerPokemon.map((poke) => (
                                                                <tr key={poke.id}>
                                                                    <td>{poke.slot_position}</td>
                                                                    <td>{poke.pokemon_name} (ID: {poke.wild_id})</td>
                                                                    <td>{poke.level_min}-{poke.level_max}</td>
                                                                    <td>
                                                                        <Button
                                                                            size="sm"
                                                                            variant="danger"
                                                                            onClick={() => handleDeleteTrainerPokemon(poke.id)}
                                                                        >
                                                                            Remove
                                                                        </Button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={6}>
                                        <Card>
                                            <Card.Header>
                                                <h5>{selectedTrainer.trainer_name} - Rewards</h5>
                                                <Button 
                                                    size="sm" 
                                                    variant="success"
                                                    onClick={() => setShowTrainerRewardModal(true)}
                                                >
                                                    + Add Reward
                                                </Button>
                                            </Card.Header>
                                            <Card.Body>
                                                {trainerRewards.length === 0 ? (
                                                    <Alert variant="info">No special rewards. Rewards have 2% chance to win.</Alert>
                                                ) : (
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Type</th>
                                                                <th>Name</th>
                                                                <th>Value</th>
                                                                <th>Quantity</th>
                                                                <th>Chance %</th>
                                                                <th>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {trainerRewards.map((reward) => (
                                                                <tr key={reward.id}>
                                                                    <td>{reward.reward_type}</td>
                                                                    <td>{reward.reward_name}</td>
                                                                    <td>{reward.reward_value}</td>
                                                                    <td>{reward.reward_quantity}</td>
                                                                    <td>{reward.chance_percentage}%</td>
                                                                    <td>
                                                                        <Button
                                                                            size="sm"
                                                                            variant="danger"
                                                                            onClick={() => handleDeleteTrainerReward(reward.id)}
                                                                        >
                                                                            Delete
                                                                        </Button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            )}
                        </Col>
                    </Row>
                    )}
                    
                    {/* Chat Management Tab */}
                    {activeTab === 'chat-management' && (
                        <Row className="mt-4">
                            <Col md={12}>
                                <Card>
                                    <Card.Header>
                                        <h3>Chat Management</h3>
                                    </Card.Header>
                                    <Card.Body>
                                        <Tabs defaultActiveKey="logs" id="chat-management-tabs">
                                            <Tab eventKey="logs" title="Admin Logs">
                                                <div className="mt-3">
                                                    <Row>
                                                        <Col md={3}>
                                                            <Form.Group>
                                                                <Form.Label>Days Back</Form.Label>
                                                                <Form.Select 
                                                                    value={logsDaysBack} 
                                                                    onChange={(e) => setLogsDaysBack(parseInt(e.target.value))}
                                                                >
                                                                    <option value={1}>Last 24 hours</option>
                                                                    <option value={7}>Last 7 days</option>
                                                                    <option value={30}>Last 30 days</option>
                                                                    <option value={90}>Last 90 days</option>
                                                                    <option value={180}>Last 180 days</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={4}>
                                                            <Form.Group>
                                                                <Form.Label>Filter by User ID</Form.Label>
                                                                <Form.Control 
                                                                    type="number" 
                                                                    placeholder="User ID (optional)"
                                                                    value={logsFilterUser}
                                                                    onChange={(e) => setLogsFilterUser(e.target.value)}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={3}>
                                                            <Form.Group>
                                                                <Form.Label>&nbsp;</Form.Label>
                                                                <Button 
                                                                    variant="primary" 
                                                                    onClick={() => loadChatLogs()}
                                                                    disabled={chatLogsLoading}
                                                                    className="w-100"
                                                                >
                                                                    {chatLogsLoading ? 'Loading...' : 'Load Logs'}
                                                                </Button>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Table striped bordered hover className="mt-3">
                                                        <thead>
                                                            <tr>
                                                                <th>Date</th>
                                                                <th>Admin</th>
                                                                <th>Action</th>
                                                                <th>Target User</th>
                                                                <th>Details</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {chatLogs.length === 0 ? (
                                                                <tr>
                                                                    <td colSpan="5" className="text-center">
                                                                        {chatLogsLoading ? 'Loading...' : 'No logs found. Click "Load Logs" to fetch.'}
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                chatLogs.map((log, idx) => (
                                                                    <tr key={idx}>
                                                                        <td>{log.created_at || log.action_time}</td>
                                                                        <td>ID: {log.admin_id}</td>
                                                                        <td><Badge bg="info">{log.action_type}</Badge></td>
                                                                        <td>{log.target_user_id ? `ID: ${log.target_user_id}` : '-'}</td>
                                                                        <td><small>{log.details || log.action_details || '-'}</small></td>
                                                                    </tr>
                                                                ))
                                                            )}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Tab>
                                            
                                            <Tab eventKey="users" title="Muted/Banned Users">
                                                <div className="mt-3">
                                                    <Row>
                                                        <Col md={6}>
                                                            <h5>Muted Users</h5>
                                                            <Table striped bordered hover size="sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th>User ID</th>
                                                                        <th>Until</th>
                                                                        <th>Reason</th>
                                                                        <th>Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {mutedUsers.length === 0 ? (
                                                                        <tr><td colSpan="4" className="text-center">No muted users</td></tr>
                                                                    ) : (
                                                                        mutedUsers.map((user, idx) => (
                                                                            <tr key={idx}>
                                                                                <td>{user.user_id}</td>
                                                                                <td>{user.mute_end}</td>
                                                                                <td><small>{user.reason || '-'}</small></td>
                                                                                <td>
                                                                                    <Button size="sm" variant="success" onClick={() => handleUnmuteFromAdmin(user.user_id)}>
                                                                                        Unmute
                                                                                    </Button>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    )}
                                                                </tbody>
                                                            </Table>
                                                        </Col>
                                                        <Col md={6}>
                                                            <h5>Banned Users</h5>
                                                            <Table striped bordered hover size="sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th>User ID</th>
                                                                        <th>Type</th>
                                                                        <th>Until</th>
                                                                        <th>Reason</th>
                                                                        <th>Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {bannedUsers.length === 0 ? (
                                                                        <tr><td colSpan="5" className="text-center">No banned users</td></tr>
                                                                    ) : (
                                                                        bannedUsers.map((user, idx) => (
                                                                            <tr key={idx}>
                                                                                <td>{user.user_id}</td>
                                                                                <td><Badge bg={user.ban_type === 'permanent' ? 'danger' : 'warning'}>{user.ban_type}</Badge></td>
                                                                                <td>{user.ban_end || 'Permanent'}</td>
                                                                                <td><small>{user.reason || '-'}</small></td>
                                                                                <td>
                                                                                    {isAdmin && adminLevel >= 3 && (
                                                                                        <Button size="sm" variant="success" onClick={() => handleUnbanFromAdmin(user.user_id)}>
                                                                                            Unban
                                                                                        </Button>
                                                                                    )}
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    )}
                                                                </tbody>
                                                            </Table>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Tab>
                                            
                                            <Tab eventKey="reports" title="Reports">
                                                <div className="mt-3">
                                                    <Button variant="primary" onClick={() => loadChatReports()} disabled={chatReportsLoading} className="mb-3">
                                                        {chatReportsLoading ? 'Loading...' : 'Load Reports'}
                                                    </Button>
                                                    <Table striped bordered hover>
                                                        <thead>
                                                            <tr>
                                                                <th>Date</th>
                                                                <th>Reporter</th>
                                                                <th>Reported User</th>
                                                                <th>Reason</th>
                                                                <th>Status</th>
                                                                <th>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {chatReports.length === 0 ? (
                                                                <tr><td colSpan="6" className="text-center">No reports found</td></tr>
                                                            ) : (
                                                                chatReports.map((report, idx) => (
                                                                    <tr key={idx}>
                                                                        <td>{report.created_at}</td>
                                                                        <td>ID: {report.reporter_id}</td>
                                                                        <td>ID: {report.reported_user_id}</td>
                                                                        <td><small>{report.reason || '-'}</small></td>
                                                                        <td><Badge bg={report.status === 'resolved' ? 'success' : 'warning'}>{report.status}</Badge></td>
                                                                        <td>
                                                                            <Button size="sm" variant="info">View</Button>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            )}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Tab>
                                            
                                            <Tab eventKey="rooms" title="Chat Rooms">
                                                <div className="mt-3">
                                                    <Row className="mb-3">
                                                        <Col md={12}>
                                                            <Button variant="success" onClick={() => setShowCreateRoomModal(true)}>
                                                                ➕ Create New Room
                                                            </Button>
                                                            <Button variant="primary" onClick={() => loadRooms()} className="ms-2">
                                                                🔄 Refresh
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                    <Table striped bordered hover>
                                                        <thead>
                                                            <tr>
                                                                <th>ID</th>
                                                                <th>Room Name</th>
                                                                <th>Type</th>
                                                                <th>Status</th>
                                                                <th>Created By</th>
                                                                <th>Room URL</th>
                                                                <th>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {chatRooms.length === 0 ? (
                                                                <tr><td colSpan="7" className="text-center">No rooms found. Click "Create New Room" to add one.</td></tr>
                                                            ) : (
                                                                chatRooms.map((room, idx) => (
                                                                    <tr key={idx}>
                                                                        <td>{room.id}</td>
                                                                        <td>{room.room_name}</td>
                                                                        <td><Badge bg="info">{room.room_type}</Badge></td>
                                                                        <td>
                                                                            {room.is_suspended == 1 ? (
                                                                                <Badge bg="danger">Suspended</Badge>
                                                                            ) : room.is_locked == 1 ? (
                                                                                <Badge bg="warning">Locked</Badge>
                                                                            ) : (
                                                                                <Badge bg="success">Active</Badge>
                                                                            )}
                                                                        </td>
                                                                        <td>{room.created_by_username || `ID: ${room.created_by}`}</td>
                                                                        <td>
                                                                            <a href={`/chat?room=${room.id}`} target="_blank" rel="noopener noreferrer">
                                                                                /chat?room={room.id}
                                                                            </a>
                                                                        </td>
                                                                        <td>
                                                                            <Button 
                                                                                size="sm" 
                                                                                variant={room.is_suspended == 1 ? "success" : "warning"}
                                                                                onClick={() => handleSuspendRoom(room.id, room.is_suspended == 1)}
                                                                                className="me-1"
                                                                            >
                                                                                {room.is_suspended == 1 ? 'Unsuspend' : 'Suspend'}
                                                                            </Button>
                                                                            {room.id !== 1 && (
                                                                                <Button 
                                                                                    size="sm" 
                                                                                    variant="danger"
                                                                                    onClick={() => handleDeleteRoom(room.id)}
                                                                                >
                                                                                    Delete
                                                                                </Button>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            )}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Tab>
                                            
                                            <Tab eventKey="broadcasts" title="Broadcasts">
                                                <div className="mt-3">
                                                    <Button variant="primary" onClick={() => loadBroadcasts()} disabled={broadcastsLoading} className="mb-3">
                                                        {broadcastsLoading ? 'Loading...' : 'Load Broadcasts'}
                                                    </Button>
                                                    <Table striped bordered hover>
                                                        <thead>
                                                            <tr>
                                                                <th>Date</th>
                                                                <th>Type</th>
                                                                <th>Message</th>
                                                                <th>Sent By</th>
                                                                <th>Expires</th>
                                                                <th>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {chatBroadcasts.length === 0 ? (
                                                                <tr><td colSpan="6" className="text-center">No broadcasts found</td></tr>
                                                            ) : (
                                                                chatBroadcasts.map((broadcast, idx) => (
                                                                    <tr key={idx}>
                                                                        <td>{broadcast.created_at}</td>
                                                                        <td><Badge bg="info">{broadcast.broadcast_type}</Badge></td>
                                                                        <td><small>{broadcast.message}</small></td>
                                                                        <td>{broadcast.sent_by_username || `ID: ${broadcast.sent_by}`}</td>
                                                                        <td>{broadcast.expires_at || 'Never'}</td>
                                                                        <td>
                                                                            <Button 
                                                                                size="sm" 
                                                                                variant="danger"
                                                                                onClick={() => handleDeleteBroadcast(broadcast.id)}
                                                                            >
                                                                                Delete
                                                                            </Button>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            )}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Tab>
                                        </Tabs>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}
                    
                    {/* Pokemon Market Management Tab */}
                    {activeTab === 'market-management' && adminLevel >= 2 && (
                        <Row className="mt-4">
                            <Col md={12}>
                                <Card>
                                    <Card.Header>
                                        <h3>Pokemon Market Management</h3>
                                        <small className="text-muted">Admin Level {adminLevel} - {adminLevel >= 2 ? 'Supervisor+' : 'Moderator'}</small>
                                    </Card.Header>
                                    <Card.Body>
                                        <Tabs defaultActiveKey="approvals" id="market-management-tabs">
                                            {/* Gold Sales Approvals Tab */}
                                            <Tab eventKey="approvals" title={`Gold Approvals (${pendingApprovals.length})`}>
                                                <div className="mt-3">
                                                    <Button variant="primary" onClick={loadPendingApprovals} disabled={approvalsLoading} className="mb-3">
                                                        {approvalsLoading ? 'Loading...' : 'Refresh Approvals'}
                                                    </Button>
                                                    {pendingApprovals.length === 0 ? (
                                                        <Alert variant="info">No pending Gold sale approvals.</Alert>
                                                    ) : (
                                                        <Table striped bordered hover>
                                                            <thead>
                                                                <tr>
                                                                    <th>ID</th>
                                                                    <th>Pokemon</th>
                                                                    <th>Level</th>
                                                                    <th>Seller</th>
                                                                    <th>Price</th>
                                                                    <th>Sale Type</th>
                                                                    <th>Created</th>
                                                                    <th>Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {pendingApprovals.map((approval) => (
                                                                    <tr key={approval.id}>
                                                                        <td>{approval.id}</td>
                                                                        <td>
                                                                            <img 
                                                                                src={`/images/pokemon/${approval.pokemon_id_wild}.gif`} 
                                                                                alt={approval.pokemon_name}
                                                                                style={{ width: '40px', height: '40px' }}
                                                                                className="me-2"
                                                                            />
                                                                            {approval.pokemon_name} {approval.shiny ? '✨' : ''}
                                                                        </td>
                                                                        <td>{approval.level}</td>
                                                                        <td>{approval.seller_username} (ID: {approval.seller_id})</td>
                                                                        <td>
                                                                            <img 
                                                                                src="/images/mock-04.png" 
                                                                                alt="Gold" 
                                                                                style={{ width: '20px', height: '20px' }}
                                                                                className="me-1"
                                                                            />
                                                                            {approval.price.toLocaleString()}
                                                                        </td>
                                                                        <td><Badge bg="info">{approval.sale_type}</Badge></td>
                                                                        <td>{new Date(approval.created_at).toLocaleString()}</td>
                                                                        <td>
                                                                            <Button 
                                                                                size="sm" 
                                                                                variant="success"
                                                                                onClick={() => handleApproveGoldSale(approval.id, 'approve')}
                                                                                className="me-1"
                                                                            >
                                                                                Approve
                                                                            </Button>
                                                                            <Button 
                                                                                size="sm" 
                                                                                variant="danger"
                                                                                onClick={() => handleApproveGoldSale(approval.id, 'reject')}
                                                                            >
                                                                                Reject
                                                                            </Button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    )}
                                                </div>
                                            </Tab>
                                            
                                            {/* Market Logs Tab */}
                                            <Tab eventKey="logs" title="Market Logs">
                                                <div className="mt-3">
                                                    <Row className="mb-3">
                                                        <Col md={4}>
                                                            <Form.Group>
                                                                <Form.Label>Filter by Action Type</Form.Label>
                                                                <Form.Select 
                                                                    value={logsActionType}
                                                                    onChange={(e) => setLogsActionType(e.target.value)}
                                                                >
                                                                    <option value="">All Actions</option>
                                                                    <option value="sell">Sell</option>
                                                                    <option value="buy">Buy</option>
                                                                    <option value="cancel">Cancel</option>
                                                                    <option value="approve">Approve</option>
                                                                    <option value="reject">Reject</option>
                                                                    <option value="admin_cancel">Admin Cancel</option>
                                                                    <option value="admin_buy_price_change">Admin Buy (Price Change)</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={4}>
                                                            <Form.Group>
                                                                <Form.Label>Filter by Sale ID</Form.Label>
                                                                <Form.Control 
                                                                    type="number"
                                                                    placeholder="Sale ID (optional)"
                                                                    value={logsSaleId}
                                                                    onChange={(e) => setLogsSaleId(e.target.value)}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={4}>
                                                            <Form.Label>&nbsp;</Form.Label>
                                                            <Button 
                                                                variant="primary" 
                                                                onClick={loadMarketLogs}
                                                                disabled={logsLoading}
                                                                className="w-100"
                                                            >
                                                                {logsLoading ? 'Loading...' : 'Load Logs'}
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                    {marketLogs.length === 0 ? (
                                                        <Alert variant="info">No market logs found.</Alert>
                                                    ) : (
                                                        <Table striped bordered hover size="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>ID</th>
                                                                    <th>Sale ID</th>
                                                                    <th>Action</th>
                                                                    <th>Performed By</th>
                                                                    <th>Admin Level</th>
                                                                    <th>Pokemon</th>
                                                                    <th>Old Value</th>
                                                                    <th>New Value</th>
                                                                    <th>Details</th>
                                                                    <th>Date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {marketLogs.map((log) => (
                                                                    <tr key={log.id}>
                                                                        <td>{log.id}</td>
                                                                        <td>{log.sale_id}</td>
                                                                        <td><Badge bg="secondary">{log.action_type}</Badge></td>
                                                                        <td>{log.performer_username || `ID: ${log.performed_by}`}</td>
                                                                        <td>{log.admin_level ? `Level ${log.admin_level}` : '-'}</td>
                                                                        <td>{log.pokemon_name || '-'}</td>
                                                                        <td><small>{log.old_value || '-'}</small></td>
                                                                        <td><small>{log.new_value || '-'}</small></td>
                                                                        <td><small>{log.details || '-'}</small></td>
                                                                        <td><small>{new Date(log.created_at).toLocaleString()}</small></td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    )}
                                                </div>
                                            </Tab>
                                            
                                            {/* Cancel Sales Tab (Admin Level 2+) */}
                                            {adminLevel >= 2 && (
                                                <Tab eventKey="cancel" title="Cancel Sales">
                                                    <div className="mt-3">
                                                        <Alert variant="warning">
                                                            <strong>Cancel Sales:</strong> Use this to cancel any active sale. The Pokemon will be returned to the seller.
                                                        </Alert>
                                                        <Button 
                                                            variant="primary" 
                                                            onClick={loadActiveSales} 
                                                            disabled={activeSalesLoading} 
                                                            className="mb-3"
                                                        >
                                                            {activeSalesLoading ? 'Loading...' : 'Refresh Active Sales'}
                                                        </Button>
                                                        {activeSales.length === 0 ? (
                                                            <Alert variant="info">No active sales found.</Alert>
                                                        ) : (
                                                            <Table striped bordered hover size="sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Sale ID</th>
                                                                        <th>Pokemon</th>
                                                                        <th>Level</th>
                                                                        <th>Seller</th>
                                                                        <th>Price</th>
                                                                        <th>Type</th>
                                                                        <th>Created</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {activeSales.map((sale) => (
                                                                        <tr 
                                                                            key={sale.id}
                                                                            style={{ 
                                                                                cursor: cancelSaleModal.sale?.id === sale.id ? 'default' : 'pointer',
                                                                                backgroundColor: cancelSaleModal.sale?.id === sale.id ? '#fff3cd' : ''
                                                                            }}
                                                                            onClick={() => {
                                                                                setCancelSaleModal({ 
                                                                                    show: true, 
                                                                                    sale: sale, 
                                                                                    reason: cancelSaleModal.reason 
                                                                                });
                                                                            }}
                                                                        >
                                                                            <td>{sale.id}</td>
                                                                            <td>
                                                                                <img 
                                                                                    src={`/images/pokemon/${sale.pokemon_id_wild || sale.wild_id}.gif`} 
                                                                                    alt={sale.pokemon_name || sale.naam}
                                                                                    style={{ width: '40px', height: '40px' }}
                                                                                    className="me-2"
                                                                                />
                                                                                {sale.pokemon_name || sale.naam} {sale.shiny ? '✨' : ''}
                                                                            </td>
                                                                            <td>{sale.level}</td>
                                                                            <td>{sale.seller_username || `ID: ${sale.seller_id}`}</td>
                                                                            <td>
                                                                                <img 
                                                                                    src={sale.currency_type === 'gold' ? '/images/mock-04.png' : '/images/mock-05.png'} 
                                                                                    alt={sale.currency_type} 
                                                                                    style={{ width: '20px', height: '20px' }}
                                                                                    className="me-1"
                                                                                />
                                                                                {sale.price.toLocaleString()}
                                                                            </td>
                                                                            <td><Badge bg="info">{sale.sale_type}</Badge></td>
                                                                            <td><small>{new Date(sale.created_at).toLocaleString()}</small></td>
                                                                            <td>
                                                                                <Button 
                                                                                    size="sm" 
                                                                                    variant="danger"
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setCancelSaleModal({ 
                                                                                            show: true, 
                                                                                            sale: sale, 
                                                                                            reason: '' 
                                                                                        });
                                                                                    }}
                                                                                >
                                                                                    Select
                                                                                </Button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        )}
                                                        {cancelSaleModal.sale && (
                                                            <div className="mt-3 p-3 border rounded" style={{ backgroundColor: '#fff3cd' }}>
                                                                <h6>Selected Sale: #{cancelSaleModal.sale.id}</h6>
                                                                <p><strong>Pokemon:</strong> {cancelSaleModal.sale.pokemon_name || cancelSaleModal.sale.naam} (Level {cancelSaleModal.sale.level})</p>
                                                                <p><strong>Seller:</strong> {cancelSaleModal.sale.seller_username || `ID: ${cancelSaleModal.sale.seller_id}`}</p>
                                                                <p><strong>Price:</strong> {cancelSaleModal.sale.price.toLocaleString()} {cancelSaleModal.sale.currency_type}</p>
                                                                <Form.Group className="mb-3 mt-3">
                                                                    <Form.Label>Cancellation Reason</Form.Label>
                                                                    <Form.Control 
                                                                        as="textarea"
                                                                        rows={3}
                                                                        placeholder="Enter reason for cancellation..."
                                                                        value={cancelSaleModal.reason}
                                                                        onChange={(e) => setCancelSaleModal({ ...cancelSaleModal, reason: e.target.value })}
                                                                    />
                                                                </Form.Group>
                                                                <Button 
                                                                    variant="danger"
                                                                    onClick={handleCancelSale}
                                                                    className="me-2"
                                                                >
                                                                    Cancel Sale #{cancelSaleModal.sale.id}
                                                                </Button>
                                                                <Button 
                                                                    variant="secondary"
                                                                    onClick={() => setCancelSaleModal({ show: false, sale: null, reason: '' })}
                                                                >
                                                                    Clear Selection
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </Tab>
                                            )}
                                            
                                            {/* Buy with Price Change Tab (Admin Level 3+) */}
                                            {adminLevel >= 3 && (
                                                <Tab eventKey="buy" title="Buy with Price Change">
                                                    <div className="mt-3">
                                                        <Alert variant="info">
                                                            <strong>Buy with Price Change:</strong> Purchase a Pokemon with a different price than listed. Only available for Administrator level (3+).
                                                        </Alert>
                                                        <Button 
                                                            variant="primary" 
                                                            onClick={loadActiveSales} 
                                                            disabled={activeSalesLoading} 
                                                            className="mb-3"
                                                        >
                                                            {activeSalesLoading ? 'Loading...' : 'Refresh Active Sales'}
                                                        </Button>
                                                        {activeSales.length === 0 ? (
                                                            <Alert variant="info">No active sales found.</Alert>
                                                        ) : (
                                                            <Table striped bordered hover size="sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Sale ID</th>
                                                                        <th>Pokemon</th>
                                                                        <th>Level</th>
                                                                        <th>Seller</th>
                                                                        <th>Current Price</th>
                                                                        <th>Type</th>
                                                                        <th>Created</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {activeSales.map((sale) => (
                                                                        <tr 
                                                                            key={sale.id}
                                                                            style={{ 
                                                                                cursor: buyPriceChangeModal.sale?.id === sale.id ? 'default' : 'pointer',
                                                                                backgroundColor: buyPriceChangeModal.sale?.id === sale.id ? '#d1ecf1' : ''
                                                                            }}
                                                                            onClick={() => {
                                                                                setBuyPriceChangeModal({ 
                                                                                    show: true, 
                                                                                    sale: sale, 
                                                                                    newPrice: buyPriceChangeModal.newPrice,
                                                                                    reason: buyPriceChangeModal.reason 
                                                                                });
                                                                            }}
                                                                        >
                                                                            <td>{sale.id}</td>
                                                                            <td>
                                                                                <img 
                                                                                    src={`/images/pokemon/${sale.pokemon_id_wild || sale.wild_id}.gif`} 
                                                                                    alt={sale.pokemon_name || sale.naam}
                                                                                    style={{ width: '40px', height: '40px' }}
                                                                                    className="me-2"
                                                                                />
                                                                                {sale.pokemon_name || sale.naam} {sale.shiny ? '✨' : ''}
                                                                            </td>
                                                                            <td>{sale.level}</td>
                                                                            <td>{sale.seller_username || `ID: ${sale.seller_id}`}</td>
                                                                            <td>
                                                                                <img 
                                                                                    src={sale.currency_type === 'gold' ? '/images/mock-04.png' : '/images/mock-05.png'} 
                                                                                    alt={sale.currency_type} 
                                                                                    style={{ width: '20px', height: '20px' }}
                                                                                    className="me-1"
                                                                                />
                                                                                {sale.price.toLocaleString()}
                                                                            </td>
                                                                            <td><Badge bg="info">{sale.sale_type}</Badge></td>
                                                                            <td><small>{new Date(sale.created_at).toLocaleString()}</small></td>
                                                                            <td>
                                                                                <Button 
                                                                                    size="sm" 
                                                                                    variant="success"
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setBuyPriceChangeModal({ 
                                                                                            show: true, 
                                                                                            sale: sale, 
                                                                                            newPrice: '',
                                                                                            reason: '' 
                                                                                        });
                                                                                    }}
                                                                                >
                                                                                    Select
                                                                                </Button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        )}
                                                        {buyPriceChangeModal.sale && (
                                                            <div className="mt-3 p-3 border rounded" style={{ backgroundColor: '#d1ecf1' }}>
                                                                <h6>Selected Sale: #{buyPriceChangeModal.sale.id}</h6>
                                                                <p><strong>Pokemon:</strong> {buyPriceChangeModal.sale.pokemon_name || buyPriceChangeModal.sale.naam} (Level {buyPriceChangeModal.sale.level})</p>
                                                                <p><strong>Seller:</strong> {buyPriceChangeModal.sale.seller_username || `ID: ${buyPriceChangeModal.sale.seller_id}`}</p>
                                                                <p><strong>Current Price:</strong> {buyPriceChangeModal.sale.price.toLocaleString()} {buyPriceChangeModal.sale.currency_type}</p>
                                                                <Form.Group className="mb-3 mt-3">
                                                                    <Form.Label>New Price</Form.Label>
                                                                    <Form.Control 
                                                                        type="number"
                                                                        min="1"
                                                                        placeholder="Enter new price"
                                                                        value={buyPriceChangeModal.newPrice}
                                                                        onChange={(e) => setBuyPriceChangeModal({ ...buyPriceChangeModal, newPrice: e.target.value })}
                                                                    />
                                                                </Form.Group>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Reason (Optional)</Form.Label>
                                                                    <Form.Control 
                                                                        as="textarea"
                                                                        rows={3}
                                                                        placeholder="Enter reason for price change..."
                                                                        value={buyPriceChangeModal.reason}
                                                                        onChange={(e) => setBuyPriceChangeModal({ ...buyPriceChangeModal, reason: e.target.value })}
                                                                    />
                                                                </Form.Group>
                                                                <Button 
                                                                    variant="success"
                                                                    onClick={handleBuyWithPriceChange}
                                                                    disabled={!buyPriceChangeModal.newPrice || buyPriceChangeModal.newPrice <= 0}
                                                                    className="me-2"
                                                                >
                                                                    Buy Pokemon with New Price
                                                                </Button>
                                                                <Button 
                                                                    variant="secondary"
                                                                    onClick={() => setBuyPriceChangeModal({ show: false, sale: null, newPrice: '', reason: '' })}
                                                                >
                                                                    Clear Selection
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </Tab>
                                            )}
                                        </Tabs>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}
                </Container>
            </GoldSiverHeader>
            
            {/* Create Room Modal */}
            <Modal show={showCreateRoomModal} onHide={() => setShowCreateRoomModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Create New Chat Room</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Room Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter room name..."
                            value={newRoomName}
                            onChange={(e) => setNewRoomName(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Room Type</Form.Label>
                        <Form.Select
                            value={newRoomType}
                            onChange={(e) => setNewRoomType(e.target.value)}
                        >
                            <option value="public">Public</option>
                            <option value="private">Private</option>
                            <option value="vip">VIP</option>
                            <option value="event">Event</option>
                        </Form.Select>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowCreateRoomModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={handleCreateRoom}>
                        Create Room
                    </Button>
                </Modal.Footer>
            </Modal>
            
            {/* Pokemon Attacks Modal */}
            <Modal 
                show={attacksModalOpen} 
                onHide={handleCloseAttacksModal}
                size="xl"
                centered
            >
                <Modal.Header closeButton className="bg-dark text-white">
                    <Modal.Title>
                        {selectedPokemonForAttacks && (
                            <>
                                Manage Attacks - {selectedPokemonForAttacks.naam} (#{selectedPokemonForAttacks.wild_id})
                                <small className="ms-2 text-muted">
                                    Type: {selectedPokemonForAttacks.type1}{selectedPokemonForAttacks.type2 ? ` / ${selectedPokemonForAttacks.type2}` : ''}
                                </small>
                            </>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-dark text-white">
                    {pokemonAttacksLoading ? (
                        <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            {/* Attack Buttons - Click to Edit */}
                            <p className="text-muted small mb-2">👆 Click on an attack button to edit it:</p>
                            <div className="d-flex flex-wrap justify-content-center gap-3 mb-4">
                                {[1, 2, 3, 4].map(num => {
                                    const attack = editedAttacks[num];
                                    const isSelected = selectedAttackSlot === num;
                                    const typeColor = getTypeColor(attack.attack_type);
                                    
                                    return (
                                        <div 
                                            key={num}
                                            className="position-relative"
                                            style={{
                                                width: '200px',
                                                height: '80px',
                                                backgroundImage: 'url(/images/battle/selAt.png)',
                                                backgroundSize: '100% 100%',
                                                backgroundRepeat: 'no-repeat',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                transition: 'all 0.2s ease',
                                                transform: isSelected ? 'scale(1.1)' : 'scale(1)',
                                                boxShadow: isSelected ? `0 0 20px ${typeColor}` : 'none',
                                                border: isSelected ? `3px solid ${typeColor}` : 'none',
                                                borderRadius: '8px'
                                            }}
                                            onClick={() => handleAttackButtonClick(num)}
                                            onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.transform = 'scale(1.05)'; }}
                                            onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.transform = 'scale(1)'; }}
                                        >
                                            <span style={{
                                                color: '#fff',
                                                fontWeight: 'bold',
                                                fontSize: '14px',
                                                textShadow: '1px 1px 2px rgba(0,0,0,0.8)',
                                                textAlign: 'center',
                                                padding: '0 10px'
                                            }}>
                                                {attack.attack_name || `Attack ${num}`}
                                            </span>
                                            {attack.attack_name && (
                                                <div style={{ fontSize: '10px', opacity: 0.8, marginTop: '2px' }}>
                                                    <span style={{ 
                                                        backgroundColor: typeColor, 
                                                        padding: '1px 6px', 
                                                        borderRadius: '10px',
                                                        marginRight: '4px'
                                                    }}>
                                                        {attack.attack_type || '?'}
                                                    </span>
                                                    Lv.{attack.level_learned} | Pwr:{attack.attack_power}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                            
                            {/* Attack Detail Editor - Shows when an attack is selected */}
                            {selectedAttackSlot && (
                                <Card className="bg-secondary mb-4">
                                    <Card.Header className="d-flex justify-content-between align-items-center">
                                        <span>✏️ Editing Attack {selectedAttackSlot}</span>
                                        <Button 
                                            variant="outline-light" 
                                            size="sm"
                                            onClick={() => setSelectedAttackSlot(null)}
                                        >
                                            ✕ Close Editor
                                        </Button>
                                    </Card.Header>
                                    <Card.Body>
                                        <Row>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Attack Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter attack name..."
                                                        value={editedAttacks[selectedAttackSlot].attack_name}
                                                        onChange={(e) => setEditedAttacks({
                                                            ...editedAttacks,
                                                            [selectedAttackSlot]: { ...editedAttacks[selectedAttackSlot], attack_name: e.target.value }
                                                        })}
                                                        list="attack-names-list"
                                                    />
                                                    <datalist id="attack-names-list">
                                                        {allAttacks.map(a => (
                                                            <option key={a.id} value={a.naam} />
                                                        ))}
                                                    </datalist>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Type</Form.Label>
                                                    <Form.Select
                                                        value={editedAttacks[selectedAttackSlot].attack_type}
                                                        onChange={(e) => setEditedAttacks({
                                                            ...editedAttacks,
                                                            [selectedAttackSlot]: { ...editedAttacks[selectedAttackSlot], attack_type: e.target.value }
                                                        })}
                                                        style={{ backgroundColor: getTypeColor(editedAttacks[selectedAttackSlot].attack_type), color: '#fff' }}
                                                    >
                                                        <option value="">Select Type</option>
                                                        {attackTypes.map(type => (
                                                            <option key={type} value={type} style={{ backgroundColor: getTypeColor(type) }}>
                                                                {type}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Learn at Level</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="1"
                                                        max="100"
                                                        value={editedAttacks[selectedAttackSlot].level_learned}
                                                        onChange={(e) => setEditedAttacks({
                                                            ...editedAttacks,
                                                            [selectedAttackSlot]: { ...editedAttacks[selectedAttackSlot], level_learned: parseInt(e.target.value) || 1 }
                                                        })}
                                                    />
                                                    <Form.Text className="text-muted">
                                                        Pokemon learns this at level {editedAttacks[selectedAttackSlot].level_learned}
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Power</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="0"
                                                        max="300"
                                                        value={editedAttacks[selectedAttackSlot].attack_power}
                                                        onChange={(e) => setEditedAttacks({
                                                            ...editedAttacks,
                                                            [selectedAttackSlot]: { ...editedAttacks[selectedAttackSlot], attack_power: parseInt(e.target.value) || 0 }
                                                        })}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>PP</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="1"
                                                        max="40"
                                                        value={editedAttacks[selectedAttackSlot].attack_pp}
                                                        onChange={(e) => setEditedAttacks({
                                                            ...editedAttacks,
                                                            [selectedAttackSlot]: { ...editedAttacks[selectedAttackSlot], attack_pp: parseInt(e.target.value) || 10 }
                                                        })}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Accuracy %</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="0"
                                                        max="100"
                                                        value={editedAttacks[selectedAttackSlot].attack_accuracy}
                                                        onChange={(e) => setEditedAttacks({
                                                            ...editedAttacks,
                                                            [selectedAttackSlot]: { ...editedAttacks[selectedAttackSlot], attack_accuracy: parseInt(e.target.value) || 100 }
                                                        })}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Category</Form.Label>
                                                    <Form.Select
                                                        value={editedAttacks[selectedAttackSlot].attack_category}
                                                        onChange={(e) => setEditedAttacks({
                                                            ...editedAttacks,
                                                            [selectedAttackSlot]: { ...editedAttacks[selectedAttackSlot], attack_category: e.target.value }
                                                        })}
                                                    >
                                                        <option value="Physical">Physical</option>
                                                        <option value="Special">Special</option>
                                                        <option value="Status">Status</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <div className="d-flex justify-content-between">
                                            <Button 
                                                variant="outline-danger" 
                                                size="sm"
                                                onClick={() => setEditedAttacks({
                                                    ...editedAttacks,
                                                    [selectedAttackSlot]: { attack_name: '', level_learned: 1, attack_type: '', attack_power: 0, attack_pp: 10, attack_accuracy: 100, attack_category: 'Physical' }
                                                })}
                                            >
                                                Clear This Attack
                                            </Button>
                                            <Button 
                                                variant="success" 
                                                onClick={() => handleSaveSingleAttack(selectedAttackSlot)}
                                                disabled={saveAttackLoading}
                                            >
                                                {saveAttackLoading ? 'Saving...' : `Save Attack ${selectedAttackSlot}`}
                                            </Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            )}
                            
                            {/* Learnable Attacks by Level (Level-up only, no TM/Egg) */}
                            {pokemonAttacks.length > 0 && (() => {
                                // Filter only level-up moves (no TM, no Egg)
                                const levelUpMoves = pokemonAttacks
                                    .filter(a => a.learn_method === 'level' || !a.learn_method)
                                    .sort((a, b) => (a.level_learned || 0) - (b.level_learned || 0));
                                
                                return (
                                    <div className="mt-4 mb-4">
                                        <h6 className="mb-2 text-success">
                                            📚 Level-up Moves ({levelUpMoves.length} moves)
                                        </h6>
                                        <div style={{ maxHeight: '300px', overflowY: 'auto' }} className="bg-secondary p-2 rounded">
                                            <Table size="sm" variant="dark" striped hover className="mb-0" style={{ fontSize: '12px' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{width: '60px'}}>Level</th>
                                                        <th>Move Name</th>
                                                        <th style={{width: '80px'}}>Type</th>
                                                        <th style={{width: '70px'}}>Category</th>
                                                        <th style={{width: '60px'}}>Power</th>
                                                        <th style={{width: '60px'}}>Acc%</th>
                                                        <th style={{width: '50px'}}>PP</th>
                                                        <th style={{width: '80px'}}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {levelUpMoves.map((attack, idx) => {
                                                        const isKnown = [
                                                            editedAttacks[1]?.attack_name,
                                                            editedAttacks[2]?.attack_name,
                                                            editedAttacks[3]?.attack_name,
                                                            editedAttacks[4]?.attack_name
                                                        ].includes(attack.attack_name);
                                                        
                                                        return (
                                                            <tr 
                                                                key={idx} 
                                                                style={{ 
                                                                    opacity: isKnown ? 0.5 : 1,
                                                                    backgroundColor: isKnown ? 'rgba(40, 167, 69, 0.2)' : 'transparent'
                                                                }}
                                                            >
                                                                <td className="text-center">
                                                                    <Badge bg="primary">
                                                                        Lv.{attack.level_learned || 1}
                                                                    </Badge>
                                                                </td>
                                                                <td>
                                                                    <strong>{attack.attack_name}</strong>
                                                                    {isKnown && <Badge bg="success" className="ms-1">✓</Badge>}
                                                                </td>
                                                                <td>
                                                                    <Badge style={{ backgroundColor: getTypeColor(attack.attack_type) }}>
                                                                        {attack.attack_type || '?'}
                                                                    </Badge>
                                                                </td>
                                                                <td className="text-center">
                                                                    <small className={
                                                                        attack.attack_category === 'Physical' ? 'text-danger' :
                                                                        attack.attack_category === 'Special' ? 'text-info' : 'text-secondary'
                                                                    }>
                                                                        {attack.attack_category || '-'}
                                                                    </small>
                                                                </td>
                                                                <td className="text-center fw-bold">{attack.attack_power || '-'}</td>
                                                                <td className="text-center">{attack.attack_accuracy || '-'}%</td>
                                                                <td className="text-center">{attack.attack_pp || '-'}</td>
                                                                <td className="text-center">
                                                                    {selectedAttackSlot && !isKnown ? (
                                                                        <Button
                                                                            variant="outline-success"
                                                                            size="sm"
                                                                            style={{ fontSize: '10px', padding: '2px 6px' }}
                                                                            onClick={() => {
                                                                                setEditedAttacks({
                                                                                    ...editedAttacks,
                                                                                    [selectedAttackSlot]: {
                                                                                        ...editedAttacks[selectedAttackSlot],
                                                                                        attack_name: attack.attack_name,
                                                                                        attack_type: attack.attack_type || '',
                                                                                        attack_power: attack.attack_power || 40,
                                                                                        attack_pp: attack.attack_pp || 10,
                                                                                        attack_accuracy: attack.attack_accuracy || 100,
                                                                                        attack_category: attack.attack_category || 'Physical',
                                                                                        level_learned: attack.level_learned || 1
                                                                                    }
                                                                                });
                                                                            }}
                                                                        >
                                                                            Use
                                                                        </Button>
                                                                    ) : !selectedAttackSlot && !isKnown ? (
                                                                        <small className="text-muted">Select slot</small>
                                                                    ) : (
                                                                        <small className="text-success">✓</small>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                        <small className="text-muted">
                                            💡 Click on an attack slot above, then click "Use" to assign a move to that slot
                                        </small>
                                    </div>
                                );
                            })()}
                            
                            {/* Quick Add from Database */}
                            {allAttacks.length > 0 && (
                                <div className="mt-3">
                                    <h6 className="mb-2">Quick Add from Database ({allAttacks.length} attacks)</h6>
                                    <Form.Control
                                        type="text"
                                        placeholder="Search attacks..."
                                        value={attackSearch}
                                        onChange={(e) => setAttackSearch(e.target.value)}
                                        className="mb-2"
                                        size="sm"
                                    />
                                    <div style={{ maxHeight: '120px', overflowY: 'auto', fontSize: '11px' }} className="bg-secondary p-2 rounded">
                                        {allAttacks
                                            .filter(a => !attackSearch || a.naam.toLowerCase().includes(attackSearch.toLowerCase()))
                                            .slice(0, 30)
                                            .map(attack => (
                                                <span 
                                                    key={attack.id}
                                                    className="badge me-1 mb-1"
                                                    style={{ 
                                                        cursor: 'pointer',
                                                        backgroundColor: getTypeColor(attack.soort)
                                                    }}
                                                    onClick={() => {
                                                        if (selectedAttackSlot) {
                                                            setEditedAttacks({
                                                                ...editedAttacks,
                                                                [selectedAttackSlot]: {
                                                                    ...editedAttacks[selectedAttackSlot],
                                                                    attack_name: attack.naam,
                                                                    attack_type: attack.soort || '',
                                                                    attack_power: attack.sterkte || 40
                                                                }
                                                            });
                                                        }
                                                    }}
                                                    title={`Type: ${attack.soort} | Power: ${attack.sterkte} | Click to use in selected slot`}
                                                >
                                                    {attack.naam}
                                                </span>
                                            ))
                                        }
                                    </div>
                                    {!selectedAttackSlot && (
                                        <small className="text-warning">👆 Select an attack slot above first, then click an attack to add it</small>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-dark">
                    <Button variant="secondary" onClick={handleCloseAttacksModal}>
                        Cancel
                    </Button>
                    <Button 
                        variant="primary" 
                        onClick={handleSaveAllAttacks}
                        disabled={saveAttackLoading || updateAttacksLoading}
                    >
                        {(saveAttackLoading || updateAttacksLoading) ? 'Saving...' : 'Save All Attacks'}
                    </Button>
                </Modal.Footer>
            </Modal>
            
            {/* Pokemon Evolutions Modal */}
            <Modal 
                show={evolutionsModalOpen} 
                onHide={handleCloseEvolutionsModal}
                size="lg"
                centered
            >
                <Modal.Header closeButton className="bg-dark text-white">
                    <Modal.Title>
                        {selectedPokemonForEvolutions && (
                            <>
                                Manage Evolutions - {selectedPokemonForEvolutions.naam} (#{selectedPokemonForEvolutions.wild_id})
                            </>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-dark text-white">
                    {pokemonEvolutionsLoading ? (
                        <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            {/* Existing Evolutions */}
                            <h5 className="mb-3">Existing Evolutions</h5>
                            {pokemonEvolutions.length === 0 ? (
                                <Alert variant="info">No evolutions defined for this Pokemon yet.</Alert>
                            ) : (
                                <Table striped bordered hover variant="dark" size="sm" className="mb-4">
                                    <thead>
                                        <tr>
                                            <th>Level</th>
                                            <th>Evolves To</th>
                                            <th>Trade</th>
                                            <th>Item</th>
                                            <th>Time</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pokemonEvolutions.map((evolution) => {
                                            const evolvedPokemon = pokemons.find(p => p.wild_id === evolution.nieuw_id);
                                            return (
                                                <tr key={evolution.id}>
                                                    <td>{evolution.level}</td>
                                                    <td>
                                                        {evolvedPokemon ? (
                                                            <strong>{evolvedPokemon.naam} (#{evolution.nieuw_id})</strong>
                                                        ) : (
                                                            `#${evolution.nieuw_id}`
                                                        )}
                                                    </td>
                                                    <td>{evolution.trade ? 'Yes' : 'No'}</td>
                                                    <td>{evolution.item || '-'}</td>
                                                    <td>{evolution.time || '-'}</td>
                                                    <td>
                                                        <Button
                                                            variant="warning"
                                                            size="sm"
                                                            className="me-2"
                                                            onClick={() => handleEditEvolution(evolution)}
                                                        >
                                                            Edit
                                                        </Button>
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => handleDeleteEvolution(evolution)}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            )}
                            
                            {/* Add/Edit Evolution Form */}
                            <hr className="my-4" />
                            <h5 className="mb-3">{editingEvolution ? 'Edit Evolution' : 'Add New Evolution'}</h5>
                            <Form>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Evolution Level *</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min="1"
                                                max="100"
                                                value={newEvolution.level}
                                                onChange={(e) => setNewEvolution({ ...newEvolution, level: parseInt(e.target.value) || 1 })}
                                                required
                                            />
                                            <Form.Text className="text-muted">Level at which Pokemon evolves (1-100)</Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Evolved Pokemon *</Form.Label>
                                            <div className="position-relative">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Search Pokemon by name or ID..."
                                                    value={evolutionPokemonSearch}
                                                    onChange={(e) => handleEvolutionPokemonSearch(e.target.value)}
                                                />
                                                {evolutionPokemonSearchResults.length > 0 && (
                                                    <div 
                                                        className="position-absolute w-100 bg-dark border border-secondary rounded mt-1"
                                                        style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}
                                                    >
                                                        {evolutionPokemonSearchResults.map((pokemon) => (
                                                            <div
                                                                key={pokemon.wild_id}
                                                                className="p-2 border-bottom border-secondary cursor-pointer"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => handleSelectEvolvedPokemon(pokemon)}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#333'}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                            >
                                                                <strong>{pokemon.naam}</strong> (#{pokemon.wild_id})
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                            {newEvolution.nieuw_id && (
                                                <Form.Text className="text-success">
                                                    Selected: {pokemons.find(p => p.wild_id === newEvolution.nieuw_id)?.naam} (#{newEvolution.nieuw_id})
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Check
                                                type="checkbox"
                                                label="Requires Trade"
                                                checked={newEvolution.trade === 1}
                                                onChange={(e) => setNewEvolution({ ...newEvolution, trade: e.target.checked ? 1 : 0 })}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Required Item</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="e.g., Fire Stone"
                                                value={newEvolution.item}
                                                onChange={(e) => setNewEvolution({ ...newEvolution, item: e.target.value })}
                                            />
                                            <Form.Text className="text-muted">Leave empty if no item required</Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Time of Day</Form.Label>
                                            <Form.Select
                                                value={newEvolution.time}
                                                onChange={(e) => setNewEvolution({ ...newEvolution, time: e.target.value })}
                                            >
                                                <option value="">Any Time</option>
                                                <option value="day">Day</option>
                                                <option value="night">Night</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-dark">
                    <Button variant="secondary" onClick={handleCloseEvolutionsModal}>
                        Cancel
                    </Button>
                    {!editingEvolution && (
                        <Button 
                            variant="success" 
                            onClick={handleSaveEvolution}
                            disabled={saveEvolutionLoading || !newEvolution.level || !newEvolution.nieuw_id}
                        >
                            {saveEvolutionLoading ? 'Saving...' : 'Add Evolution'}
                        </Button>
                    )}
                    {editingEvolution && (
                        <>
                            <Button 
                                variant="secondary"
                                onClick={() => {
                                    setEditingEvolution(null);
                                    setNewEvolution({
                                        level: 16,
                                        nieuw_id: '',
                                        trade: 0,
                                        item: '',
                                        time: ''
                                    });
                                    setEvolutionPokemonSearch('');
                                }}
                            >
                                Cancel Edit
                            </Button>
                            <Button 
                                variant="primary" 
                                onClick={handleSaveEvolution}
                                disabled={saveEvolutionLoading || !newEvolution.level || !newEvolution.nieuw_id}
                            >
                                {saveEvolutionLoading ? 'Saving...' : 'Update Evolution'}
                            </Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
            
            {/* Pokemon Import Modal */}
            <Modal 
                show={importModalOpen} 
                onHide={handleCloseImportModal}
                size="xl"
                centered
            >
                <Modal.Header closeButton className="bg-info text-white">
                    <Modal.Title>
                        {importingPokemon && (
                            <>
                                📥 Import Data - {importingPokemon.naam} (#{importingPokemon.wild_id})
                            </>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-dark text-white">
                    {importLoading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-info" role="status" style={{ width: '3rem', height: '3rem' }}>
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3">Fetching data from PokemonDB.net...</p>
                        </div>
                    ) : importResults ? (
                        <div className="text-center py-4">
                            <div className="mb-4">
                                <span className="display-4">✅</span>
                            </div>
                            <h4 className="text-success mb-3">Import Successful!</h4>
                            <div className="d-flex justify-content-center gap-4">
                                {importResults.stats_updated && (
                                    <Badge bg="success" className="p-2 fs-6">Stats Updated</Badge>
                                )}
                                {importResults.types_updated && (
                                    <Badge bg="primary" className="p-2 fs-6">Types Updated</Badge>
                                )}
                                {importResults.moves_imported > 0 && (
                                    <Badge bg="warning" className="p-2 fs-6">{importResults.moves_imported} Moves Imported</Badge>
                                )}
                            </div>
                        </div>
                    ) : importPreviewData ? (
                        <>
                            {/* Types */}
                            <div className="mb-4">
                                <h5 className="border-bottom pb-2 mb-3">🏷️ Types</h5>
                                <div className="d-flex gap-2">
                                    {importPreviewData.types?.map((type, idx) => (
                                        <Badge 
                                            key={idx} 
                                            style={{ 
                                                backgroundColor: getTypeColor(type),
                                                fontSize: '1rem',
                                                padding: '8px 16px'
                                            }}
                                        >
                                            {type}
                                        </Badge>
                                    ))}
                                </div>
                            </div>
                            
                            {/* Base Stats */}
                            <div className="mb-4">
                                <h5 className="border-bottom pb-2 mb-3">📊 Base Stats</h5>
                                {importPreviewData.base_stats && (
                                    <Row>
                                        <Col md={4}>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>HP:</span>
                                                <strong className="text-success">{importPreviewData.base_stats.hp}</strong>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>Attack:</span>
                                                <strong className="text-danger">{importPreviewData.base_stats.attack}</strong>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>Defense:</span>
                                                <strong className="text-warning">{importPreviewData.base_stats.defense}</strong>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>Sp. Atk:</span>
                                                <strong className="text-info">{importPreviewData.base_stats.sp_atk}</strong>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>Sp. Def:</span>
                                                <strong className="text-primary">{importPreviewData.base_stats.sp_def}</strong>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>Speed:</span>
                                                <strong className="text-secondary">{importPreviewData.base_stats.speed}</strong>
                                            </div>
                                        </Col>
                                        <Col xs={12}>
                                            <div className="mt-2 text-center">
                                                <Badge bg="dark" className="px-4 py-2 fs-6">
                                                    Total: {importPreviewData.base_stats.total}
                                                </Badge>
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                            </div>
                            
                            {/* Level-up Moves */}
                            <div className="mb-4">
                                <h5 className="border-bottom pb-2 mb-3">
                                    ⚔️ Level-up Moves 
                                    <Badge bg="info" className="ms-2">{importPreviewData.level_moves?.length || 0}</Badge>
                                </h5>
                                {importPreviewData.level_moves?.length > 0 ? (
                                    <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                        <Table striped bordered hover variant="dark" size="sm">
                                            <thead style={{ position: 'sticky', top: 0 }}>
                                                <tr>
                                                    <th>Lv.</th>
                                                    <th>Move</th>
                                                    <th>Type</th>
                                                    <th>Category</th>
                                                    <th>Power</th>
                                                    <th>Acc.</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {importPreviewData.level_moves.map((move, idx) => (
                                                    <tr key={idx}>
                                                        <td>{move.level}</td>
                                                        <td><strong>{move.name}</strong></td>
                                                        <td>
                                                            <Badge style={{ backgroundColor: getTypeColor(move.type) }}>
                                                                {move.type}
                                                            </Badge>
                                                        </td>
                                                        <td>{move.category}</td>
                                                        <td>{move.power || '-'}</td>
                                                        <td>{move.accuracy}%</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                ) : (
                                    <Alert variant="secondary">No level-up moves found</Alert>
                                )}
                            </div>
                            
                            {/* TM Moves */}
                            <div className="mb-4">
                                <h5 className="border-bottom pb-2 mb-3">
                                    💿 TM Moves 
                                    <Badge bg="warning" className="ms-2">{importPreviewData.tm_moves?.length || 0}</Badge>
                                </h5>
                                {importPreviewData.tm_moves?.length > 0 ? (
                                    <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                        <Table striped bordered hover variant="dark" size="sm">
                                            <thead style={{ position: 'sticky', top: 0 }}>
                                                <tr>
                                                    <th>TM#</th>
                                                    <th>Move</th>
                                                    <th>Type</th>
                                                    <th>Category</th>
                                                    <th>Power</th>
                                                    <th>Acc.</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {importPreviewData.tm_moves.map((move, idx) => (
                                                    <tr key={idx}>
                                                        <td>TM{move.tm_number}</td>
                                                        <td><strong>{move.name}</strong></td>
                                                        <td>
                                                            <Badge style={{ backgroundColor: getTypeColor(move.type) }}>
                                                                {move.type}
                                                            </Badge>
                                                        </td>
                                                        <td>{move.category}</td>
                                                        <td>{move.power || '-'}</td>
                                                        <td>{move.accuracy}%</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                ) : (
                                    <Alert variant="secondary">No TM moves found</Alert>
                                )}
                            </div>
                            
                            {/* Egg Moves */}
                            {importPreviewData.egg_moves?.length > 0 && (
                                <div className="mb-4">
                                    <h5 className="border-bottom pb-2 mb-3">
                                        🥚 Egg Moves 
                                        <Badge bg="success" className="ms-2">{importPreviewData.egg_moves.length}</Badge>
                                    </h5>
                                    <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
                                        <Table striped bordered hover variant="dark" size="sm">
                                            <thead style={{ position: 'sticky', top: 0 }}>
                                                <tr>
                                                    <th>Move</th>
                                                    <th>Type</th>
                                                    <th>Category</th>
                                                    <th>Power</th>
                                                    <th>Acc.</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {importPreviewData.egg_moves.map((move, idx) => (
                                                    <tr key={idx}>
                                                        <td><strong>{move.name}</strong></td>
                                                        <td>
                                                            <Badge style={{ backgroundColor: getTypeColor(move.type) }}>
                                                                {move.type}
                                                            </Badge>
                                                        </td>
                                                        <td>{move.category}</td>
                                                        <td>{move.power || '-'}</td>
                                                        <td>{move.accuracy}%</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            )}
                            
                            {/* Source Link */}
                            <div className="text-center mt-4">
                                <small className="text-muted">
                                    Data from: <a href={importPreviewData.url} target="_blank" rel="noopener noreferrer" className="text-info">{importPreviewData.url}</a>
                                </small>
                            </div>
                        </>
                    ) : (
                        <Alert variant="warning">Failed to load preview data. Please try again.</Alert>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-dark">
                    <Button variant="secondary" onClick={handleCloseImportModal}>
                        {importResults ? 'Close' : 'Cancel'}
                    </Button>
                    {importPreviewData && !importResults && (
                        <>
                            <Button 
                                variant="outline-info" 
                                onClick={() => handleImportConfirm(true, false)}
                                disabled={importLoading}
                            >
                                Import Stats Only
                            </Button>
                            <Button 
                                variant="outline-warning" 
                                onClick={() => handleImportConfirm(false, true)}
                                disabled={importLoading}
                            >
                                Import Moves Only
                            </Button>
                            <Button 
                                variant="success" 
                                onClick={() => handleImportConfirm(true, true)}
                                disabled={importLoading}
                            >
                                {importLoading ? 'Importing...' : '✅ Import All'}
                            </Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
            
            {/* Map Modal */}
            <Modal show={showMapModal} onHide={() => {
                setShowMapModal(false);
                setEditingMap(null);
                setNewMap({ name: '', image_path: '', city_id: null, city_name: '', order: 0, is_active: 1, required_level: 0 });
                setCitySearch('');
                setCities([]);
            }} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{editingMap ? 'Edit Map' : 'Create New Map'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Map Name *</Form.Label>
                            <Form.Control
                                type="text"
                                value={editingMap ? editingMap.name : newMap.name}
                                onChange={(e) => editingMap ? setEditingMap({ ...editingMap, name: e.target.value }) : setNewMap({ ...newMap, name: e.target.value })}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Map Image *</Form.Label>
                            <Tabs defaultActiveKey="upload" id="image-select-tabs" className="mb-3">
                                <Tab eventKey="upload" title="📤 Upload">
                                    <Form.Control
                                        type="file"
                                        accept="image/*"
                                        onChange={handleMapImageUpload}
                                        disabled={uploadingImage}
                                        className="mb-2"
                                    />
                                    <Form.Text className="text-muted">
                                        {uploadingImage ? 'Uploading...' : 'Upload image file. It will be saved to /api/assets/images/maps/[map_name]/'}
                                    </Form.Text>
                                </Tab>
                                <Tab eventKey="browse" title="📁 Browse">
                                    <div className="mb-2">
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                            {imageBrowserPath && (
                                                <Button 
                                                    variant="outline-secondary" 
                                                    size="sm"
                                                    onClick={() => {
                                                        const parentPath = imageBrowserPath.split('/').slice(0, -1).join('/');
                                                        loadImageBrowser(parentPath);
                                                    }}
                                                >
                                                    ← Back
                                                </Button>
                                            )}
                                            <span className="text-muted small">
                                                {imageBrowserPath ? `Path: ${imageBrowserPath}` : 'Root: /images/maps/'}
                                            </span>
                                        </div>
                                    </div>
                                    {imageBrowserLoading ? (
                                        <div className="text-center p-4">
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : imageBrowserItems.length === 0 ? (
                                        <Alert variant="info" className="mb-0">No images or folders found in this directory.</Alert>
                                    ) : (
                                        <div className="row g-2" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                            {imageBrowserItems.map((item, index) => (
                                                <div key={index} className="col-md-3 col-sm-4 col-6">
                                                    {item.type === 'directory' ? (
                                                        <div
                                                            className="card h-100"
                                                            style={{ cursor: 'pointer', minHeight: '100px' }}
                                                            onClick={() => loadImageBrowser(item.path)}
                                                            onMouseEnter={(e) => e.currentTarget.style.borderColor = '#007bff'}
                                                            onMouseLeave={(e) => e.currentTarget.style.borderColor = '#dee2e6'}
                                                        >
                                                            <div className="card-body text-center p-2">
                                                                <div style={{ fontSize: '36px' }}>📁</div>
                                                                <div className="mt-1" style={{ fontSize: '11px', wordBreak: 'break-word' }}>
                                                                    {item.name}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className="card h-100"
                                                            style={{ cursor: 'pointer', minHeight: '100px' }}
                                                            onClick={() => {
                                                                const imagePath = item.url;
                                                                if (editingMap) {
                                                                    setEditingMap({ ...editingMap, image_path: imagePath });
                                                                } else {
                                                                    setNewMap({ ...newMap, image_path: imagePath });
                                                                }
                                                                toast.success('Image selected');
                                                            }}
                                                            onMouseEnter={(e) => e.currentTarget.style.borderColor = '#007bff'}
                                                            onMouseLeave={(e) => e.currentTarget.style.borderColor = '#dee2e6'}
                                                        >
                                                            <img
                                                                src={item.url}
                                                                alt={item.name}
                                                                className="card-img-top"
                                                                style={{ 
                                                                    height: '80px', 
                                                                    objectFit: 'cover',
                                                                    backgroundColor: '#f8f9fa'
                                                                }}
                                                                onError={(e) => {
                                                                    e.target.src = '/images/loading.gif';
                                                                }}
                                                            />
                                                            <div className="card-body p-1">
                                                                <div style={{ fontSize: '10px', wordBreak: 'break-word' }}>
                                                                    {item.name}
                                                                </div>
                                                                <div style={{ fontSize: '9px', color: '#6c757d' }}>
                                                                    {(item.size / 1024).toFixed(1)} KB
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </Tab>
                            </Tabs>
                            {(editingMap?.image_path || newMap.image_path) && (
                                <div className="mt-2">
                                    <img 
                                        src={editingMap?.image_path || newMap.image_path} 
                                        alt="Map preview" 
                                        style={{ maxWidth: '100%', maxHeight: '200px', border: '1px solid #ccc' }}
                                        onError={(e) => {
                                            e.target.src = '/images/loading.gif';
                                        }}
                                    />
                                    <Form.Control
                                        type="text"
                                        className="mt-2"
                                        value={editingMap ? editingMap.image_path : newMap.image_path}
                                        onChange={(e) => editingMap ? setEditingMap({ ...editingMap, image_path: e.target.value }) : setNewMap({ ...newMap, image_path: e.target.value })}
                                        placeholder="Image path"
                                        required
                                    />
                                </div>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" style={{ position: 'relative' }}>
                            <Form.Label>City (optional)</Form.Label>
                            <Form.Control
                                type="text"
                                value={citySearch || (editingMap?.city_name || newMap.city_name || '')}
                                onChange={(e) => {
                                    setCitySearch(e.target.value);
                                    if (e.target.value === '') {
                                        if (editingMap) {
                                            setEditingMap({ ...editingMap, city_id: null, city_name: '' });
                                        } else {
                                            setNewMap({ ...newMap, city_id: null, city_name: '' });
                                        }
                                    }
                                }}
                                placeholder="Type to search cities..."
                                autoComplete="off"
                            />
                            {citySearch && citySearch.length > 0 && cities.length > 0 && (
                                <div style={{ 
                                    position: 'absolute', 
                                    zIndex: 1000, 
                                    backgroundColor: 'white', 
                                    border: '1px solid #ccc', 
                                    borderRadius: '4px',
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    width: '100%',
                                    marginTop: '2px',
                                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                                }}>
                                    {citySearchLoading ? (
                                        <div className="p-2 text-center">Loading...</div>
                                    ) : (
                                        cities.map((city) => (
                                            <div
                                                key={city.id}
                                                className="p-2"
                                                style={{ cursor: 'pointer', borderBottom: '1px solid #eee' }}
                                                onClick={() => {
                                                    if (editingMap) {
                                                        setEditingMap({ ...editingMap, city_id: city.id, city_name: city.name });
                                                    } else {
                                                        setNewMap({ ...newMap, city_id: city.id, city_name: city.name });
                                                    }
                                                    setCitySearch(city.name);
                                                    setCities([]);
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                            >
                                                {city.name} (ID: {city.id})
                                            </div>
                                        ))
                                    )}
                                </div>
                            )}
                            {(editingMap?.city_id || newMap.city_id) && (
                                <Form.Text className="text-muted">
                                    Selected: {editingMap?.city_name || newMap.city_name} (ID: {editingMap?.city_id || newMap.city_id})
                                </Form.Text>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>City Name (optional)</Form.Label>
                            <Form.Control
                                type="text"
                                value={editingMap ? (editingMap.city_name || '') : (newMap.city_name || '')}
                                onChange={(e) => editingMap ? setEditingMap({ ...editingMap, city_name: e.target.value }) : setNewMap({ ...newMap, city_name: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Display Order</Form.Label>
                            <Form.Control
                                type="number"
                                value={editingMap ? editingMap.order : newMap.order}
                                onChange={(e) => editingMap ? setEditingMap({ ...editingMap, order: parseInt(e.target.value) || 0 }) : setNewMap({ ...newMap, order: parseInt(e.target.value) || 0 })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Required Level (0 = No requirement)</Form.Label>
                            <Form.Control
                                type="number"
                                value={editingMap ? (editingMap.required_level || 0) : (newMap.required_level || 0)}
                                onChange={(e) => editingMap ? setEditingMap({ ...editingMap, required_level: parseInt(e.target.value) || 0 }) : setNewMap({ ...newMap, required_level: parseInt(e.target.value) || 0 })}
                                min="0"
                                placeholder="0"
                            />
                            <Form.Text className="text-muted">
                                Players must reach this level to unlock and view this map. Set to 0 to make it available to all players.
                            </Form.Text>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Check
                                type="checkbox"
                                label="Active"
                                checked={editingMap ? editingMap.is_active : newMap.is_active}
                                onChange={(e) => editingMap ? setEditingMap({ ...editingMap, is_active: e.target.checked ? 1 : 0 }) : setNewMap({ ...newMap, is_active: e.target.checked ? 1 : 0 })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                        setShowMapModal(false);
                        setEditingMap(null);
                        setNewMap({ name: '', image_path: '', city_id: null, city_name: '', order: 0, is_active: 1 });
                    }}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={editingMap ? handleUpdateMap : handleCreateMap}>
                        {editingMap ? 'Update Map' : 'Create Map'}
                    </Button>
                </Modal.Footer>
            </Modal>
            
            {/* Map Point Modal */}
            <Modal show={showPointModal} onHide={() => {
                        setShowPointModal(false);
                        setEditingPoint(null);
                        // Only reset if not in the middle of creating points from rectangles
                        if (pendingRectangles.length === 0) {
                            setNewPoint({ map_id: null, name: '', gebied: '', point_type: 'battle', target_url: '', x: 0, y: 0, width: 100, height: 100, tooltip: '', is_active: 1, required_level: 0, required_attacks: 0, next_point_id: null, trainer_id: null, silver_cost: null, trainer_image: null });
                        }
                    }} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{editingPoint ? 'Edit Map Point' : 'Create New Map Point'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!selectedMap && !editingPoint && (
                        <Alert variant="warning" className="mb-3">
                            <strong>Warning:</strong> No map selected. Please select a map first.
                        </Alert>
                    )}
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Point Name *</Form.Label>
                            <Form.Control
                                type="text"
                                value={editingPoint ? editingPoint.name : newPoint.name}
                                onChange={(e) => editingPoint ? setEditingPoint({ ...editingPoint, name: e.target.value }) : setNewPoint({ ...newPoint, name: e.target.value })}
                                required
                                isInvalid={!editingPoint && (!newPoint.name || newPoint.name.trim() === '')}
                            />
                            {!editingPoint && (!newPoint.name || newPoint.name.trim() === '') && (
                                <Form.Control.Feedback type="invalid">
                                    Point name is required
                                </Form.Control.Feedback>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Point Type *</Form.Label>
                            <Form.Select
                                value={editingPoint ? (editingPoint.point_type || 'battle') : (newPoint.point_type || 'battle')}
                                onChange={(e) => {
                                    const pointType = e.target.value;
                                    if (editingPoint) {
                                        setEditingPoint({ 
                                            ...editingPoint, 
                                            point_type: pointType,
                                            gebied: pointType === 'battle' ? editingPoint.gebied : '',
                                            target_url: pointType === 'navigation' ? editingPoint.target_url : '',
                                            trainer_id: pointType === 'trainer' ? editingPoint.trainer_id : null
                                        });
                                    } else {
                                        setNewPoint({ 
                                            ...newPoint, 
                                            point_type: pointType,
                                            gebied: pointType === 'battle' ? newPoint.gebied : '',
                                            target_url: pointType === 'navigation' ? newPoint.target_url : '',
                                            trainer_id: pointType === 'trainer' ? newPoint.trainer_id : null
                                        });
                                    }
                                }}
                            >
                                <option value="battle">Battle (קרב עם פוקימונים פראיים)</option>
                                <option value="trainer">Trainer Battle (קרב מאמן)</option>
                                <option value="navigation">Navigation (ניווט)</option>
                            </Form.Select>
                            <Form.Text className="text-muted">
                                Battle: Opens a battle with wild Pokémon. Trainer Battle: Battle with a trainer (requires trainer setup). Navigation: Navigates to a different page.
                            </Form.Text>
                        </Form.Group>
                        {((editingPoint && editingPoint.point_type === 'battle') || (!editingPoint && newPoint.point_type === 'battle')) && (
                            <Form.Group className="mb-3">
                                <Form.Label>Gebied (Area Identifier) *</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={editingPoint ? editingPoint.gebied : newPoint.gebied}
                                    onChange={(e) => editingPoint ? setEditingPoint({ ...editingPoint, gebied: e.target.value }) : setNewPoint({ ...newPoint, gebied: e.target.value })}
                                    placeholder="Lavagrot, Gras, Water, etc."
                                    required
                                    isInvalid={!editingPoint && (!newPoint.gebied || newPoint.gebied.trim() === '')}
                                />
                                <Form.Text className="text-muted">This is used in the battle system to identify the area</Form.Text>
                                {!editingPoint && (!newPoint.gebied || newPoint.gebied.trim() === '') && (
                                    <Form.Control.Feedback type="invalid">
                                        Gebied is required for battle points
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>
                        )}
                        {((editingPoint && editingPoint.point_type === 'trainer') || (!editingPoint && newPoint.point_type === 'trainer')) && (
                            <>
                                <Form.Group className="mb-3">
                                    <Form.Label>Select Trainer *</Form.Label>
                                    <Form.Select
                                        value={editingPoint ? (editingPoint.trainer_id || '') : (newPoint.trainer_id || '')}
                                        onChange={(e) => {
                                            const trainerId = e.target.value ? parseInt(e.target.value) : null;
                                            const selectedTrainer = trainers.find(t => t.id === trainerId);
                                            if (editingPoint) {
                                                setEditingPoint({ 
                                                    ...editingPoint, 
                                                    trainer_id: trainerId,
                                                    silver_cost: selectedTrainer ? selectedTrainer.silver_cost : null,
                                                    trainer_image: selectedTrainer ? selectedTrainer.trainer_image : null
                                                });
                                            } else {
                                                setNewPoint({ 
                                                    ...newPoint, 
                                                    trainer_id: trainerId,
                                                    silver_cost: selectedTrainer ? selectedTrainer.silver_cost : null,
                                                    trainer_image: selectedTrainer ? selectedTrainer.trainer_image : null
                                                });
                                            }
                                        }}
                                        required
                                    >
                                        <option value="">-- Select Trainer --</option>
                                        {trainers.filter(t => t.is_active).map((trainer) => (
                                            <option key={trainer.id} value={trainer.id}>
                                                {trainer.trainer_name} (Cost: {trainer.silver_cost} Silver, Pokemon: {trainer.pokemon?.length || 0})
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Form.Text className="text-muted">
                                        Select a trainer for this battle point. Trainers are configured in Trainers Management tab.
                                    </Form.Text>
                                </Form.Group>
                                {(editingPoint?.trainer_id || newPoint.trainer_id) && (
                                    <>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Override Silver Cost (Optional)</Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={editingPoint ? (editingPoint.silver_cost || '') : (newPoint.silver_cost || '')}
                                                onChange={(e) => {
                                                    const cost = e.target.value ? parseInt(e.target.value) : null;
                                                    editingPoint ? setEditingPoint({ ...editingPoint, silver_cost: cost }) : setNewPoint({ ...newPoint, silver_cost: cost });
                                                }}
                                                placeholder="Leave empty to use trainer's default cost"
                                                min="0"
                                            />
                                            <Form.Text className="text-muted">
                                                Override the trainer's default silver cost for this specific point. Leave empty to use trainer's default.
                                            </Form.Text>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Override Trainer Image (Optional)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={editingPoint ? (editingPoint.trainer_image || '') : (newPoint.trainer_image || '')}
                                                onChange={(e) => {
                                                    const image = e.target.value || null;
                                                    editingPoint ? setEditingPoint({ ...editingPoint, trainer_image: image }) : setNewPoint({ ...newPoint, trainer_image: image });
                                                }}
                                                placeholder="Leave empty to use trainer's default image"
                                            />
                                            <Form.Text className="text-muted">
                                                Override the trainer's default image for this specific point. Leave empty to use trainer's default.
                                            </Form.Text>
                                        </Form.Group>
                                    </>
                                )}
                            </>
                        )}
                        {((editingPoint && editingPoint.point_type === 'navigation') || (!editingPoint && newPoint.point_type === 'navigation')) && (
                            <Form.Group className="mb-3">
                                <Form.Label>Target URL / Path *</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={editingPoint ? (editingPoint.target_url || '') : (newPoint.target_url || '')}
                                    onChange={(e) => editingPoint ? setEditingPoint({ ...editingPoint, target_url: e.target.value }) : setNewPoint({ ...newPoint, target_url: e.target.value })}
                                    placeholder="/city, /shop, /gym, /home, etc."
                                    required
                                    isInvalid={!editingPoint && (!newPoint.target_url || newPoint.target_url.trim() === '')}
                                />
                                <Form.Text className="text-muted">
                                    The URL or path to navigate to when clicking this point (e.g., /city, /shop, /gym)
                                </Form.Text>
                                {!editingPoint && (!newPoint.target_url || newPoint.target_url.trim() === '') && (
                                    <Form.Control.Feedback type="invalid">
                                        Target URL is required for navigation points
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>
                        )}
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>X Position (%) *</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        value={editingPoint ? editingPoint.x : newPoint.x}
                                        onChange={(e) => {
                                            const val = parseFloat(e.target.value) || 0;
                                            editingPoint ? setEditingPoint({ ...editingPoint, x: val }) : setNewPoint({ ...newPoint, x: val });
                                        }}
                                        min="0"
                                        max="100"
                                        required
                                    />
                                    <Form.Text className="text-muted">You can use decimal values (e.g., 25.50)</Form.Text>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Y Position (%) *</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        value={editingPoint ? editingPoint.y : newPoint.y}
                                        onChange={(e) => {
                                            const val = parseFloat(e.target.value) || 0;
                                            editingPoint ? setEditingPoint({ ...editingPoint, y: val }) : setNewPoint({ ...newPoint, y: val });
                                        }}
                                        min="0"
                                        max="100"
                                        required
                                    />
                                    <Form.Text className="text-muted">You can use decimal values (e.g., 25.50)</Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Width (px)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={editingPoint ? editingPoint.width : newPoint.width}
                                        onChange={(e) => editingPoint ? setEditingPoint({ ...editingPoint, width: parseInt(e.target.value) || 100 }) : setNewPoint({ ...newPoint, width: parseInt(e.target.value) || 100 })}
                                        min="10"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Height (px)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={editingPoint ? editingPoint.height : newPoint.height}
                                        onChange={(e) => editingPoint ? setEditingPoint({ ...editingPoint, height: parseInt(e.target.value) || 100 }) : setNewPoint({ ...newPoint, height: parseInt(e.target.value) || 100 })}
                                        min="10"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-3">
                            <Form.Label>Tooltip (optional)</Form.Label>
                            <Form.Control
                                type="text"
                                value={editingPoint ? (editingPoint.tooltip || '') : (newPoint.tooltip || '')}
                                onChange={(e) => editingPoint ? setEditingPoint({ ...editingPoint, tooltip: e.target.value }) : setNewPoint({ ...newPoint, tooltip: e.target.value })}
                                placeholder="Hover text for this point"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Required Level (0 = No requirement)</Form.Label>
                            <Form.Control
                                type="number"
                                value={editingPoint ? (editingPoint.required_level || 0) : (newPoint.required_level || 0)}
                                onChange={(e) => editingPoint ? setEditingPoint({ ...editingPoint, required_level: parseInt(e.target.value) || 0 }) : setNewPoint({ ...newPoint, required_level: parseInt(e.target.value) || 0 })}
                                min="0"
                                placeholder="0"
                            />
                            <Form.Text className="text-muted">
                                Players must reach this level (rank) to unlock and access this point. Set to 0 to make it available to all players.
                            </Form.Text>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Required Attacks (0 = No requirement)</Form.Label>
                            <Form.Control
                                type="number"
                                value={editingPoint ? (editingPoint.required_attacks || 0) : (newPoint.required_attacks || 0)}
                                onChange={(e) => editingPoint ? setEditingPoint({ ...editingPoint, required_attacks: parseInt(e.target.value) || 0 }) : setNewPoint({ ...newPoint, required_attacks: parseInt(e.target.value) || 0 })}
                                min="0"
                                placeholder="0"
                            />
                            <Form.Text className="text-muted">
                                Number of attacks required on this point before the next point becomes available. Set to 0 to disable this feature.
                            </Form.Text>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Next Point (Unlock after required attacks)</Form.Label>
                            <Form.Select
                                value={editingPoint ? (editingPoint.next_point_id || '') : (newPoint.next_point_id || '')}
                                onChange={(e) => {
                                    const value = e.target.value === '' ? null : parseInt(e.target.value);
                                    editingPoint ? setEditingPoint({ ...editingPoint, next_point_id: value }) : setNewPoint({ ...newPoint, next_point_id: value });
                                }}
                            >
                                <option value="">None (No next point)</option>
                                {mapPoints
                                    .filter(point => {
                                        // Don't show the current point being edited in the list
                                        if (editingPoint && point.id === editingPoint.id) return false;
                                        // Only show points from the same map
                                        return point.map_id === (editingPoint ? editingPoint.map_id : (selectedMap ? selectedMap.id : null));
                                    })
                                    .map(point => (
                                        <option key={point.id} value={point.id}>
                                            {point.name} ({point.gebied || 'N/A'})
                                        </option>
                                    ))}
                            </Form.Select>
                            <Form.Text className="text-muted">
                                Select the next map point that will be unlocked after players attack this point the required number of times.
                            </Form.Text>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Check
                                type="checkbox"
                                label="Active"
                                checked={editingPoint ? editingPoint.is_active : newPoint.is_active}
                                onChange={(e) => editingPoint ? setEditingPoint({ ...editingPoint, is_active: e.target.checked ? 1 : 0 }) : setNewPoint({ ...newPoint, is_active: e.target.checked ? 1 : 0 })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                        setShowPointModal(false);
                        setEditingPoint(null);
                        setNewPoint({ map_id: null, name: '', gebied: '', point_type: 'battle', target_url: '', x: 0, y: 0, width: 100, height: 100, tooltip: '', is_active: 1, required_level: 0, required_attacks: 0, next_point_id: null });
                    }}>
                        Cancel
                    </Button>
                    <Button 
                        variant="primary" 
                        onClick={editingPoint ? handleUpdateMapPoint : handleCreateMapPoint}
                        disabled={
                            !editingPoint && (
                                !newPoint.name || 
                                newPoint.name.trim() === '' || 
                                (!newPoint.map_id && (!selectedMap || !selectedMap.id)) ||
                                (newPoint.point_type === 'battle' && (!newPoint.gebied || newPoint.gebied.trim() === '')) ||
                                (newPoint.point_type === 'trainer' && !newPoint.trainer_id) ||
                                (newPoint.point_type === 'navigation' && (!newPoint.target_url || newPoint.target_url.trim() === ''))
                            )
                        }
                    >
                        {editingPoint ? 'Update Point' : 'Create Point'}
                    </Button>
                </Modal.Footer>
            </Modal>
            
            {/* Add Pokemon to Point Modal */}
            <Modal show={showPokemonModal} onHide={() => {
                setShowPokemonModal(false);
                setNewPokemonToPoint({ pokemon_wild_id: null, spawn_rate: 100, min_level: 1, max_level: 100 });
                setEditingPokemonId(null);
                setBulkImportMode(false);
                setHtmlImportMode(false);
                setHtmlInput('');
                setBulkPokemonList([{ pokemon_wild_id: null, spawn_rate: 100, min_level: 1, max_level: 100, search: '' }]);
                setPokemonSearchInput('');
                setShowPokemonSearch(false);
            }} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{editingPokemonId ? 'Edit Pokemon' : 'Add Pokemon to Point'}: {selectedPoint?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {wildPokemonLoading ? (
                        <Alert variant="info">Loading pokemon...</Alert>
                    ) : (
                        <>
                            <div className="mb-3">
                                <Button 
                                    variant={!bulkImportMode && !htmlImportMode ? "primary" : "outline-primary"} 
                                    size="sm" 
                                    onClick={() => {
                                        setBulkImportMode(false);
                                        setHtmlImportMode(false);
                                        setBulkPokemonList([{ pokemon_wild_id: null, spawn_rate: 100, min_level: 1, max_level: 100, search: '' }]);
                                        setHtmlInput('');
                                    }}
                                    className="me-2"
                                >
                                    Single Pokemon
                                </Button>
                                <Button 
                                    variant={bulkImportMode && !htmlImportMode ? "primary" : "outline-primary"} 
                                    size="sm" 
                                    onClick={() => {
                                        setBulkImportMode(true);
                                        setHtmlImportMode(false);
                                        setHtmlInput('');
                                        if (bulkPokemonList.length === 0) {
                                            setBulkPokemonList([{ pokemon_wild_id: null, spawn_rate: 100, min_level: 1, max_level: 100, search: '' }]);
                                        }
                                    }}
                                    className="me-2"
                                >
                                    Bulk Import
                                </Button>
                                <Button 
                                    variant={htmlImportMode ? "primary" : "outline-primary"} 
                                    size="sm" 
                                    onClick={() => {
                                        setHtmlImportMode(true);
                                        setBulkImportMode(false);
                                        setHtmlInput('');
                                    }}
                                >
                                    HTML
                                </Button>
                            </div>
                            
                            {htmlImportMode ? (
                                <div>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Paste HTML Table</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={10}
                                            value={htmlInput}
                                            onChange={(e) => setHtmlInput(e.target.value)}
                                            placeholder="Paste HTML table here..."
                                            style={{ fontFamily: 'monospace', fontSize: '12px' }}
                                        />
                                        <Form.Text className="text-muted">
                                            Paste the HTML table from PokemonDB. The system will automatically extract Pokemon names and level ranges.
                                        </Form.Text>
                                    </Form.Group>
                                    <div className="mb-3">
                                        <Button variant="primary" onClick={handleHtmlImport} disabled={!htmlInput.trim()}>
                                            Parse HTML and Add to Pokemon List
                                        </Button>
                                    </div>
                                </div>
                            ) : !bulkImportMode ? (
                                <Form>
                                    <Form.Group className="mb-3" style={{ position: 'relative' }}>
                                        <Form.Label>Pokemon *</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={pokemonSearchInput || (newPokemonToPoint.pokemon_wild_id ? allWildPokemon.find(p => p.wild_id === newPokemonToPoint.pokemon_wild_id)?.naam || '' : '')}
                                            onChange={(e) => handlePokemonSearchChange(e.target.value)}
                                            placeholder="Search Pokemon by name, ID, or type..."
                                            required
                                        />
                                        {showPokemonSearch && pokemonSearchResults.length > 0 && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                right: 0,
                                                zIndex: 1000,
                                                backgroundColor: 'white',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                maxHeight: '300px',
                                                overflowY: 'auto',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                            }}>
                                                {pokemonSearchResults.map((pokemon) => (
                                                    <div
                                                        key={pokemon.wild_id}
                                                        onClick={() => handlePokemonSelect(pokemon)}
                                                        style={{
                                                            padding: '10px',
                                                            cursor: 'pointer',
                                                            borderBottom: '1px solid #eee',
                                                            backgroundColor: newPokemonToPoint.pokemon_wild_id === pokemon.wild_id ? '#e3f2fd' : 'white'
                                                        }}
                                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                        onMouseLeave={(e) => e.target.style.backgroundColor = newPokemonToPoint.pokemon_wild_id === pokemon.wild_id ? '#e3f2fd' : 'white'}
                                                    >
                                                        <strong>{pokemon.naam}</strong> (ID: {pokemon.wild_id})
                                                        {pokemon.type1 && <span className="ms-2">({pokemon.type1}{pokemon.type2 ? ` / ${pokemon.type2}` : ''})</span>}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Spawn Rate (1-100)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={newPokemonToPoint.spawn_rate}
                                            onChange={(e) => setNewPokemonToPoint({ ...newPokemonToPoint, spawn_rate: parseInt(e.target.value) || 100 })}
                                            min="1"
                                            max="100"
                                        />
                                        <Form.Text className="text-muted">Higher number = more common spawn</Form.Text>
                                    </Form.Group>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Min Level</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={newPokemonToPoint.min_level}
                                                    onChange={(e) => setNewPokemonToPoint({ ...newPokemonToPoint, min_level: parseInt(e.target.value) || 1 })}
                                                    min="1"
                                                    max="100"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Max Level</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={newPokemonToPoint.max_level}
                                                    onChange={(e) => setNewPokemonToPoint({ ...newPokemonToPoint, max_level: parseInt(e.target.value) || 100 })}
                                                    min="1"
                                                    max="100"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Form>
                            ) : (
                                <div>
                                    <div className="mb-3">
                                        <Form.Label>Import from CSV/Excel</Form.Label>
                                        <Form.Control
                                            type="file"
                                            accept=".csv,.xlsx,.xls"
                                            onChange={handleCsvUpload}
                                        />
                                        <Form.Text className="text-muted">
                                            CSV format: Pokemon, Spawn Rate, Min Level, Max Level (or: Pokemon Name/ID, Rate, Min, Max)
                                        </Form.Text>
                                    </div>
                                    
                                    <div className="mb-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h6>Pokemon List</h6>
                                            <Button variant="success" size="sm" onClick={addBulkPokemonRow}>
                                                + Add Row
                                            </Button>
                                        </div>
                                        <Table striped bordered hover size="sm">
                                            <thead>
                                                <tr>
                                                    <th>Pokemon *</th>
                                                    <th>Spawn Rate</th>
                                                    <th>Min Level</th>
                                                    <th>Max Level</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bulkPokemonList.map((pokemon, index) => (
                                                    <tr key={index}>
                                                        <td style={{ position: 'relative', minWidth: '250px' }}>
                                                            <Form.Control
                                                                type="text"
                                                                value={pokemon.search || ''}
                                                                onChange={(e) => handlePokemonSearchChange(e.target.value, index)}
                                                                placeholder="Search Pokemon..."
                                                                size="sm"
                                                            />
                                                            {showPokemonSearch && pokemonSearchResults.length > 0 && activeSearchIndex === index && (
                                                                <div style={{
                                                                    position: 'absolute',
                                                                    top: '100%',
                                                                    left: 0,
                                                                    right: 0,
                                                                    zIndex: 1000,
                                                                    backgroundColor: 'white',
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '4px',
                                                                    maxHeight: '200px',
                                                                    overflowY: 'auto',
                                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                                                }}>
                                                                    {pokemonSearchResults.map((p) => (
                                                                        <div
                                                                            key={p.wild_id}
                                                                            onClick={() => handlePokemonSelect(p, index)}
                                                                            style={{
                                                                                padding: '8px',
                                                                                cursor: 'pointer',
                                                                                borderBottom: '1px solid #eee',
                                                                                backgroundColor: pokemon.pokemon_wild_id === p.wild_id ? '#e3f2fd' : 'white'
                                                                            }}
                                                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                                            onMouseLeave={(e) => e.target.style.backgroundColor = pokemon.pokemon_wild_id === p.wild_id ? '#e3f2fd' : 'white'}
                                                                        >
                                                                            <strong>{p.naam}</strong> (ID: {p.wild_id})
                                                                            {p.type1 && <span className="ms-2">({p.type1}{p.type2 ? ` / ${p.type2}` : ''})</span>}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                value={pokemon.spawn_rate}
                                                                onChange={(e) => {
                                                                    const updated = [...bulkPokemonList];
                                                                    updated[index].spawn_rate = parseInt(e.target.value) || 100;
                                                                    setBulkPokemonList(updated);
                                                                }}
                                                                min="1"
                                                                max="100"
                                                                size="sm"
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                value={pokemon.min_level}
                                                                onChange={(e) => {
                                                                    const updated = [...bulkPokemonList];
                                                                    updated[index].min_level = parseInt(e.target.value) || 1;
                                                                    setBulkPokemonList(updated);
                                                                }}
                                                                min="1"
                                                                max="100"
                                                                size="sm"
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                value={pokemon.max_level}
                                                                onChange={(e) => {
                                                                    const updated = [...bulkPokemonList];
                                                                    updated[index].max_level = parseInt(e.target.value) || 100;
                                                                    setBulkPokemonList(updated);
                                                                }}
                                                                min="1"
                                                                max="100"
                                                                size="sm"
                                                            />
                                                        </td>
                                                        <td>
                                                            <Button 
                                                                variant="danger" 
                                                                size="sm" 
                                                                onClick={() => removeBulkPokemonRow(index)}
                                                                disabled={bulkPokemonList.length === 1}
                                                            >
                                                                Remove
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                        setShowPokemonModal(false);
                        setNewPokemonToPoint({ pokemon_wild_id: null, spawn_rate: 100, min_level: 1, max_level: 100 });
                        setBulkImportMode(false);
                        setHtmlImportMode(false);
                        setHtmlInput('');
                        setBulkPokemonList([{ pokemon_wild_id: null, spawn_rate: 100, min_level: 1, max_level: 100, search: '' }]);
                        setPokemonSearchInput('');
                        setShowPokemonSearch(false);
                    }}>
                        Cancel
                    </Button>
                    {htmlImportMode ? (
                        <Button variant="primary" onClick={handleHtmlImport} disabled={!htmlInput.trim()}>
                            Parse HTML and Add to Pokemon List
                        </Button>
                    ) : !bulkImportMode ? (
                        <Button variant="primary" onClick={handleAddPokemonToPoint} disabled={wildPokemonLoading || !newPokemonToPoint.pokemon_wild_id}>
                            {editingPokemonId ? 'Update Pokemon' : 'Add Pokemon'}
                        </Button>
                    ) : (
                        <Button variant="primary" onClick={handleBulkAddPokemon} disabled={wildPokemonLoading || bulkPokemonList.filter(p => p.pokemon_wild_id).length === 0}>
                            Add All Pokemon ({bulkPokemonList.filter(p => p.pokemon_wild_id).length})
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
            
            {/* Trainer Modal */}
            <Modal show={showTrainerModal} onHide={() => {
                setShowTrainerModal(false);
                setEditingTrainer(null);
                setNewTrainer({
                    trainer_name: '',
                    trainer_image: '',
                    silver_cost: 100,
                    level_range_min: 1,
                    level_range_max: 100,
                    is_active: 1
                });
            }} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{editingTrainer ? 'Edit Trainer' : 'Create New Trainer'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={editingTrainer ? handleUpdateTrainer : handleCreateTrainer}>
                        <Form.Group className="mb-3">
                            <Form.Label>Trainer Name *</Form.Label>
                            <Form.Control
                                type="text"
                                value={editingTrainer ? editingTrainer.trainer_name : newTrainer.trainer_name}
                                onChange={(e) => editingTrainer ? setEditingTrainer({...editingTrainer, trainer_name: e.target.value}) : setNewTrainer({...newTrainer, trainer_name: e.target.value})}
                                placeholder="e.g. Ash Ketchum"
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Trainer Image Path *</Form.Label>
                            <Form.Control
                                type="text"
                                value={editingTrainer ? editingTrainer.trainer_image : newTrainer.trainer_image}
                                onChange={(e) => editingTrainer ? setEditingTrainer({...editingTrainer, trainer_image: e.target.value}) : setNewTrainer({...newTrainer, trainer_image: e.target.value})}
                                placeholder="e.g. trainer1.png (from /api/assets/images/attack/)"
                                required
                            />
                            <Form.Text className="text-muted">
                                Image should be in /api/assets/images/attack/ directory
                            </Form.Text>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Silver Cost *</Form.Label>
                            <Form.Control
                                type="number"
                                value={editingTrainer ? editingTrainer.silver_cost : newTrainer.silver_cost}
                                onChange={(e) => editingTrainer ? setEditingTrainer({...editingTrainer, silver_cost: parseInt(e.target.value) || 100}) : setNewTrainer({...newTrainer, silver_cost: parseInt(e.target.value) || 100})}
                                min="0"
                                required
                            />
                        </Form.Group>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Min Level *</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={editingTrainer ? editingTrainer.level_range_min : newTrainer.level_range_min}
                                        onChange={(e) => editingTrainer ? setEditingTrainer({...editingTrainer, level_range_min: parseInt(e.target.value) || 1}) : setNewTrainer({...newTrainer, level_range_min: parseInt(e.target.value) || 1})}
                                        min="1"
                                        max="100"
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Max Level *</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={editingTrainer ? editingTrainer.level_range_max : newTrainer.level_range_max}
                                        onChange={(e) => editingTrainer ? setEditingTrainer({...editingTrainer, level_range_max: parseInt(e.target.value) || 100}) : setNewTrainer({...newTrainer, level_range_max: parseInt(e.target.value) || 100})}
                                        min="1"
                                        max="100"
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-3">
                            <Form.Check
                                type="checkbox"
                                label="Active"
                                checked={editingTrainer ? editingTrainer.is_active : newTrainer.is_active}
                                onChange={(e) => editingTrainer ? setEditingTrainer({...editingTrainer, is_active: e.target.checked ? 1 : 0}) : setNewTrainer({...newTrainer, is_active: e.target.checked ? 1 : 0})}
                            />
                        </Form.Group>
                        {!editingTrainer && (
                            <Alert variant="info">
                                <strong>Note:</strong> You can add Pokemon and Rewards after creating the trainer.
                            </Alert>
                        )}
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => {
                                setShowTrainerModal(false);
                                setEditingTrainer(null);
                            }}>
                                Cancel
                            </Button>
                            <Button variant="primary" type="submit">
                                {editingTrainer ? 'Update Trainer' : 'Create Trainer'}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>
            </Modal>
            
            {/* Trainer Pokemon Modal */}
            <Modal show={showTrainerPokemonModal} onHide={() => {
                setShowTrainerPokemonModal(false);
                setNewTrainerPokemon({
                    wild_id: null,
                    slot_position: 1,
                    level_min: 5,
                    level_max: 100
                });
                setPokemonSearchInput('');
                setShowPokemonSearch(false);
            }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Pokemon to {selectedTrainer?.trainer_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" style={{ position: 'relative' }}>
                        <Form.Label>Pokemon *</Form.Label>
                        <Form.Control
                            type="text"
                            value={pokemonSearchInput || (newTrainerPokemon.wild_id ? allWildPokemon.find(p => p.wild_id === newTrainerPokemon.wild_id)?.naam || '' : '')}
                            onChange={(e) => handlePokemonSearchChange(e.target.value)}
                            placeholder="Search Pokemon..."
                            required
                        />
                        {showPokemonSearch && pokemonSearchResults.length > 0 && (
                            <div style={{
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                right: 0,
                                zIndex: 1000,
                                backgroundColor: 'white',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                maxHeight: '300px',
                                overflowY: 'auto',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                            }}>
                                {pokemonSearchResults.map((pokemon) => (
                                    <div
                                        key={pokemon.wild_id}
                                        onClick={() => {
                                            setNewTrainerPokemon({...newTrainerPokemon, wild_id: pokemon.wild_id});
                                            setPokemonSearchInput('');
                                            setShowPokemonSearch(false);
                                        }}
                                        style={{
                                            padding: '10px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #eee',
                                            backgroundColor: newTrainerPokemon.wild_id === pokemon.wild_id ? '#e3f2fd' : 'white'
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = newTrainerPokemon.wild_id === pokemon.wild_id ? '#e3f2fd' : 'white'}
                                    >
                                        <strong>{pokemon.naam}</strong> (ID: {pokemon.wild_id})
                                    </div>
                                ))}
                            </div>
                        )}
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Slot Position (1-6) *</Form.Label>
                        <Form.Control
                            type="number"
                            value={newTrainerPokemon.slot_position}
                            onChange={(e) => setNewTrainerPokemon({...newTrainerPokemon, slot_position: parseInt(e.target.value) || 1})}
                            min="1"
                            max="6"
                            required
                        />
                    </Form.Group>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Min Level *</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={newTrainerPokemon.level_min}
                                    onChange={(e) => setNewTrainerPokemon({...newTrainerPokemon, level_min: parseInt(e.target.value) || 5})}
                                    min="1"
                                    max="100"
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Max Level *</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={newTrainerPokemon.level_max}
                                    onChange={(e) => setNewTrainerPokemon({...newTrainerPokemon, level_max: parseInt(e.target.value) || 100})}
                                    min="1"
                                    max="100"
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowTrainerPokemonModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleAddTrainerPokemon} disabled={!newTrainerPokemon.wild_id}>
                            Add Pokemon
                        </Button>
                    </Modal.Footer>
                </Modal.Body>
            </Modal>
            
            {/* Trainer Reward Modal */}
            <Modal show={showTrainerRewardModal} onHide={() => {
                setShowTrainerRewardModal(false);
                setNewTrainerReward({
                    reward_type: 'item',
                    reward_value: '',
                    reward_quantity: 1,
                    reward_name: '',
                    chance_percentage: 2.0
                });
            }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Reward to {selectedTrainer?.trainer_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Reward Type *</Form.Label>
                        <Form.Select
                            value={newTrainerReward.reward_type}
                            onChange={(e) => setNewTrainerReward({...newTrainerReward, reward_type: e.target.value})}
                        >
                            <option value="item">Item</option>
                            <option value="silver">Silver</option>
                            <option value="gold">Gold</option>
                            <option value="pokemon">Pokemon</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Reward Name *</Form.Label>
                        <Form.Control
                            type="text"
                            value={newTrainerReward.reward_name}
                            onChange={(e) => setNewTrainerReward({...newTrainerReward, reward_name: e.target.value})}
                            placeholder="e.g. Master Ball"
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Reward Value *</Form.Label>
                        <Form.Control
                            type="text"
                            value={newTrainerReward.reward_value}
                            onChange={(e) => setNewTrainerReward({...newTrainerReward, reward_value: e.target.value})}
                            placeholder={newTrainerReward.reward_type === 'item' ? 'Item name' : newTrainerReward.reward_type === 'pokemon' ? 'Pokemon ID' : 'Amount'}
                            required
                        />
                        <Form.Text className="text-muted">
                            {newTrainerReward.reward_type === 'item' && 'Item name (e.g. Masterball)'}
                            {newTrainerReward.reward_type === 'silver' && 'Amount of silver'}
                            {newTrainerReward.reward_type === 'gold' && 'Amount of gold'}
                            {newTrainerReward.reward_type === 'pokemon' && 'Pokemon wild_id'}
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Quantity</Form.Label>
                        <Form.Control
                            type="number"
                            value={newTrainerReward.reward_quantity}
                            onChange={(e) => setNewTrainerReward({...newTrainerReward, reward_quantity: parseInt(e.target.value) || 1})}
                            min="1"
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Chance Percentage (%)</Form.Label>
                        <Form.Control
                            type="number"
                            value={newTrainerReward.chance_percentage}
                            onChange={(e) => setNewTrainerReward({...newTrainerReward, chance_percentage: parseFloat(e.target.value) || 2.0})}
                            min="0"
                            max="100"
                            step="0.1"
                        />
                        <Form.Text className="text-muted">
                            Default is 2% (recommended)
                        </Form.Text>
                    </Form.Group>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowTrainerRewardModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleAddTrainerReward} disabled={!newTrainerReward.reward_value || !newTrainerReward.reward_name}>
                            Add Reward
                        </Button>
                    </Modal.Footer>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default Admin;
